
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb86"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb86"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eF5U7", function(module, exports) {
module.exports = import("hX9Ss").then(()=>parcelRequire('3MFDc'));

});

parcelRegister("d5uQM", function(module, exports) {
module.exports = Promise.all([
    import("bhVHy"),
    import("fvAFR")
]).then(()=>parcelRequire('4Eldx'));

});

parcelRegister("jXyqT", function(module, exports) {
module.exports = Promise.all([
    import("bhVHy"),
    import("cGFct")
]).then(()=>parcelRequire('ca2jq'));

});

/*! @license DOMPurify 3.4.13 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.13/LICENSE */ function $d0d31c26942b471d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d0d31c26942b471d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $d0d31c26942b471d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d0d31c26942b471d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0d31c26942b471d$var$_slicedToArray(r, e) {
    return $d0d31c26942b471d$var$_arrayWithHoles(r) || $d0d31c26942b471d$var$_iterableToArrayLimit(r, e) || $d0d31c26942b471d$var$_unsupportedIterableToArray(r, e) || $d0d31c26942b471d$var$_nonIterableRest();
}
function $d0d31c26942b471d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d0d31c26942b471d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d0d31c26942b471d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
const $d0d31c26942b471d$var$entries = Object.entries, $d0d31c26942b471d$var$setPrototypeOf = Object.setPrototypeOf, $d0d31c26942b471d$var$isFrozen = Object.isFrozen, $d0d31c26942b471d$var$getPrototypeOf = Object.getPrototypeOf, $d0d31c26942b471d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let $d0d31c26942b471d$var$freeze = Object.freeze, $d0d31c26942b471d$var$seal = Object.seal, $d0d31c26942b471d$var$create = Object.create; // eslint-disable-line import/no-mutable-exports
let $d0d31c26942b471d$var$_ref = typeof Reflect !== 'undefined' && Reflect, $d0d31c26942b471d$var$apply = $d0d31c26942b471d$var$_ref.apply, $d0d31c26942b471d$var$construct = $d0d31c26942b471d$var$_ref.construct;
if (!$d0d31c26942b471d$var$freeze) $d0d31c26942b471d$var$freeze = function freeze(x) {
    return x;
};
if (!$d0d31c26942b471d$var$seal) $d0d31c26942b471d$var$seal = function seal(x) {
    return x;
};
if (!$d0d31c26942b471d$var$apply) $d0d31c26942b471d$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$d0d31c26942b471d$var$construct) $d0d31c26942b471d$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $d0d31c26942b471d$var$arrayForEach = $d0d31c26942b471d$var$unapply(Array.prototype.forEach);
const $d0d31c26942b471d$var$arrayLastIndexOf = $d0d31c26942b471d$var$unapply(Array.prototype.lastIndexOf);
const $d0d31c26942b471d$var$arrayPop = $d0d31c26942b471d$var$unapply(Array.prototype.pop);
const $d0d31c26942b471d$var$arrayPush = $d0d31c26942b471d$var$unapply(Array.prototype.push);
const $d0d31c26942b471d$var$arraySplice = $d0d31c26942b471d$var$unapply(Array.prototype.splice);
const $d0d31c26942b471d$var$arrayIsArray = Array.isArray;
const $d0d31c26942b471d$var$stringToLowerCase = $d0d31c26942b471d$var$unapply(String.prototype.toLowerCase);
const $d0d31c26942b471d$var$stringToString = $d0d31c26942b471d$var$unapply(String.prototype.toString);
const $d0d31c26942b471d$var$stringMatch = $d0d31c26942b471d$var$unapply(String.prototype.match);
const $d0d31c26942b471d$var$stringReplace = $d0d31c26942b471d$var$unapply(String.prototype.replace);
const $d0d31c26942b471d$var$stringIndexOf = $d0d31c26942b471d$var$unapply(String.prototype.indexOf);
const $d0d31c26942b471d$var$stringTrim = $d0d31c26942b471d$var$unapply(String.prototype.trim);
const $d0d31c26942b471d$var$numberToString = $d0d31c26942b471d$var$unapply(Number.prototype.toString);
const $d0d31c26942b471d$var$booleanToString = $d0d31c26942b471d$var$unapply(Boolean.prototype.toString);
const $d0d31c26942b471d$var$bigintToString = typeof BigInt === 'undefined' ? null : $d0d31c26942b471d$var$unapply(BigInt.prototype.toString);
const $d0d31c26942b471d$var$symbolToString = typeof Symbol === 'undefined' ? null : $d0d31c26942b471d$var$unapply(Symbol.prototype.toString);
const $d0d31c26942b471d$var$objectHasOwnProperty = $d0d31c26942b471d$var$unapply(Object.prototype.hasOwnProperty);
const $d0d31c26942b471d$var$objectToString = $d0d31c26942b471d$var$unapply(Object.prototype.toString);
const $d0d31c26942b471d$var$regExpTest = $d0d31c26942b471d$var$unapply(RegExp.prototype.test);
const $d0d31c26942b471d$var$typeErrorCreate = $d0d31c26942b471d$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $d0d31c26942b471d$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $d0d31c26942b471d$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $d0d31c26942b471d$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $d0d31c26942b471d$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $d0d31c26942b471d$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $d0d31c26942b471d$var$stringToLowerCase;
    if ($d0d31c26942b471d$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $d0d31c26942b471d$var$setPrototypeOf(set, null);
    if (!$d0d31c26942b471d$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$d0d31c26942b471d$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $d0d31c26942b471d$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $d0d31c26942b471d$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $d0d31c26942b471d$var$clone(object) {
    const newObject = $d0d31c26942b471d$var$create(null);
    for (const _ref2 of $d0d31c26942b471d$var$entries(object)){
        var _ref3 = $d0d31c26942b471d$var$_slicedToArray(_ref2, 2);
        const property = _ref3[0];
        const value = _ref3[1];
        const isPropertyExist = $d0d31c26942b471d$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if ($d0d31c26942b471d$var$arrayIsArray(value)) newObject[property] = $d0d31c26942b471d$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $d0d31c26942b471d$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */ function $d0d31c26942b471d$var$stringifyValue(value) {
    switch(typeof value){
        case 'string':
            return value;
        case 'number':
            return $d0d31c26942b471d$var$numberToString(value);
        case 'boolean':
            return $d0d31c26942b471d$var$booleanToString(value);
        case 'bigint':
            return $d0d31c26942b471d$var$bigintToString ? $d0d31c26942b471d$var$bigintToString(value) : '0';
        case 'symbol':
            return $d0d31c26942b471d$var$symbolToString ? $d0d31c26942b471d$var$symbolToString(value) : 'Symbol()';
        case 'undefined':
            return $d0d31c26942b471d$var$objectToString(value);
        case 'function':
        case 'object':
            {
                if (value === null) return $d0d31c26942b471d$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $d0d31c26942b471d$var$lookupGetter(valueAsRecord, 'toString');
                if (typeof valueToString === 'function') {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === 'string' ? stringified : $d0d31c26942b471d$var$objectToString(stringified);
                }
                return $d0d31c26942b471d$var$objectToString(value);
            }
        default:
            return $d0d31c26942b471d$var$objectToString(value);
    }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $d0d31c26942b471d$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $d0d31c26942b471d$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $d0d31c26942b471d$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $d0d31c26942b471d$var$unapply(desc.value);
        }
        object = $d0d31c26942b471d$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
function $d0d31c26942b471d$var$isRegex(value) {
    try {
        $d0d31c26942b471d$var$regExpTest(value, '');
        return true;
    } catch (_unused) {
        return false;
    }
}
const $d0d31c26942b471d$var$html$1 = $d0d31c26942b471d$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $d0d31c26942b471d$var$svg$1 = $d0d31c26942b471d$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $d0d31c26942b471d$var$svgFilters = $d0d31c26942b471d$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $d0d31c26942b471d$var$svgDisallowed = $d0d31c26942b471d$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $d0d31c26942b471d$var$mathMl$1 = $d0d31c26942b471d$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $d0d31c26942b471d$var$mathMlDisallowed = $d0d31c26942b471d$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $d0d31c26942b471d$var$text = $d0d31c26942b471d$var$freeze([
    '#text'
]);
const $d0d31c26942b471d$var$html = $d0d31c26942b471d$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'command',
    'commandfor',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns'
]);
const $d0d31c26942b471d$var$svg = $d0d31c26942b471d$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dominant-baseline',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-orientation',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $d0d31c26942b471d$var$mathMl = $d0d31c26942b471d$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $d0d31c26942b471d$var$xml = $d0d31c26942b471d$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
const $d0d31c26942b471d$var$MUSTACHE_EXPR = $d0d31c26942b471d$var$seal(/{{[\w\W]*|^[\w\W]*}}/g);
const $d0d31c26942b471d$var$ERB_EXPR = $d0d31c26942b471d$var$seal(/<%[\w\W]*|^[\w\W]*%>/g);
const $d0d31c26942b471d$var$TMPLIT_EXPR = $d0d31c26942b471d$var$seal(/\${[\w\W]*/g);
const $d0d31c26942b471d$var$DATA_ATTR = $d0d31c26942b471d$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $d0d31c26942b471d$var$ARIA_ATTR = $d0d31c26942b471d$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $d0d31c26942b471d$var$IS_ALLOWED_URI = $d0d31c26942b471d$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $d0d31c26942b471d$var$IS_SCRIPT_OR_DATA = $d0d31c26942b471d$var$seal(/^(?:\w+script|data):/i);
const $d0d31c26942b471d$var$ATTR_WHITESPACE = $d0d31c26942b471d$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $d0d31c26942b471d$var$DOCTYPE_NAME = $d0d31c26942b471d$var$seal(/^html$/i);
const $d0d31c26942b471d$var$CUSTOM_ELEMENT = $d0d31c26942b471d$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
// Markup-significant character probes used by _sanitizeElements.
// Shared module-level instances are safe despite the sticky /g flags:
// unapply() resets lastIndex for RegExp receivers before every call.
const $d0d31c26942b471d$var$ELEMENT_MARKUP_PROBE = $d0d31c26942b471d$var$seal(/<[/\w!]/g);
const $d0d31c26942b471d$var$COMMENT_MARKUP_PROBE = $d0d31c26942b471d$var$seal(/<[/\w]/g);
const $d0d31c26942b471d$var$FALLBACK_TAG_CLOSE = $d0d31c26942b471d$var$seal(/<\/no(script|embed|frames)/i);
const $d0d31c26942b471d$var$SELF_CLOSING_TAG = $d0d31c26942b471d$var$seal(/\/>/i);
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $d0d31c26942b471d$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
const $d0d31c26942b471d$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $d0d31c26942b471d$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $d0d31c26942b471d$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
/**
 * Resolve a set-valued configuration option: a fresh set built from
 * cfg[key] when it is an own array property (seeded with a clone of
 * options.base when given, case-normalized via options.transform),
 * the fallback set otherwise.
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param fallback the set to use when the option is absent or not an array
 * @param options transform and optional base set to merge into
 * @returns the resolved set
 */ const $d0d31c26942b471d$var$_resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
    return $d0d31c26942b471d$var$objectHasOwnProperty(cfg, key) && $d0d31c26942b471d$var$arrayIsArray(cfg[key]) ? $d0d31c26942b471d$var$addToSet(options.base ? $d0d31c26942b471d$var$clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
function $d0d31c26942b471d$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d0d31c26942b471d$var$getGlobal();
    const DOMPurify = (root)=>$d0d31c26942b471d$var$createDOMPurify(root);
    DOMPurify.version = '3.4.13';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $d0d31c26942b471d$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let document = window1.document;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    window1.DocumentFragment;
    const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
    _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
    window1.HTMLFormElement;
    const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'parentNode');
    const getShadowRoot = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'shadowRoot');
    const getAttributes = $d0d31c26942b471d$var$lookupGetter(ElementPrototype, 'attributes');
    const getNodeType = Node && Node.prototype ? $d0d31c26942b471d$var$lookupGetter(Node.prototype, 'nodeType') : null;
    const getNodeName = Node && Node.prototype ? $d0d31c26942b471d$var$lookupGetter(Node.prototype, 'nodeName') : null;
    const getOwnerDocument = Node && Node.prototype ? $d0d31c26942b471d$var$lookupGetter(Node.prototype, 'ownerDocument') : null;
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    // The instance's own internal Trusted Types policy. Unlike a caller-supplied
    // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
    // on duplicate policy names — and is the only policy allowed to persist
    // across configurations and survive `clearConfig()`.
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    // Tracks whether we are already inside a call to the configured Trusted Types
    // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
    // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
    // re-enter the policy and recurse until the stack overflows. We detect that
    // re-entry and throw a clear, actionable error instead. The guard is shared
    // across both callbacks, because either one re-entering `sanitize` triggers
    // the same unbounded recursion.
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
        if (IN_TRUSTED_TYPES_POLICY > 0) throw $d0d31c26942b471d$var$typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    };
    const _createTrustedHTML = function _createTrustedHTML(html) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createHTML(html);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createScriptURL(scriptUrl);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    // Lazily resolve (and cache) the instance's internal default policy.
    // Resolution is attempted at most once: a successful `createPolicy` cannot be
    // repeated (Trusted Types throws on duplicate names), and a failed or
    // unsupported attempt must not be retried on every parse.
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
        if (!defaultTrustedTypesPolicyResolved) {
            defaultTrustedTypesPolicy = $d0d31c26942b471d$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            defaultTrustedTypesPolicyResolved = true;
        }
        return defaultTrustedTypesPolicy;
    };
    const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = $d0d31c26942b471d$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $d0d31c26942b471d$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const MUSTACHE_EXPR$1 = $d0d31c26942b471d$var$MUSTACHE_EXPR, ERB_EXPR$1 = $d0d31c26942b471d$var$ERB_EXPR, TMPLIT_EXPR$1 = $d0d31c26942b471d$var$TMPLIT_EXPR, DATA_ATTR$1 = $d0d31c26942b471d$var$DATA_ATTR, ARIA_ATTR$1 = $d0d31c26942b471d$var$ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = $d0d31c26942b471d$var$IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = $d0d31c26942b471d$var$ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = $d0d31c26942b471d$var$CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = $d0d31c26942b471d$var$IS_ALLOWED_URI;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $d0d31c26942b471d$var$addToSet({}, [
        ...$d0d31c26942b471d$var$html$1,
        ...$d0d31c26942b471d$var$svg$1,
        ...$d0d31c26942b471d$var$svgFilters,
        ...$d0d31c26942b471d$var$mathMl$1,
        ...$d0d31c26942b471d$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $d0d31c26942b471d$var$addToSet({}, [
        ...$d0d31c26942b471d$var$html,
        ...$d0d31c26942b471d$var$svg,
        ...$d0d31c26942b471d$var$mathMl,
        ...$d0d31c26942b471d$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($d0d31c26942b471d$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($d0d31c26942b471d$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Pristine allowlist bindings captured at setConfig() time. On the
   * persistent-config path sanitize() restores the sets from these before
   * the per-walk hook clone-guard, so a hook's in-call widening cannot
   * carry across calls. Null until setConfig() is called; reset by
   * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $d0d31c26942b471d$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
        // the UA (customizable <select>) — including any on* handlers — and the
        // engine re-mirrors synchronously whenever a removal changes which
        // option/selectedcontent is current, even inside DOMPurify's inert
        // DOMParser document. Hoisting its children on removal re-inserts a fresh
        // mirror target ahead of the walk, which the engine refills, looping
        // forever (DoS) and amplifying output. Dropping its content on removal
        // (rather than hoisting) breaks that cascade; the content is a duplicate
        // of the option, which is sanitized on its own. See campaign-3 F1/F6.
        'selectedcontent',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $d0d31c26942b471d$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $d0d31c26942b471d$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $d0d31c26942b471d$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $d0d31c26942b471d$var$stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = $d0d31c26942b471d$var$freeze([
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = $d0d31c26942b471d$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = $d0d31c26942b471d$var$freeze([
        'annotation-xml'
    ]);
    let HTML_INTEGRATION_POINTS = $d0d31c26942b471d$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $d0d31c26942b471d$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $d0d31c26942b471d$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $d0d31c26942b471d$var$stringToString : $d0d31c26942b471d$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
            transform: transformCaseFunc
        });
        ALLOWED_ATTR = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
            transform: transformCaseFunc
        });
        ALLOWED_NAMESPACES = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
            transform: $d0d31c26942b471d$var$stringToString
        });
        URI_SAFE_ATTRIBUTES = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
            transform: transformCaseFunc,
            base: DEFAULT_URI_SAFE_ATTRIBUTES
        });
        DATA_URI_TAGS = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
            transform: transformCaseFunc,
            base: DEFAULT_DATA_URI_TAGS
        });
        FORBID_CONTENTS = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
            transform: transformCaseFunc
        });
        FORBID_TAGS = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'FORBID_TAGS', $d0d31c26942b471d$var$clone({}), {
            transform: transformCaseFunc
        });
        FORBID_ATTR = $d0d31c26942b471d$var$_resolveSetOption(cfg, 'FORBID_ATTR', $d0d31c26942b471d$var$clone({}), {
            transform: transformCaseFunc
        });
        USE_PROFILES = $d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? $d0d31c26942b471d$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = $d0d31c26942b471d$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $d0d31c26942b471d$var$IS_ALLOWED_URI; // Default regexp
        NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
        MATHML_TEXT_INTEGRATION_POINTS = $d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? $d0d31c26942b471d$var$clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : $d0d31c26942b471d$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS); // Default built-in map
        HTML_INTEGRATION_POINTS = $d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? $d0d31c26942b471d$var$clone(cfg.HTML_INTEGRATION_POINTS) : $d0d31c26942b471d$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS); // Default built-in map
        const customElementHandling = $d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? $d0d31c26942b471d$var$clone(cfg.CUSTOM_ELEMENT_HANDLING) : $d0d31c26942b471d$var$create(null);
        CUSTOM_ELEMENT_HANDLING = $d0d31c26942b471d$var$create(null);
        if ($d0d31c26942b471d$var$objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
        if ($d0d31c26942b471d$var$objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
        if ($d0d31c26942b471d$var$objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
        $d0d31c26942b471d$var$seal(CUSTOM_ELEMENT_HANDLING);
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $d0d31c26942b471d$var$addToSet({}, $d0d31c26942b471d$var$text);
            ALLOWED_ATTR = $d0d31c26942b471d$var$create(null);
            if (USE_PROFILES.html === true) {
                $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, $d0d31c26942b471d$var$html$1);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, $d0d31c26942b471d$var$svg$1);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$svg);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, $d0d31c26942b471d$var$svgFilters);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$svg);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, $d0d31c26942b471d$var$mathMl$1);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$mathMl);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, $d0d31c26942b471d$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if ($d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'ADD_TAGS')) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($d0d31c26942b471d$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $d0d31c26942b471d$var$clone(ALLOWED_TAGS);
                $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'ADD_ATTR')) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($d0d31c26942b471d$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $d0d31c26942b471d$var$clone(ALLOWED_ATTR);
                $d0d31c26942b471d$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && $d0d31c26942b471d$var$arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) $d0d31c26942b471d$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if ($d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && $d0d31c26942b471d$var$arrayIsArray(cfg.FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $d0d31c26942b471d$var$clone(FORBID_CONTENTS);
            $d0d31c26942b471d$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if ($d0d31c26942b471d$var$objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && $d0d31c26942b471d$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $d0d31c26942b471d$var$clone(FORBID_CONTENTS);
            $d0d31c26942b471d$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $d0d31c26942b471d$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        // Re-derive the active Trusted Types policy from this configuration on
        // every parse. The active policy must never be sticky closure state that
        // outlives the config that set it: a caller-supplied policy left in place
        // after `clearConfig()` — or after a later call that supplied none, or
        // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
        // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
        // See GHSA-vxr8-fq34-vvx9.
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $d0d31c26942b471d$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $d0d31c26942b471d$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // A caller-supplied policy applies to this configuration only.
            const previousTrustedTypesPolicy = trustedTypesPolicy;
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`. If the supplied policy's
            // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
            // throws via the re-entrancy guard. Restore the previous policy first so
            // the instance is not left in a poisoned state. See #1422.
            try {
                emptyHTML = _createTrustedHTML('');
            } catch (error) {
                trustedTypesPolicy = previousTrustedTypesPolicy;
                throw error;
            }
        } else if (cfg.TRUSTED_TYPES_POLICY === null) {
            // Explicit opt-out for this call: perform no Trusted Types signing and
            // create nothing (so a strict `trusted-types` CSP that disallows a
            // `dompurify` policy can still call `sanitize` from inside its own
            // policy — see #1422). Resetting to `undefined` rather than a sticky
            // `null` also drops any previously retained caller policy, so it cannot
            // resurface on a later call, while still allowing the next config-less
            // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = undefined;
            emptyHTML = '';
        } else {
            // No policy supplied: keep the currently active policy if one is set — a
            // previously supplied policy is intentionally sticky across config-less
            // calls — otherwise fall back to the instance's own internal policy,
            // created at most once. (A policy supplied for a *single* call still
            // lingers by design; what must not linger is a policy whose configuration
            // has been torn down via `clearConfig()`, which restores the default.)
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
            // Sign internal variables only when a policy is active. A falsy policy
            // (Trusted Types unsupported, creation failed, or an explicit opt-out)
            // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
            // a non-policy and throw. See #1422.
            if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($d0d31c26942b471d$var$freeze) $d0d31c26942b471d$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $d0d31c26942b471d$var$addToSet({}, [
        ...$d0d31c26942b471d$var$svg$1,
        ...$d0d31c26942b471d$var$svgFilters,
        ...$d0d31c26942b471d$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $d0d31c26942b471d$var$addToSet({}, [
        ...$d0d31c26942b471d$var$mathMl$1,
        ...$d0d31c26942b471d$var$mathMlDisallowed
    ]);
    /**
   * Namespace rules for an element in the SVG namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
        // The only way to switch from MathML to SVG is via <svg>
        // if the parent is either <annotation-xml> or a MathML
        // text integration point.
        if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the MathML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the HTML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $d0d31c26942b471d$var$stringToLowerCase(element.tagName);
        const parentTagName = $d0d31c26942b471d$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $d0d31c26942b471d$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            /* The normal detach failed — this is reached for a parentless node
         (getParentNode() is null, so .removeChild throws). Element.prototype
         .remove() is itself a spec no-op on a parentless node, so a recorded
         "removal" would otherwise hand the caller back an intact,
         payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
         the style-with-element-child rule decided to kill). Fail closed by
         throwing — exactly as a clobbered root does at the IN_PLACE entry —
         rather than trying to "neutralize" the node via its own methods.
         Neutralizing would mean calling getAttributeNames()/removeAttribute()
         on the node, both of which a <form> root can clobber via a named child
         (and _isClobbered does not even probe getAttributeNames), so the
         neutralize step could itself be silently defeated, leaving the payload
         intact. A throw touches only the cached, clobber-safe remove() and
         getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
         to every root-kill reason. REPORT-3.
                This lives inside the catch, so it never fires for a normally-removed
         in-tree node: those have a parent, removeChild() succeeds, and the
         catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
            if (!getParentNode(node)) throw $d0d31c26942b471d$var$typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
        }
    };
    /**
   * _neutralizeRoot
   *
   * Fail-closed teardown of an in-place root after the sanitize walk aborts
   * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
   * custom element's reaction detaches a node so `_forceRemove`'s deliberate
   * parentless guard throws, or any other re-entrant engine mutation — would
   * otherwise leave the caller's *live* tree half-sanitized, with everything
   * after the abort point still carrying its handlers. There is no safe way
   * to resume the walk (the tree mutated under us), so we strip the root bare:
   * remove every child and every attribute, then let the caller's catch see
   * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
   * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
   *
   * @param root the in-place root to empty
   */ const _neutralizeRoot = function _neutralizeRoot(root) {
        /* Strip every disallowed attribute (on* handlers included) off the whole
       subtree BEFORE detaching anything. Detaching first would hand back
       handler-bearing originals (e.g. an already-loading `<img onerror>`)
       whose queued resource event still fires in page scope after we throw.
       Clobber-safe reads; a doomed clobbered node's own attributes are
       irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
        const childNodes = getChildNodes(root);
        if (childNodes) {
            const snapshot = [];
            $d0d31c26942b471d$var$arrayForEach(childNodes, (child)=>{
                $d0d31c26942b471d$var$arrayPush(snapshot, child);
            });
            $d0d31c26942b471d$var$arrayForEach(snapshot, (child)=>{
                try {
                    remove(child);
                } catch (_) {
                /* Best-effort teardown; a still-attached child is handled below */ }
            });
        }
        const attributes = getAttributes(root);
        if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name === 'string') try {
                root.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute — ignore (fail-closed best effort) */ }
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $d0d31c26942b471d$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $d0d31c26942b471d$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _stripDisallowedAttributes
   *
   * Removes every attribute the active configuration does not allow from a
   * single element, using the same allowlist as the main attribute pass (so
   * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
   * neutralise nodes that are being discarded from an in-place tree.
   *
   * @param element the element to strip
   */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
        const attributes = getAttributes(element);
        if (!attributes) return;
        for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
            try {
                element.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute on a doomed node — ignore */ }
        }
    };
    /**
   * _neutralizeSubtree
   *
   * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
   * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
   * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
   * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
   * those dropped nodes are detached from the caller's LIVE tree but a
   * handler-bearing original among them (an `<img onerror>`/`<video>` that was
   * loading) keeps its queued resource event, which fires in page scope after
   * sanitize returns. This walks a removed subtree and strips every attribute
   * the active configuration does not allow — so `on*` handlers are cancelled
   * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
   * blocklist. Run synchronously before sanitize returns, i.e. before any
   * queued event can fire. Hook-free by design: these nodes leave the output,
   * so firing attribute hooks for them would be surprising. Clobber-safe reads;
   * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
   * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
   * the `<img>`, are reached and scrubbed).
   *
   * @param root the root of a removed subtree to neutralise
   */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            if (nodeType === $d0d31c26942b471d$var$NODE_TYPE.element) _stripDisallowedAttributes(node);
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _neutralizePatchLinkage
   *
   * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
   * hardening, https://github.com/WICG/declarative-partial-updates).
   *
   * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
   * markers (PIs / markup comments) node-by-node, in document order, AS it
   * reaches each node. On a live in-place root that leaves a window: from the
   * moment the root is connected until the walk arrives at a given node, that
   * node's linkage is live. A patch applied on connection/stream can fire as
   * a microtask during the walk and inject or teleport an unsanitized DOM
   * range into a region the iterator has already passed and will not revisit,
   * so the post-return "tree is sanitized" contract is violated. Sweep the
   * whole tree once up front and sever every linkage before the walk begins,
   * closing that window.
   *
   * This CANNOT undo a patch that already fired before sanitize ran — that is
   * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
   * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
   * to group with the rest of the declarative-partial-updates handling and
   * stay overridable, consistent with the codebase.
   *
   * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
   * clobbered root cannot defeat the sweep of its non-clobbered descendants.
   *
   * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
   * .html Q1): this mirrors the existing policy of keeping `for` on
   * <label>/<output>. If the shipping feature can drive a patch through a
   * surviving `for`-on-label/output + `id` pair, this pre-pass and the
   * attribute check at _isBasicCustomElement's caller must additionally drop
   * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
   *
   * @param root the in-place root to sweep
   */ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
        if (!SAFE_FOR_XML) return;
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            /* Remove range markers (the target side of a patch linkage): every
         processing instruction, and any markup-bearing comment. */ if (nodeType === $d0d31c26942b471d$var$NODE_TYPE.processingInstruction || nodeType === $d0d31c26942b471d$var$NODE_TYPE.comment && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$COMMENT_MARKUP_PROBE, node.data)) {
                try {
                    remove(node);
                } catch (_) {
                /* Best-effort */ }
                continue;
            }
            /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === $d0d31c26942b471d$var$NODE_TYPE.element) {
                const element = node;
                const lcTag = transformCaseFunc(getNodeName ? getNodeName(node) : node.nodeName);
                try {
                    if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                    if (element.hasAttribute && element.hasAttribute('for') && lcTag !== 'label' && lcTag !== 'output') element.removeAttribute('for');
                } catch (_) {
                /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
            }
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $d0d31c26942b471d$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        /* Read ownerDocument through the cached Node.prototype getter, never the
       direct property. HTMLFormElement has [LegacyOverrideBuiltIns], so a
       clobbering child (<input name="ownerDocument"> or a form-associated
       external input) shadows the prototype getter and makes a direct read
       return that <input>. createNodeIterator.call(<input>, ...) then throws
       "Illegal invocation", and on the IN_PLACE path that throw lands before
       the walk's fail-closed barrier - leaving the caller's live tree, with
       any already-armed handler in it, un-neutralized. The cached getter
       returns the real Document regardless of the clobber. */ const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
        return createNodeIterator.call(doc || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * Replace template expression syntax (mustache, ERB, template
   * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
   * sites. Order matters: mustache, then ERB, then template literal.
   *
   * @param value the string to scrub
   * @returns the scrubbed string
   */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
        value = $d0d31c26942b471d$var$stringReplace(value, MUSTACHE_EXPR$1, ' ');
        value = $d0d31c26942b471d$var$stringReplace(value, ERB_EXPR$1, ' ');
        value = $d0d31c26942b471d$var$stringReplace(value, TMPLIT_EXPR$1, ' ');
        return value;
    };
    /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
        var _node$querySelectorAl;
        node.normalize();
        /* Clobber-safe ownerDocument read, same reasoning as _createNodeIterator:
       under SAFE_FOR_TEMPLATES this runs on the live IN_PLACE root, which may
       carry a form-named-getter override of ownerDocument. */ const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
        const walker = createNodeIterator.call(doc || node, node, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
        let currentNode = walker.nextNode();
        while(currentNode){
            currentNode.data = _stripTemplateExpressions(currentNode.data);
            currentNode = walker.nextNode();
        }
        // NodeIterator does not descend into <template>.content per the DOM spec,
        // so we must explicitly recurse into each template's content fragment,
        // mirroring the approach used by _sanitizeShadowDOM.
        const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
        if (templates) $d0d31c26942b471d$var$arrayForEach(templates, (tmpl)=>{
            if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
        });
    };
    /**
   * _isClobbered
   *
   * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
   * interface with [LegacyOverrideBuiltIns]; a descendant element with a
   * `name` attribute matching a prototype property shadows that property
   * on direct reads. We use this check at the IN_PLACE entry-point and
   * during attribute sanitization to refuse clobbered forms.
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        // Realm-independent tag-name probe. If we can't determine the tag
        // name at all, we can't reason about clobbering — return false
        // (the caller's other defences still apply).
        const realTagName = getNodeName ? getNodeName(element) : null;
        if (typeof realTagName !== 'string') return false;
        if (transformCaseFunc(realTagName) !== 'form') return false;
        return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
        // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
        // makes the direct read diverge from the cached read; a clean form
        // (same-realm OR foreign-realm) has both reads pointing at the same
        // canonical NamedNodeMap.
        element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
        // returns the integer 1 for any Element regardless of realm; direct
        // read on a clobbered form (e.g. <input name="nodeType">) returns
        // the named child element. Cheap addition — nodeType is read from
        // an internal slot, no serialization cost — and removes a residual
        // clobbering surface used by several mXSS / PI / comment branches
        // in _sanitizeElements that compare currentNode.nodeType directly.
        element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
        // "childNodes" shadows the prototype getter. Direct reads of
        // form.childNodes from a clobbered form return the named child
        // instead of the real NodeList, so any walk that reads it directly
        // skips the form's real children. Compare the direct read to the
        // cached Node.prototype getter — when the form's named-property
        // getter intercepts the read, the two values differ and we flag
        // the form. This catches every clobbering child type (input,
        // select, etc.) regardless of whether the named child happens to
        // carry a numeric .length, which a typeof-based probe would miss
        // (e.g. HTMLSelectElement.length is a defined unsigned-long).
        element.childNodes !== getChildNodes(element);
    };
    /**
   * Checks whether the given value is a DocumentFragment from any realm.
   *
   * The realm-independent replacement reads `nodeType` through the cached
   * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
   * constant (11). nodeType is a numeric value resolved from the node's
   * internal slot, identical across realms for the same kind of node.
   *
   * @param value object to check
   * @return true if value is a DocumentFragment-shaped node from any realm
   */ const _isDocumentFragment = function _isDocumentFragment(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return getNodeType(value) === $d0d31c26942b471d$var$NODE_TYPE.documentFragment;
        } catch (_) {
            return false;
        }
    };
    /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */ const _isNode = function _isNode(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return typeof getNodeType(value) === 'number';
        } catch (_) {
            return false;
        }
    };
    function _executeHooks(hooks, currentNode, data) {
        if (hooks.length === 0) return;
        $d0d31c26942b471d$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * Structural-threat checks that condemn a node regardless of the
   * allowlists: mXSS via namespace confusion, risky CSS construction,
   * processing instructions, markup-bearing comments. Pure predicate;
   * the caller removes. Check order is load-bearing.
   *
   * @param currentNode the node to inspect
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node must be removed
   */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$ELEMENT_MARKUP_PROBE, currentNode.textContent) && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
        /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) return true;
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $d0d31c26942b471d$var$NODE_TYPE.processingInstruction) return true;
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $d0d31c26942b471d$var$NODE_TYPE.comment && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$COMMENT_MARKUP_PROBE, currentNode.data)) return true;
        return false;
    };
    /**
   * Handle a node whose tag is forbidden or not allowlisted: keep
   * allowed custom elements (false return exits _sanitizeElements
   * early - the namespace and fallback-tag removal checks are
   * intentionally skipped for kept custom elements), else hoist
   * content per KEEP_CONTENT and remove.
   *
   * A kept custom element is the ONLY case in which this function
   * returns false, so the caller uses that return value to run the
   * afterSanitizeElements hook on the kept element and keep the
   * element-hook lifecycle consistent with normal allowlisted
   * elements (GHSA-c2j3-45gr-mqc4).
   *
   * @param currentNode the disallowed node
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node was removed, false if kept
   */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
        /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $d0d31c26942b471d$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements.
         Use the cached prototype getters exclusively — the previous code
         had `|| currentNode.parentNode` / `|| currentNode.childNodes`
         fallbacks, but the cached getters always return the canonical
         value (or null for a real parent-less node), so the fallback
         path was dead in safe cases and a clobbering surface in unsafe
         ones. Falsy cached results stay falsy; the `if (childNodes &&
         parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            const parentNode = getParentNode(currentNode);
            const childNodes = getChildNodes(currentNode);
            if (childNodes && parentNode) {
                const childCount = childNodes.length;
                /* Hoist by moving each child up one level rather than deep-cloning
             it. Moving transfers every descendant exactly once, so a chain of
             nested disallowed elements costs O(n) instead of the O(n^2) that
             re-cloning the shrinking subtree at each level produced; it also
             empties the removed original, so `DOMPurify.removed` no longer
             pins whole subtrees. Moving preserves the in-place guarantee too:
             an original carrying already-queued resource events (`<img
             onerror>`, `<video>`/`<audio>` error, lazy/`onload`, …) is
             relocated and sanitised rather than left detached but still armed.
                      The sole case that must clone is removing the walk root itself.
             The result is serialised from the root's subtree, so a restrictive
             ALLOWED_TAGS that strips the root (`body` on the string path) must
             leave the content inside it, which only cloning does. In IN_PLACE
             the root is pre-validated as an allowed tag and so is never removed
             here, so that path always takes the move branch.
                      `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
             valid whether we move (drops the trailing entry) or clone (leaves
             the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                    const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                    parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                }
            }
        }
        _forceRemove(currentNode);
        return true;
    };
    /**
   * Fork a hook-mutable allowlist off its shared binding the first time a
   * (possibly lazily-installed) uponSanitize* hook is about to see it, so the
   * hook cannot widen the per-instance default or the setConfig binding by
   * reference and leak past the call. Returns the set unchanged once it is
   * already call-local, so repeated calls across elements are idempotent.
   *
   * @param hookList the uponSanitize* hook array for this event
   * @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
   * @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
   * @param setConfigSet the captured setConfig() binding, or null
   * @return a call-local clone if a hook is present and set is still shared,
   *   else set unchanged
   */ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
        if (hookList.length === 0) return set;
        return set === defaultSet || set === setConfigSet ? $d0d31c26942b471d$var$clone(set) : set;
    };
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ // eslint-disable-next-line complexity
    const _sanitizeElements = function _sanitizeElements(currentNode, root) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* A hook may have detached the node - treat it as removed (see the
       detached-node comment after the uponSanitizeElement hook below). On
       the IN_PLACE path, neutralize the detached subtree first so a queued
       resource handler on it cannot fire in page scope after we return. */ if (currentNode !== root && getParentNode(currentNode) === null) {
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        }
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
        /* Close the pre-walk clone-guard's timing gap: an uponSanitizeElement
       hook may have been installed after that guard sampled the hook arrays
       (e.g. lazily from beforeSanitizeElements), leaving ALLOWED_TAGS still
       aliasing a shared binding that a widening hook would mutate by
       reference. Fork it before exposing it to the hook. */ ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* A hook may have detached the node from the tree — a long-standing
       user pattern (issue #469; draw.io-style foreignObject filtering).
       Per the cached, unclobberable parentNode getter the node is
       genuinely out of the tree, so it can reach neither the serialized
       output nor an IN_PLACE live tree; treat it as removed and stop
       processing it. Without this guard, the unsafe-node / namespace
       checks below would call _forceRemove on a parentless node and hit
       the REPORT-3 fail-closed throw — which exists for nodes DOMPurify
       wants gone but *cannot* detach (clobbered / parentless roots), the
       opposite of a node that is already safely gone. The walk root is
       exempt: a detached IN_PLACE root is legitimate input and must still
       be fully sanitized, and a kill-decision on it must keep hitting the
       REPORT-3 throw. Nodes detached by hooks stay the hook's
       responsibility for placement: they are not recorded in
       DOMPurify.removed, so the post-walk IN_PLACE pass (which iterates
       DOMPurify.removed) does not reach them. But a hook-detached subtree
       can still hold a queued resource-event handler - e.g. an <img onload>
       that began loading when the caller built the live tree - which fires
       in page scope after sanitize returns even though the handler never
       reached the returned tree. That is the audit-5 F1 hazard, and the
       documented node.remove() hook pattern walks straight into it. So on
       the IN_PLACE path we neutralize the detached subtree inline here,
       stripping its non-allow-listed attributes before returning, exactly
       as the post-walk pass does for _forceRemove'd subtrees. */ if (currentNode !== root && getParentNode(currentNode) === null) {
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        }
        /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
            /* A false return means the node is a custom element kept via
         CUSTOM_ELEMENT_HANDLING - the only keep path through
         _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
         element-hook lifecycle matches normal allowlisted elements: a
         security policy applied in this hook (e.g. stripping an attribute
         from every surviving element) must not silently skip kept custom
         elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
         tail below - the hook runs, then the walker's subsequent
         _sanitizeAttributes pass sanitizes the element's attributes. The
         deliberately skipped namespace and fallback-tag removal checks stay
         skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return removed;
        }
        /* Check whether element has a valid namespace.
       Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
       nodeType getter rather than `instanceof Element`, which is realm-
       bound and short-circuits to false for any node minted in a different
       realm — letting a foreign-realm element with a forbidden namespace
       slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
        if (nt === $d0d31c26942b471d$var$NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $d0d31c26942b471d$var$NODE_TYPE.text) {
            /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
            if (currentNode.textContent !== content) {
                $d0d31c26942b471d$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Reject declarative-partial-updates patch-linkage attributes
       (https://github.com/WICG/declarative-partial-updates).
            Empirical note (Chrome 150, verified — see
       test/declarative-patch-probe-v3.html): expansion is NOT applied after
       sanitization. For the string path it fires during sanitize()'s own
       parse, so the walk sees and sanitizes the fully materialized expanded
       tree — teleports into MathML/SVG integration points included; a
       weaponized `<template for>`->`<img onerror>` comes back with the handler
       stripped. For the IN_PLACE path it fires on connection, before the walk.
       Either way DOMPurify is NOT blind to the patch.
            This removal is therefore defense-in-depth rather than the sole barrier:
       it prevents live linkage from surviving into the OUTPUT and re-expanding
       in the caller's context, and keeps behaviour deterministic if a future
       engine defers expansion. `for` is legitimate only on <label>/<output>;
       anywhere else (notably <template for>) it links the element to a patch
       target and teleports or removes an arbitrary DOM range by id/marker name.
       `patchsrc` fetches remote markup and is treated as a script-loading
       mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
       other structural-threat checks and stays overridable, consistent with
       the rest of the codebase. PI range markers are already removed by
       _isUnsafeNode. */ if (SAFE_FOR_XML && lcName === 'patchsrc') return false;
        if (SAFE_FOR_XML && lcName === 'for' && lcTag !== 'label' && lcTag !== 'output') return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && $d0d31c26942b471d$var$regExpTest(DATA_ATTR$1, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $d0d31c26942b471d$var$regExpTest(ARIA_ATTR$1, lcName)) ;
        else if (!nameIsPermitted) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $d0d31c26942b471d$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $d0d31c26942b471d$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $d0d31c26942b471d$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($d0d31c26942b471d$var$regExpTest(IS_ALLOWED_URI$1, $d0d31c26942b471d$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $d0d31c26942b471d$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$d0d31c26942b471d$var$regExpTest(IS_SCRIPT_OR_DATA$1, $d0d31c26942b471d$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if (value) return false;
        return true;
    };
    /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = $d0d31c26942b471d$var$addToSet({}, [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'missing-glyph'
    ]);
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$d0d31c26942b471d$var$stringToLowerCase(tagName)] && $d0d31c26942b471d$var$regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    /**
   * Wrap an attribute value in the matching Trusted Types object when
   * the active policy requires it. Namespaced attributes pass through
   * unchanged (no TT support yet, see
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
   *
   * @param lcTag lowercase tag name of the containing element
   * @param lcName lowercase attribute name
   * @param namespaceURI the attribute's namespace, if any
   * @param value the attribute value to wrap
   * @return the value, wrapped when Trusted Types demand it
   */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
            case 'TrustedHTML':
                return _createTrustedHTML(value);
            case 'TrustedScriptURL':
                return _createTrustedScriptURL(value);
        }
        return value;
    };
    /**
   * Write a modified attribute value back onto the element. On
   * success, re-probe for clobbering introduced by the new value and
   * remove the element when found; otherwise pop the removal entry
   * recorded by the earlier _removeAttribute (long-standing pairing
   * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
   * failure, remove the attribute instead.
   *
   * @param currentNode the element carrying the attribute
   * @param name the attribute name as present on the element
   * @param namespaceURI the attribute's namespace, if any
   * @param value the new attribute value
   */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
        try {
            if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
            else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
            if (_isClobbered(currentNode)) _forceRemove(currentNode);
            else $d0d31c26942b471d$var$arrayPop(DOMPurify.removed);
        } catch (_) {
            _removeAttribute(name, currentNode);
        }
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const attributes = currentNode.attributes;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        /* Same lazy-install guard as uponSanitizeElement (see there): fork the
       attribute allowlist off its shared binding before a hook can see it. */ ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        const lcTag = transformCaseFunc(currentNode.nodeName);
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $d0d31c26942b471d$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && $d0d31c26942b471d$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            // Else: already prefixed, leave the attribute alone — the prefix is
            // itself the clobbering protection, and re-applying it is incorrect.
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $d0d31c26942b471d$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $d0d31c26942b471d$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$SELF_CLOSING_TAG, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
            /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
         DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
         recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
            /* An element iterated here may itself host an attached
         shadow root. The default NodeIterator does not enter shadow
         trees, so a shadow root nested inside template.content was
         previously reached by no walk at all (the pre-pass at
         _sanitizeAttachedShadowRoots descends via childNodes, which
         doesn't enter template.content; the template-content recursion
         above iterates the content but never inspected shadowRoot).
         Walk it explicitly. The nodeType guard avoids reading
         shadowRoot off text / comment / CDATA / PI nodes that the
         iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
            if (shadowNodeType === $d0d31c26942b471d$var$NODE_TYPE.element) {
                const innerSr = getShadowRoot(shadowNode);
                if (_isDocumentFragment(innerSr)) {
                    _sanitizeAttachedShadowRoots(innerSr);
                    _sanitizeShadowDOM2(innerSr);
                }
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
        /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
       impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
       built straight into the DOM — the IN_PLACE surface) deeper than the JS
       call-stack budget would otherwise overflow native recursion here and
       throw at the IN_PLACE entry pre-pass, before a single node is
       sanitized, leaving the caller's live tree untouched (fail-open). See
       campaign-3 F4. A heap stack keeps depth off the call stack.
            Each work item is either a node to descend into, or a deferred
       `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
       form preserves the original post-order discipline: a shadow root's
       nested shadow roots are discovered before the outer shadow is
       sanitized (which may remove hosts). Pushes are in reverse of the
       desired processing order (LIFO): template content, then children, then
       the shadow-sanitize, then the shadow walk — so the order matches the
       previous recursion exactly. */ const stack = [
            {
                node: root,
                shadow: null
            }
        ];
        while(stack.length > 0){
            const item = stack.pop();
            /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                _sanitizeShadowDOM2(item.shadow);
                continue;
            }
            const node = item.node;
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            const isElement = nodeType === $d0d31c26942b471d$var$NODE_TYPE.element;
            /* (pushed last → processed first) Children, snapshotted in reverse so
         the first child is processed first. Snapshotting matters because a
         hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                node: childNodes[i],
                shadow: null
            });
            /* (pushed before children → processed after them, matching the old
         "template content last" order) When the node is a <template>,
         descend into its content. */ if (isElement) {
                const rootName = getNodeName ? getNodeName(node) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = node.content;
                    if (_isDocumentFragment(content)) stack.push({
                        node: content,
                        shadow: null
                    });
                }
            }
            /* Shadow root (processed first): walk its subtree, then sanitise it.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
         rather than `instanceof DocumentFragment`, which is realm-bound and
         silently skipped foreign-realm shadow roots (e.g.
         iframe.contentDocument attachShadow). */ if (isElement) {
                const sr = getShadowRoot(node);
                if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
             walk we push next, i.e. nested shadow roots are discovered
             before this one is sanitised. */ stack.push({
                    node: null,
                    shadow: sr
                }, {
                    node: sr,
                    shadow: null
                });
            }
        }
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            dirty = $d0d31c26942b471d$var$stringifyValue(dirty);
            if (typeof dirty !== 'string') throw $d0d31c26942b471d$var$typeErrorCreate('dirty is not a string, aborting');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (SET_CONFIG) {
            /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
       * not re-derived per call. Restore them from the pristine bindings
       * captured at setConfig() time so a previous call's hook clone (mutated
       * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
            ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
        } else _parseConfig(cfg);
        /* Clone the hook-mutable allowlists before the walk whenever an
     * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
     * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
     * a hook that widens them would otherwise mutate the shared set
     * permanently: across later calls and across every element. Cloning per
     * walk keeps documented in-call widening working while scoping it to the
     * call. A single guard for both config paths - the per-call path rebinds
     * the sets in _parseConfig each call, the persistent path restores them
     * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = $d0d31c26942b471d$var$clone(ALLOWED_TAGS);
        if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = $d0d31c26942b471d$var$clone(ALLOWED_ATTR);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Resolve IN_PLACE for this call without mutating persistent config.
       Writing the IN_PLACE closure variable here leaks under setConfig(),
       where _parseConfig is skipped on later calls: a single string call would
       disable in-place mode for every subsequent node call, returning a
       sanitized copy while leaving the caller's node — which in-place callers
       keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
        if (inPlace) {
            /* Declarative-partial-updates / streaming pre-pass: sever every patch
         linkage across the live tree BEFORE the walk, so no patch can fire
         mid-walk and inject into an already-processed region. Runs first, so
         it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
            /* Do some early pre-sanitization to avoid unsafe root nodes.
         Read nodeName through the cached prototype getter — a clobbering
         child named "nodeName" on the form root would otherwise shadow
         the property and let this check skip the root-allowlist
         validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
            if (typeof nn === 'string') {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    /* Fail closed on a live root: neutralize handlers/children before
             throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                    throw $d0d31c26942b471d$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            }
            /* Pre-flight the root through _isClobbered. The iterator-driven
         removal path can not detach a parent-less root: _forceRemove
         falls through to Element.prototype.remove(), which per spec
         is a no-op on a node with no parent. A clobbered root would
         then survive the main loop with its attributes uninspected,
         because _sanitizeAttributes early-returns on _isClobbered. The
         result would be an attacker-controlled form, complete with any
         event-handler attributes the caller passed in, handed back to
         the application unsanitized. Refuse to sanitize such a root
         the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                /* Fail closed on a live clobbered root before throwing.
           _neutralizeRoot's reads are clobber-safe (cached getters); the
           form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                throw $d0d31c26942b471d$var$typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
            }
            /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. Same fail-closed
         barrier as the main walk (campaign-3 F2): a custom-element reaction
         inside a shadow root could abort this pre-pass before the walk runs,
         which would otherwise leave the entire live tree unsanitized. */ try {
                _sanitizeAttachedShadowRoots(dirty);
            } catch (error) {
                _neutralizeRoot(dirty);
                throw error;
            }
        } else if (_isNode(dirty)) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $d0d31c26942b471d$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
            /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. The walk routes every read through a
         cached prototype getter so clobbering descendants on a form root
         cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
        /* Now start iterating over the created document.
       The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
       engine/custom-element mutation can detach a node mid-walk so
       `_forceRemove`'s parentless guard throws, aborting the loop. Without the
       barrier the caller's in-place tree would be left half-sanitized with the
       unvisited tail still armed. _createNodeIterator itself is inside the
       barrier too: constructing the iterator dereferences the root's document,
       and any failure there (e.g. an exotic/clobbered root) must still fail
       closed rather than skip the neutralize. On any throw we fail closed -
       strip the in-place root bare - then rethrow so the existing throw
       contract is preserved. (String/DOM-copy paths never return the partial
       body, so the propagating throw is already fail-closed there.) */ try {
            const nodeIterator = _createNodeIterator(walkRoot);
            while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
        } catch (error) {
            if (inPlace) {
                _neutralizeRoot(dirty);
                /* Nodes _forceRemove'd earlier in the aborted walk are already
           detached from the root, so _neutralizeRoot's subtree pass does not
           reach them. Defuse them too, mirroring the success-path loop below. */ $d0d31c26942b471d$var$arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
            }
            throw error;
        }
        /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
            /* Fail-closed completion of the audit-5 F1 fix: every node removed from
         the caller's live tree is detached but may still hold a queued
         resource-event handler that fires in page scope after we return. The
         move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
         non-allow-listed attributes off every other removed subtree (clobber,
         mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
         cancelled before any event can fire. Runs synchronously, pre-return. */ $d0d31c26942b471d$var$arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) _neutralizeSubtree(entry.element);
            });
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
            return dirty;
        }
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $d0d31c26942b471d$var$regExpTest($d0d31c26942b471d$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
        SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
        SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
        SET_CONFIG_ALLOWED_TAGS = null;
        SET_CONFIG_ALLOWED_ATTR = null;
        // Drop any caller-supplied Trusted Types policy so it cannot poison later
        // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
        // never recreated — Trusted Types throws on duplicate names) is restored by
        // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
        trustedTypesPolicy = defaultTrustedTypesPolicy;
        emptyHTML = '';
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        /* Reject unknown entry points. Without this, a non-hook key (e.g.
     * '__proto__') indexes off the prototype chain rather than a real
     * hook array, and arrayPush then writes to Object.prototype. Guard
     * with an own-property check against the known hook names. */ if (!$d0d31c26942b471d$var$objectHasOwnProperty(hooks, entryPoint)) return;
        $d0d31c26942b471d$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (!$d0d31c26942b471d$var$objectHasOwnProperty(hooks, entryPoint)) return undefined;
        if (hookFunction !== undefined) {
            const index = $d0d31c26942b471d$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $d0d31c26942b471d$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $d0d31c26942b471d$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        if (!$d0d31c26942b471d$var$objectHasOwnProperty(hooks, entryPoint)) return;
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $d0d31c26942b471d$var$_createHooksMap();
    };
    return DOMPurify;
}
var $d0d31c26942b471d$export$2e2bcd8739ae039 = $d0d31c26942b471d$var$createDOMPurify();


// https://nodejs.org/api/packages.html#packages_writing_dual_packages_while_avoiding_or_minimizing_hazards
var $096de701954268a2$exports = {};
/* eslint-disable no-multi-assign */ function $096de701954268a2$var$deepFreeze(obj) {
    if (obj instanceof Map) obj.clear = obj.delete = obj.set = function() {
        throw new Error('map is read-only');
    };
    else if (obj instanceof Set) obj.add = obj.clear = obj.delete = function() {
        throw new Error('set is read-only');
    };
    // Freeze self
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const prop = obj[name];
        const type = typeof prop;
        // Freeze prop if it is an object or function and also not already frozen
        if ((type === 'object' || type === 'function') && !Object.isFrozen(prop)) $096de701954268a2$var$deepFreeze(prop);
    });
    return obj;
}
/** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */ /** @typedef {import('highlight.js').CompiledMode} CompiledMode */ /** @implements CallbackResponse */ class $096de701954268a2$var$Response {
    /**
   * @param {CompiledMode} mode
   */ constructor(mode){
        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};
        this.data = mode.data;
        this.isMatchIgnored = false;
    }
    ignoreMatch() {
        this.isMatchIgnored = true;
    }
}
/**
 * @param {string} value
 * @returns {string}
 */ function $096de701954268a2$var$escapeHTML(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
}
/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */ function $096de701954268a2$var$inherit$1(original, ...objects) {
    /** @type Record<string,any> */ const result = Object.create(null);
    for(const key in original)result[key] = original[key];
    objects.forEach(function(obj) {
        for(const key in obj)result[key] = obj[key];
    });
    return /** @type {T} */ result;
}
/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */ /** @typedef {{scope?: string, language?: string, sublanguage?: boolean}} Node */ /** @typedef {{walk: (r: Renderer) => void}} Tree */ /** */ const $096de701954268a2$var$SPAN_CLOSE = '</span>';
/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */ const $096de701954268a2$var$emitsWrappingTags = (node)=>{
    // rarely we can have a sublanguage where language is undefined
    // TODO: track down why
    return !!node.scope;
};
/**
 *
 * @param {string} name
 * @param {{prefix:string}} options
 */ const $096de701954268a2$var$scopeToCSSClass = (name, { prefix: prefix })=>{
    // sub-language
    if (name.startsWith("language:")) return name.replace("language:", "language-");
    // tiered scope: comment.line
    if (name.includes(".")) {
        const pieces = name.split(".");
        return [
            `${prefix}${pieces.shift()}`,
            ...pieces.map((x, i)=>`${x}${"_".repeat(i + 1)}`)
        ].join(" ");
    }
    // simple scope
    return `${prefix}${name}`;
};
/** @type {Renderer} */ class $096de701954268a2$var$HTMLRenderer {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(parseTree, options){
        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(text) {
        this.buffer += $096de701954268a2$var$escapeHTML(text);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(node) {
        if (!$096de701954268a2$var$emitsWrappingTags(node)) return;
        const className = $096de701954268a2$var$scopeToCSSClass(node.scope, {
            prefix: this.classPrefix
        });
        this.span(className);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(node) {
        if (!$096de701954268a2$var$emitsWrappingTags(node)) return;
        this.buffer += $096de701954268a2$var$SPAN_CLOSE;
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(className) {
        this.buffer += `<span class="${className}">`;
    }
}
/** @typedef {{scope?: string, language?: string, children: Node[]} | string} Node */ /** @typedef {{scope?: string, language?: string, children: Node[]} } DataNode */ /** @typedef {import('highlight.js').Emitter} Emitter */ /**  */ /** @returns {DataNode} */ const $096de701954268a2$var$newNode = (opts = {})=>{
    /** @type DataNode */ const result = {
        children: []
    };
    Object.assign(result, opts);
    return result;
};
class $096de701954268a2$var$TokenTree {
    constructor(){
        /** @type DataNode */ this.rootNode = $096de701954268a2$var$newNode();
        this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(node) {
        this.top.children.push(node);
    }
    /** @param {string} scope */ openNode(scope) {
        /** @type Node */ const node = $096de701954268a2$var$newNode({
            scope: scope
        });
        this.add(node);
        this.stack.push(node);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    closeAllNodes() {
        while(this.closeNode());
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(builder) {
        // this does not
        return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(builder, node) {
        if (typeof node === "string") builder.addText(node);
        else if (node.children) {
            builder.openNode(node);
            node.children.forEach((child)=>this._walk(builder, child));
            builder.closeNode(node);
        }
        return builder;
    }
    /**
   * @param {Node} node
   */ static _collapse(node) {
        if (typeof node === "string") return;
        if (!node.children) return;
        if (node.children.every((el)=>typeof el === "string")) // node.text = node.children.join("");
        // delete node.children;
        node.children = [
            node.children.join("")
        ];
        else node.children.forEach((child)=>{
            $096de701954268a2$var$TokenTree._collapse(child);
        });
    }
}
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addText(text)
  - __addSublanguage(emitter, subLanguageName)
  - startScope(scope)
  - endScope()
  - finalize()
  - toHTML()

*/ /**
 * @implements {Emitter}
 */ class $096de701954268a2$var$TokenTreeEmitter extends $096de701954268a2$var$TokenTree {
    /**
   * @param {*} options
   */ constructor(options){
        super();
        this.options = options;
    }
    /**
   * @param {string} text
   */ addText(text) {
        if (text === "") return;
        this.add(text);
    }
    /** @param {string} scope */ startScope(scope) {
        this.openNode(scope);
    }
    endScope() {
        this.closeNode();
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ __addSublanguage(emitter, name) {
        /** @type DataNode */ const node = emitter.root;
        if (name) node.scope = `language:${name}`;
        this.add(node);
    }
    toHTML() {
        const renderer = new $096de701954268a2$var$HTMLRenderer(this, this.options);
        return renderer.value();
    }
    finalize() {
        this.closeAllNodes();
        return true;
    }
}
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $096de701954268a2$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $096de701954268a2$var$lookahead(re) {
    return $096de701954268a2$var$concat('(?=', re, ')');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $096de701954268a2$var$anyNumberOfTimes(re) {
    return $096de701954268a2$var$concat('(?:', re, ')*');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $096de701954268a2$var$optional(re) {
    return $096de701954268a2$var$concat('(?:', re, ')?');
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $096de701954268a2$var$concat(...args) {
    const joined = args.map((x)=>$096de701954268a2$var$source(x)).join("");
    return joined;
}
/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */ function $096de701954268a2$var$stripOptionsFromArgs(args) {
    const opts = args[args.length - 1];
    if (typeof opts === 'object' && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
    } else return {};
}
/** @typedef { {capture?: boolean} } RegexEitherOptions */ /**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */ function $096de701954268a2$var$either(...args) {
    /** @type { object & {capture?: boolean} }  */ const opts = $096de701954268a2$var$stripOptionsFromArgs(args);
    const joined = '(' + (opts.capture ? "" : "?:") + args.map((x)=>$096de701954268a2$var$source(x)).join("|") + ")";
    return joined;
}
/**
 * @param {RegExp | string} re
 * @returns {number}
 */ function $096de701954268a2$var$countMatchGroups(re) {
    return new RegExp(re.toString() + '|').exec('').length - 1;
}
/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */ function $096de701954268a2$var$startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
}
// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const $096de701954268a2$var$BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
// **INTERNAL** Not intended for outside usage
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {{joinWith: string}} opts
 * @returns {string}
 */ function $096de701954268a2$var$_rewriteBackreferences(regexps, { joinWith: joinWith }) {
    let numCaptures = 0;
    return regexps.map((regex)=>{
        numCaptures += 1;
        const offset = numCaptures;
        let re = $096de701954268a2$var$source(regex);
        let out = '';
        while(re.length > 0){
            const match = $096de701954268a2$var$BACKREF_RE.exec(re);
            if (!match) {
                out += re;
                break;
            }
            out += re.substring(0, match.index);
            re = re.substring(match.index + match[0].length);
            if (match[0][0] === '\\' && match[1]) // Adjust the backreference.
            out += '\\' + String(Number(match[1]) + offset);
            else {
                out += match[0];
                if (match[0] === '(') numCaptures++;
            }
        }
        return out;
    }).map((re)=>`(${re})`).join(joinWith);
}
/** @typedef {import('highlight.js').Mode} Mode */ /** @typedef {import('highlight.js').ModeCallback} ModeCallback */ // Common regexps
const $096de701954268a2$var$MATCH_NOTHING_RE = /\b\B/;
const $096de701954268a2$var$IDENT_RE = '[a-zA-Z]\\w*';
const $096de701954268a2$var$UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const $096de701954268a2$var$NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const $096de701954268a2$var$C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const $096de701954268a2$var$BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const $096de701954268a2$var$RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/ const $096de701954268a2$var$SHEBANG = (opts = {})=>{
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) opts.begin = $096de701954268a2$var$concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
    return $096de701954268a2$var$inherit$1({
        scope: 'meta',
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            if (m.index !== 0) resp.ignoreMatch();
        }
    }, opts);
};
// Common modes
const $096de701954268a2$var$BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]',
    relevance: 0
};
const $096de701954268a2$var$APOS_STRING_MODE = {
    scope: 'string',
    begin: '\'',
    end: '\'',
    illegal: '\\n',
    contains: [
        $096de701954268a2$var$BACKSLASH_ESCAPE
    ]
};
const $096de701954268a2$var$QUOTE_STRING_MODE = {
    scope: 'string',
    begin: '"',
    end: '"',
    illegal: '\\n',
    contains: [
        $096de701954268a2$var$BACKSLASH_ESCAPE
    ]
};
const $096de701954268a2$var$PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */ const $096de701954268a2$var$COMMENT = function(begin, end, modeOptions = {}) {
    const mode = $096de701954268a2$var$inherit$1({
        scope: 'comment',
        begin: begin,
        end: end,
        contains: []
    }, modeOptions);
    mode.contains.push({
        scope: 'doctag',
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: '[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)',
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: true,
        relevance: 0
    });
    const ENGLISH_WORD = $096de701954268a2$var$either(// list of common 1 and 2 letter words in English
    "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
    );
    // looking like plain text, more likely to be a comment
    mode.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: $096de701954268a2$var$concat(/[ ]+/, '(', ENGLISH_WORD, /[.]?[:]?([.][ ]|[ ])/, '){3}') // look for 3 words in a row
    });
    return mode;
};
const $096de701954268a2$var$C_LINE_COMMENT_MODE = $096de701954268a2$var$COMMENT('//', '$');
const $096de701954268a2$var$C_BLOCK_COMMENT_MODE = $096de701954268a2$var$COMMENT('/\\*', '\\*/');
const $096de701954268a2$var$HASH_COMMENT_MODE = $096de701954268a2$var$COMMENT('#', '$');
const $096de701954268a2$var$NUMBER_MODE = {
    scope: 'number',
    begin: $096de701954268a2$var$NUMBER_RE,
    relevance: 0
};
const $096de701954268a2$var$C_NUMBER_MODE = {
    scope: 'number',
    begin: $096de701954268a2$var$C_NUMBER_RE,
    relevance: 0
};
const $096de701954268a2$var$BINARY_NUMBER_MODE = {
    scope: 'number',
    begin: $096de701954268a2$var$BINARY_NUMBER_RE,
    relevance: 0
};
const $096de701954268a2$var$REGEXP_MODE = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
        $096de701954268a2$var$BACKSLASH_ESCAPE,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                $096de701954268a2$var$BACKSLASH_ESCAPE
            ]
        }
    ]
};
const $096de701954268a2$var$TITLE_MODE = {
    scope: 'title',
    begin: $096de701954268a2$var$IDENT_RE,
    relevance: 0
};
const $096de701954268a2$var$UNDERSCORE_TITLE_MODE = {
    scope: 'title',
    begin: $096de701954268a2$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
const $096de701954268a2$var$METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + $096de701954268a2$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */ const $096de701954268a2$var$END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(mode, {
        /** @type {ModeCallback} */ 'on:begin': (m, resp)=>{
            resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */ 'on:end': (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    });
};
var $096de701954268a2$var$MODES = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: $096de701954268a2$var$APOS_STRING_MODE,
    BACKSLASH_ESCAPE: $096de701954268a2$var$BACKSLASH_ESCAPE,
    BINARY_NUMBER_MODE: $096de701954268a2$var$BINARY_NUMBER_MODE,
    BINARY_NUMBER_RE: $096de701954268a2$var$BINARY_NUMBER_RE,
    COMMENT: $096de701954268a2$var$COMMENT,
    C_BLOCK_COMMENT_MODE: $096de701954268a2$var$C_BLOCK_COMMENT_MODE,
    C_LINE_COMMENT_MODE: $096de701954268a2$var$C_LINE_COMMENT_MODE,
    C_NUMBER_MODE: $096de701954268a2$var$C_NUMBER_MODE,
    C_NUMBER_RE: $096de701954268a2$var$C_NUMBER_RE,
    END_SAME_AS_BEGIN: $096de701954268a2$var$END_SAME_AS_BEGIN,
    HASH_COMMENT_MODE: $096de701954268a2$var$HASH_COMMENT_MODE,
    IDENT_RE: $096de701954268a2$var$IDENT_RE,
    MATCH_NOTHING_RE: $096de701954268a2$var$MATCH_NOTHING_RE,
    METHOD_GUARD: $096de701954268a2$var$METHOD_GUARD,
    NUMBER_MODE: $096de701954268a2$var$NUMBER_MODE,
    NUMBER_RE: $096de701954268a2$var$NUMBER_RE,
    PHRASAL_WORDS_MODE: $096de701954268a2$var$PHRASAL_WORDS_MODE,
    QUOTE_STRING_MODE: $096de701954268a2$var$QUOTE_STRING_MODE,
    REGEXP_MODE: $096de701954268a2$var$REGEXP_MODE,
    RE_STARTERS_RE: $096de701954268a2$var$RE_STARTERS_RE,
    SHEBANG: $096de701954268a2$var$SHEBANG,
    TITLE_MODE: $096de701954268a2$var$TITLE_MODE,
    UNDERSCORE_IDENT_RE: $096de701954268a2$var$UNDERSCORE_IDENT_RE,
    UNDERSCORE_TITLE_MODE: $096de701954268a2$var$UNDERSCORE_TITLE_MODE
});
/**
@typedef {import('highlight.js').CallbackResponse} CallbackResponse
@typedef {import('highlight.js').CompilerExt} CompilerExt
*/ // Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833
// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.
// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.
// ------
// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */ function $096de701954268a2$var$skipIfHasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") response.ignoreMatch();
}
/**
 *
 * @type {CompilerExt}
 */ function $096de701954268a2$var$scopeClassName(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.className !== undefined) {
        mode.scope = mode.className;
        delete mode.className;
    }
}
/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */ function $096de701954268a2$var$beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    // for languages with keywords that include non-word characters checking for
    // a word boundary is not sufficient, so instead we check for a word boundary
    // or whitespace - this does no harm in any case since our keyword engine
    // doesn't allow spaces in keywords anyways and we still check for the boundary
    // first
    mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
    mode.__beforeBegin = $096de701954268a2$var$skipIfHasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    // prevents double relevance, the keywords themselves provide
    // relevance, the mode doesn't need to double it
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 0;
}
/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */ function $096de701954268a2$var$compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = $096de701954268a2$var$either(...mode.illegal);
}
/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */ function $096de701954268a2$var$compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
}
/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */ function $096de701954268a2$var$compileRelevance(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 1;
}
// allow beforeMatch to act as a "qualifier" for the match
// the full match begin must be [beforeMatch][begin]
const $096de701954268a2$var$beforeMatchExt = (mode, parent)=>{
    if (!mode.beforeMatch) return;
    // starts conflicts with endsParent which we need to make sure the child
    // rule is not matched multiple times
    if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
    const originalMode = Object.assign({}, mode);
    Object.keys(mode).forEach((key)=>{
        delete mode[key];
    });
    mode.keywords = originalMode.keywords;
    mode.begin = $096de701954268a2$var$concat(originalMode.beforeMatch, $096de701954268a2$var$lookahead(originalMode.begin));
    mode.starts = {
        relevance: 0,
        contains: [
            Object.assign(originalMode, {
                endsParent: true
            })
        ]
    };
    mode.relevance = 0;
    delete originalMode.beforeMatch;
};
// keywords that should have no default relevance value
const $096de701954268a2$var$COMMON_KEYWORDS = [
    'of',
    'and',
    'for',
    'in',
    'not',
    'or',
    'if',
    'then',
    'parent',
    'list',
    'value' // common variable name
];
const $096de701954268a2$var$DEFAULT_KEYWORD_SCOPE = "keyword";
/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */ function $096de701954268a2$var$compileKeywords(rawKeywords, caseInsensitive, scopeName = $096de701954268a2$var$DEFAULT_KEYWORD_SCOPE) {
    /** @type {import("highlight.js/private").KeywordDict} */ const compiledKeywords = Object.create(null);
    // input can be a string of keywords, an array of keywords, or a object with
    // named keys representing scopeName (which can then point to a string or array)
    if (typeof rawKeywords === 'string') compileList(scopeName, rawKeywords.split(" "));
    else if (Array.isArray(rawKeywords)) compileList(scopeName, rawKeywords);
    else Object.keys(rawKeywords).forEach(function(scopeName) {
        // collapse all our objects back into the parent object
        Object.assign(compiledKeywords, $096de701954268a2$var$compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName));
    });
    return compiledKeywords;
    // ---
    /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} scopeName
   * @param {Array<string>} keywordList
   */ function compileList(scopeName, keywordList) {
        if (caseInsensitive) keywordList = keywordList.map((x)=>x.toLowerCase());
        keywordList.forEach(function(keyword) {
            const pair = keyword.split('|');
            compiledKeywords[pair[0]] = [
                scopeName,
                $096de701954268a2$var$scoreForKeyword(pair[0], pair[1])
            ];
        });
    }
}
/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */ function $096de701954268a2$var$scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore) return Number(providedScore);
    return $096de701954268a2$var$commonKeyword(keyword) ? 0 : 1;
}
/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */ function $096de701954268a2$var$commonKeyword(keyword) {
    return $096de701954268a2$var$COMMON_KEYWORDS.includes(keyword.toLowerCase());
}
/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/ /**
 * @type {Record<string, boolean>}
 */ const $096de701954268a2$var$seenDeprecations = {};
/**
 * @param {string} message
 */ const $096de701954268a2$var$error = (message)=>{
    console.error(message);
};
/**
 * @param {string} message
 * @param {any} args
 */ const $096de701954268a2$var$warn = (message, ...args)=>{
    console.log(`WARN: ${message}`, ...args);
};
/**
 * @param {string} version
 * @param {string} message
 */ const $096de701954268a2$var$deprecated = (version, message)=>{
    if ($096de701954268a2$var$seenDeprecations[`${version}/${message}`]) return;
    console.log(`Deprecated as of ${version}. ${message}`);
    $096de701954268a2$var$seenDeprecations[`${version}/${message}`] = true;
};
/* eslint-disable no-throw-literal */ /**
@typedef {import('highlight.js').CompiledMode} CompiledMode
*/ const $096de701954268a2$var$MultiClassError = new Error();
/**
 * Renumbers labeled scope names to account for additional inner match
 * groups that otherwise would break everything.
 *
 * Lets say we 3 match scopes:
 *
 *   { 1 => ..., 2 => ..., 3 => ... }
 *
 * So what we need is a clean match like this:
 *
 *   (a)(b)(c) => [ "a", "b", "c" ]
 *
 * But this falls apart with inner match groups:
 *
 * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
 *
 * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
 * What needs to happen is the numbers are remapped:
 *
 *   { 1 => ..., 2 => ..., 5 => ... }
 *
 * We also need to know that the ONLY groups that should be output
 * are 1, 2, and 5.  This function handles this behavior.
 *
 * @param {CompiledMode} mode
 * @param {Array<RegExp | string>} regexes
 * @param {{key: "beginScope"|"endScope"}} opts
 */ function $096de701954268a2$var$remapScopeNames(mode, regexes, { key: key }) {
    let offset = 0;
    const scopeNames = mode[key];
    /** @type Record<number,boolean> */ const emit = {};
    /** @type Record<number,string> */ const positions = {};
    for(let i = 1; i <= regexes.length; i++){
        positions[i + offset] = scopeNames[i];
        emit[i + offset] = true;
        offset += $096de701954268a2$var$countMatchGroups(regexes[i - 1]);
    }
    // we use _emit to keep track of which match groups are "top-level" to avoid double
    // output from inside match groups
    mode[key] = positions;
    mode[key]._emit = emit;
    mode[key]._multi = true;
}
/**
 * @param {CompiledMode} mode
 */ function $096de701954268a2$var$beginMultiClass(mode) {
    if (!Array.isArray(mode.begin)) return;
    if (mode.skip || mode.excludeBegin || mode.returnBegin) {
        $096de701954268a2$var$error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
        throw $096de701954268a2$var$MultiClassError;
    }
    if (typeof mode.beginScope !== "object" || mode.beginScope === null) {
        $096de701954268a2$var$error("beginScope must be object");
        throw $096de701954268a2$var$MultiClassError;
    }
    $096de701954268a2$var$remapScopeNames(mode, mode.begin, {
        key: "beginScope"
    });
    mode.begin = $096de701954268a2$var$_rewriteBackreferences(mode.begin, {
        joinWith: ""
    });
}
/**
 * @param {CompiledMode} mode
 */ function $096de701954268a2$var$endMultiClass(mode) {
    if (!Array.isArray(mode.end)) return;
    if (mode.skip || mode.excludeEnd || mode.returnEnd) {
        $096de701954268a2$var$error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
        throw $096de701954268a2$var$MultiClassError;
    }
    if (typeof mode.endScope !== "object" || mode.endScope === null) {
        $096de701954268a2$var$error("endScope must be object");
        throw $096de701954268a2$var$MultiClassError;
    }
    $096de701954268a2$var$remapScopeNames(mode, mode.end, {
        key: "endScope"
    });
    mode.end = $096de701954268a2$var$_rewriteBackreferences(mode.end, {
        joinWith: ""
    });
}
/**
 * this exists only to allow `scope: {}` to be used beside `match:`
 * Otherwise `beginScope` would necessary and that would look weird

  {
    match: [ /def/, /\w+/ ]
    scope: { 1: "keyword" , 2: "title" }
  }

 * @param {CompiledMode} mode
 */ function $096de701954268a2$var$scopeSugar(mode) {
    if (mode.scope && typeof mode.scope === "object" && mode.scope !== null) {
        mode.beginScope = mode.scope;
        delete mode.scope;
    }
}
/**
 * @param {CompiledMode} mode
 */ function $096de701954268a2$var$MultiClass(mode) {
    $096de701954268a2$var$scopeSugar(mode);
    if (typeof mode.beginScope === "string") mode.beginScope = {
        _wrap: mode.beginScope
    };
    if (typeof mode.endScope === "string") mode.endScope = {
        _wrap: mode.endScope
    };
    $096de701954268a2$var$beginMultiClass(mode);
    $096de701954268a2$var$endMultiClass(mode);
}
/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
*/ // compilation
/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @returns {CompiledLanguage}
 */ function $096de701954268a2$var$compileLanguage(language) {
    /**
   * Builds a regex with the case sensitivity of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */ function langRe(value, global) {
        return new RegExp($096de701954268a2$var$source(value), 'm' + (language.case_insensitive ? 'i' : '') + (language.unicodeRegex ? 'u' : '') + (global ? 'g' : ''));
    }
    /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */ class MultiRegex {
        constructor(){
            this.matchIndexes = {};
            // @ts-ignore
            this.regexes = [];
            this.matchAt = 1;
            this.position = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([
                opts,
                re
            ]);
            this.matchAt += $096de701954268a2$var$countMatchGroups(re) + 1;
        }
        compile() {
            if (this.regexes.length === 0) // avoids the need to check length every time exec is called
            // @ts-ignore
            this.exec = ()=>null;
            const terminators = this.regexes.map((el)=>el[1]);
            this.matcherRe = langRe($096de701954268a2$var$_rewriteBackreferences(terminators, {
                joinWith: '|'
            }), true);
            this.lastIndex = 0;
        }
        /** @param {string} s */ exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            const match = this.matcherRe.exec(s);
            if (!match) return null;
            // eslint-disable-next-line no-undefined
            const i = match.findIndex((el, i)=>i > 0 && el !== undefined);
            // @ts-ignore
            const matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);
            return Object.assign(match, matchData);
        }
    }
    /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */ class ResumableMultiRegex {
        constructor(){
            // @ts-ignore
            this.rules = [];
            // @ts-ignore
            this.multiRegexes = [];
            this.count = 0;
            this.lastIndex = 0;
            this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];
            const matcher = new MultiRegex();
            this.rules.slice(index).forEach(([re, opts])=>matcher.addRule(re, opts));
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            this.rules.push([
                re,
                opts
            ]);
            if (opts.type === "begin") this.count++;
        }
        /** @param {string} s */ exec(s) {
            const m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            let result = m.exec(s);
            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":
            // our matcher is [string, "booger", number]
            //
            // ....booger....
            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)
            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:
            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....
            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
                if (result && result.index === this.lastIndex) ;
                else {
                    const m2 = this.getMatcher(0);
                    m2.lastIndex = this.lastIndex + 1;
                    result = m2.exec(s);
                }
            }
            if (result) {
                this.regexIndex += result.position + 1;
                if (this.regexIndex === this.count) // wrap-around to considering all matches again
                this.considerAll();
            }
            return result;
        }
    }
    /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */ function buildModeRegex(mode) {
        const mm = new ResumableMultiRegex();
        mode.contains.forEach((term)=>mm.addRule(term.begin, {
                rule: term,
                type: "begin"
            }));
        if (mode.terminatorEnd) mm.addRule(mode.terminatorEnd, {
            type: "end"
        });
        if (mode.illegal) mm.addRule(mode.illegal, {
            type: "illegal"
        });
        return mm;
    }
    /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */ /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */ function compileMode(mode, parent) {
        const cmode = /** @type CompiledMode */ mode;
        if (mode.isCompiled) return cmode;
        [
            $096de701954268a2$var$scopeClassName,
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $096de701954268a2$var$compileMatch,
            $096de701954268a2$var$MultiClass,
            $096de701954268a2$var$beforeMatchExt
        ].forEach((ext)=>ext(mode, parent));
        language.compilerExtensions.forEach((ext)=>ext(mode, parent));
        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;
        [
            $096de701954268a2$var$beginKeywords,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $096de701954268a2$var$compileIllegal,
            // default to 1 relevance if not specified
            $096de701954268a2$var$compileRelevance
        ].forEach((ext)=>ext(mode, parent));
        mode.isCompiled = true;
        let keywordPattern = null;
        if (typeof mode.keywords === "object" && mode.keywords.$pattern) {
            // we need a copy because keywords might be compiled multiple times
            // so we can't go deleting $pattern from the original on the first
            // pass
            mode.keywords = Object.assign({}, mode.keywords);
            keywordPattern = mode.keywords.$pattern;
            delete mode.keywords.$pattern;
        }
        keywordPattern = keywordPattern || /\w+/;
        if (mode.keywords) mode.keywords = $096de701954268a2$var$compileKeywords(mode.keywords, language.case_insensitive);
        cmode.keywordPatternRe = langRe(keywordPattern, true);
        if (parent) {
            if (!mode.begin) mode.begin = /\B|\b/;
            cmode.beginRe = langRe(cmode.begin);
            if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
            if (mode.end) cmode.endRe = langRe(cmode.end);
            cmode.terminatorEnd = $096de701954268a2$var$source(cmode.end) || '';
            if (mode.endsWithParent && parent.terminatorEnd) cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
        }
        if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ mode.illegal);
        if (!mode.contains) mode.contains = [];
        mode.contains = [].concat(...mode.contains.map(function(c) {
            return $096de701954268a2$var$expandOrCloneMode(c === 'self' ? mode : c);
        }));
        mode.contains.forEach(function(c) {
            compileMode(/** @type Mode */ c, cmode);
        });
        if (mode.starts) compileMode(mode.starts, parent);
        cmode.matcher = buildModeRegex(cmode);
        return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    // self is not valid at the top-level
    if (language.contains && language.contains.includes('self')) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    // we need a null object, which inherit will guarantee
    language.classNameAliases = $096de701954268a2$var$inherit$1(language.classNameAliases || {});
    return compileMode(/** @type Mode */ language);
}
/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */ function $096de701954268a2$var$dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || $096de701954268a2$var$dependencyOnParent(mode.starts);
}
/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */ function $096de701954268a2$var$expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) mode.cachedVariants = mode.variants.map(function(variant) {
        return $096de701954268a2$var$inherit$1(mode, {
            variants: null
        }, variant);
    });
    // EXPAND
    // if we have variants then essentially "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cachedVariants) return mode.cachedVariants;
    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if ($096de701954268a2$var$dependencyOnParent(mode)) return $096de701954268a2$var$inherit$1(mode, {
        starts: mode.starts ? $096de701954268a2$var$inherit$1(mode.starts) : null
    });
    if (Object.isFrozen(mode)) return $096de701954268a2$var$inherit$1(mode);
    // no special dependency issues, just return ourselves
    return mode;
}
var $096de701954268a2$var$version = "11.11.1";
class $096de701954268a2$var$HTMLInjectionError extends Error {
    constructor(reason, html){
        super(reason);
        this.name = "HTMLInjectionError";
        this.html = html;
    }
}
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ /**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').CompiledScope} CompiledScope
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSApi} HLJSApi
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').PluginEvent} PluginEvent
@typedef {import('highlight.js').HLJSOptions} HLJSOptions
@typedef {import('highlight.js').LanguageFn} LanguageFn
@typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
@typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
@typedef {import('highlight.js/private').MatchType} MatchType
@typedef {import('highlight.js/private').KeywordData} KeywordData
@typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
@typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
@typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
@typedef {import('highlight.js').HighlightOptions} HighlightOptions
@typedef {import('highlight.js').HighlightResult} HighlightResult
*/ const $096de701954268a2$var$escape = $096de701954268a2$var$escapeHTML;
const $096de701954268a2$var$inherit = $096de701954268a2$var$inherit$1;
const $096de701954268a2$var$NO_MATCH = Symbol("nomatch");
const $096de701954268a2$var$MAX_KEYWORD_HITS = 7;
/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */ const $096de701954268a2$var$HLJS = function(hljs) {
    // Global internal variables used within the highlight.js library.
    /** @type {Record<string, Language>} */ const languages = Object.create(null);
    /** @type {Record<string, string>} */ const aliases = Object.create(null);
    /** @type {HLJSPlugin[]} */ const plugins = [];
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    let SAFE_MODE = true;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    /** @type {Language} */ const PLAINTEXT_LANGUAGE = {
        disableAutodetect: true,
        name: 'Plain text',
        contains: []
    };
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    /** @type HLJSOptions */ let options = {
        ignoreUnescapedHTML: false,
        throwUnescapedHTML: false,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: 'hljs-',
        cssSelector: 'pre code',
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $096de701954268a2$var$TokenTreeEmitter
    };
    /* Utility functions */ /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */ function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
    }
    /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */ function blockLanguage(block) {
        let classes = block.className + ' ';
        classes += block.parentNode ? block.parentNode.className : '';
        // language-* takes precedence over non-prefixed class names.
        const match = options.languageDetectRe.exec(classes);
        if (match) {
            const language = getLanguage(match[1]);
            if (!language) {
                $096de701954268a2$var$warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                $096de701954268a2$var$warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : 'no-highlight';
        }
        return classes.split(/\s+/).find((_class)=>shouldNotHighlight(_class) || getLanguage(_class));
    }
    /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrLanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
        let code = "";
        let languageName = "";
        if (typeof optionsOrCode === "object") {
            code = codeOrLanguageName;
            ignoreIllegals = optionsOrCode.ignoreIllegals;
            languageName = optionsOrCode.language;
        } else {
            // old API
            $096de701954268a2$var$deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
            $096de701954268a2$var$deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
            languageName = codeOrLanguageName;
            code = optionsOrCode;
        }
        // https://github.com/highlightjs/highlight.js/issues/3149
        // eslint-disable-next-line no-undefined
        if (ignoreIllegals === undefined) ignoreIllegals = true;
        /** @type {BeforeHighlightContext} */ const context = {
            code: code,
            language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);
        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals);
        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);
        return result;
    }
    /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */ function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        const keywordHits = Object.create(null);
        /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {string} matchText - the textual match
     * @returns {KeywordData | false}
     */ function keywordData(mode, matchText) {
            return mode.keywords[matchText];
        }
        function processKeywords() {
            if (!top.keywords) {
                emitter.addText(modeBuffer);
                return;
            }
            let lastIndex = 0;
            top.keywordPatternRe.lastIndex = 0;
            let match = top.keywordPatternRe.exec(modeBuffer);
            let buf = "";
            while(match){
                buf += modeBuffer.substring(lastIndex, match.index);
                const word = language.case_insensitive ? match[0].toLowerCase() : match[0];
                const data = keywordData(top, word);
                if (data) {
                    const [kind, keywordRelevance] = data;
                    emitter.addText(buf);
                    buf = "";
                    keywordHits[word] = (keywordHits[word] || 0) + 1;
                    if (keywordHits[word] <= $096de701954268a2$var$MAX_KEYWORD_HITS) relevance += keywordRelevance;
                    if (kind.startsWith("_")) // _ implied for relevance only, do not highlight
                    // by applying a class name
                    buf += match[0];
                    else {
                        const cssClass = language.classNameAliases[kind] || kind;
                        emitKeyword(match[0], cssClass);
                    }
                } else buf += match[0];
                lastIndex = top.keywordPatternRe.lastIndex;
                match = top.keywordPatternRe.exec(modeBuffer);
            }
            buf += modeBuffer.substring(lastIndex);
            emitter.addText(buf);
        }
        function processSubLanguage() {
            if (modeBuffer === "") return;
            /** @type HighlightResult */ let result = null;
            if (typeof top.subLanguage === 'string') {
                if (!languages[top.subLanguage]) {
                    emitter.addText(modeBuffer);
                    return;
                }
                result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
                continuations[top.subLanguage] = /** @type {CompiledMode} */ result._top;
            } else result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            emitter.__addSublanguage(result._emitter, result.language);
        }
        function processBuffer() {
            if (top.subLanguage != null) processSubLanguage();
            else processKeywords();
            modeBuffer = '';
        }
        /**
     * @param {string} text
     * @param {string} scope
     */ function emitKeyword(keyword, scope) {
            if (keyword === "") return;
            emitter.startScope(scope);
            emitter.addText(keyword);
            emitter.endScope();
        }
        /**
     * @param {CompiledScope} scope
     * @param {RegExpMatchArray} match
     */ function emitMultiClass(scope, match) {
            let i = 1;
            const max = match.length - 1;
            while(i <= max){
                if (!scope._emit[i]) {
                    i++;
                    continue;
                }
                const klass = language.classNameAliases[scope[i]] || scope[i];
                const text = match[i];
                if (klass) emitKeyword(text, klass);
                else {
                    modeBuffer = text;
                    processKeywords();
                    modeBuffer = "";
                }
                i++;
            }
        }
        /**
     * @param {CompiledMode} mode - new mode to start
     * @param {RegExpMatchArray} match
     */ function startNewMode(mode, match) {
            if (mode.scope && typeof mode.scope === "string") emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
            if (mode.beginScope) {
                // beginScope just wraps the begin match itself in a scope
                if (mode.beginScope._wrap) {
                    emitKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
                    modeBuffer = "";
                } else if (mode.beginScope._multi) {
                    // at this point modeBuffer should just be the match
                    emitMultiClass(mode.beginScope, match);
                    modeBuffer = "";
                }
            }
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
            return top;
        }
        /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */ function endOfMode(mode, match, matchPlusRemainder) {
            let matched = $096de701954268a2$var$startsWith(mode.endRe, matchPlusRemainder);
            if (matched) {
                if (mode["on:end"]) {
                    const resp = new $096de701954268a2$var$Response(mode);
                    mode["on:end"](match, resp);
                    if (resp.isMatchIgnored) matched = false;
                }
                if (matched) {
                    while(mode.endsParent && mode.parent)mode = mode.parent;
                    return mode;
                }
            }
            // even if on:end fires an `ignore` it's still possible
            // that we might trigger the end node because of a parent mode
            if (mode.endsWithParent) return endOfMode(mode.parent, match, matchPlusRemainder);
        }
        /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */ function doIgnore(lexeme) {
            if (top.matcher.regexIndex === 0) {
                // no more regexes to potentially match here, so we move the cursor forward one
                // space
                modeBuffer += lexeme[0];
                return 1;
            } else {
                // no need to move the cursor, we still have additional regexes to try and
                // match at this very spot
                resumeScanAtSamePosition = true;
                return 0;
            }
        }
        /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */ function doBeginMatch(match) {
            const lexeme = match[0];
            const newMode = match.rule;
            const resp = new $096de701954268a2$var$Response(newMode);
            // first internal before callbacks, then the public ones
            const beforeCallbacks = [
                newMode.__beforeBegin,
                newMode["on:begin"]
            ];
            for (const cb of beforeCallbacks){
                if (!cb) continue;
                cb(match, resp);
                if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
            if (newMode.skip) modeBuffer += lexeme;
            else {
                if (newMode.excludeBegin) modeBuffer += lexeme;
                processBuffer();
                if (!newMode.returnBegin && !newMode.excludeBegin) modeBuffer = lexeme;
            }
            startNewMode(newMode, match);
            return newMode.returnBegin ? 0 : lexeme.length;
        }
        /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */ function doEndMatch(match) {
            const lexeme = match[0];
            const matchPlusRemainder = codeToHighlight.substring(match.index);
            const endMode = endOfMode(top, match, matchPlusRemainder);
            if (!endMode) return $096de701954268a2$var$NO_MATCH;
            const origin = top;
            if (top.endScope && top.endScope._wrap) {
                processBuffer();
                emitKeyword(lexeme, top.endScope._wrap);
            } else if (top.endScope && top.endScope._multi) {
                processBuffer();
                emitMultiClass(top.endScope, match);
            } else if (origin.skip) modeBuffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) modeBuffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) modeBuffer = lexeme;
            }
            do {
                if (top.scope) emitter.closeNode();
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== endMode.parent);
            if (endMode.starts) startNewMode(endMode.starts, match);
            return origin.returnEnd ? 0 : lexeme.length;
        }
        function processContinuations() {
            const list = [];
            for(let current = top; current !== language; current = current.parent)if (current.scope) list.unshift(current.scope);
            list.forEach((item)=>emitter.openNode(item));
        }
        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */ let lastMatch = {};
        /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */ function processLexeme(textBeforeMatch, match) {
            const lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            modeBuffer += textBeforeMatch;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
                if (!SAFE_MODE) {
                    /** @type {AnnotatedError} */ const err = new Error(`0 width match regex (${languageName})`);
                    err.languageName = languageName;
                    err.badRule = lastMatch.rule;
                    throw err;
                }
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignoreIllegals) {
                // illegal match, we do not continue processing
                /** @type {AnnotatedError} */ const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || '<unnamed>') + '"');
                err.mode = top;
                throw err;
            } else if (match.type === "end") {
                const processed = doEndMatch(match);
                if (processed !== $096de701954268a2$var$NO_MATCH) return processed;
            }
            // edge case for when illegal matches $ (end of line) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when ignoreIllegals is true)
            if (match.type === "illegal" && lexeme === "") {
                // advance so we aren't stuck in an infinite loop
                modeBuffer += "\n";
                return 1;
            }
            // infinite loops are BAD, this is a last ditch catch all. if we have a
            // decent number of iterations yet our index (cursor position in our
            // parsing) still 3x behind our index then something is very wrong
            // so we bail
            if (iterations > 100000 && iterations > match.index * 3) {
                const err = new Error('potential infinite loop, way more iterations than matches');
                throw err;
            }
            /*
      Why might be find ourselves here?  An potential end match that was
      triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
      (this could be because a callback requests the match be ignored, etc)

      This causes no real harm other than stopping a few times too many.
      */ modeBuffer += lexeme;
            return lexeme.length;
        }
        const language = getLanguage(languageName);
        if (!language) {
            $096de701954268a2$var$error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        const md = $096de701954268a2$var$compileLanguage(language);
        let result = '';
        /** @type {CompiledMode} */ let top = continuation || md;
        /** @type Record<string,CompiledMode> */ const continuations = {}; // keep continuations for sub-languages
        const emitter = new options.__emitter(options);
        processContinuations();
        let modeBuffer = '';
        let relevance = 0;
        let index = 0;
        let iterations = 0;
        let resumeScanAtSamePosition = false;
        try {
            if (!language.__emitTokens) {
                top.matcher.considerAll();
                for(;;){
                    iterations++;
                    if (resumeScanAtSamePosition) // only regexes not matched previously will now be
                    // considered for a potential match
                    resumeScanAtSamePosition = false;
                    else top.matcher.considerAll();
                    top.matcher.lastIndex = index;
                    const match = top.matcher.exec(codeToHighlight);
                    // console.log("match", match[0], match.rule && match.rule.begin)
                    if (!match) break;
                    const beforeMatch = codeToHighlight.substring(index, match.index);
                    const processedCount = processLexeme(beforeMatch, match);
                    index = match.index + processedCount;
                }
                processLexeme(codeToHighlight.substring(index));
            } else language.__emitTokens(codeToHighlight, emitter);
            emitter.finalize();
            result = emitter.toHTML();
            return {
                language: languageName,
                value: result,
                relevance: relevance,
                illegal: false,
                _emitter: emitter,
                _top: top
            };
        } catch (err) {
            if (err.message && err.message.includes('Illegal')) return {
                language: languageName,
                value: $096de701954268a2$var$escape(codeToHighlight),
                illegal: true,
                relevance: 0,
                _illegalBy: {
                    message: err.message,
                    index: index,
                    context: codeToHighlight.slice(index - 100, index + 100),
                    mode: err.mode,
                    resultSoFar: result
                },
                _emitter: emitter
            };
            else if (SAFE_MODE) return {
                language: languageName,
                value: $096de701954268a2$var$escape(codeToHighlight),
                illegal: false,
                relevance: 0,
                errorRaised: err,
                _emitter: emitter,
                _top: top
            };
            else throw err;
        }
    }
    /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */ function justTextHighlightResult(code) {
        const result = {
            value: $096de701954268a2$var$escape(code),
            illegal: false,
            relevance: 0,
            _top: PLAINTEXT_LANGUAGE,
            _emitter: new options.__emitter(options)
        };
        result._emitter.addText(code);
        return result;
    }
    /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - secondBest (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        const plaintext = justTextHighlightResult(code);
        const results = languageSubset.filter(getLanguage).filter(autoDetection).map((name)=>_highlight(name, code, false));
        results.unshift(plaintext); // plaintext is always an option
        const sorted = results.sort((a, b)=>{
            // sort base on relevance
            if (a.relevance !== b.relevance) return b.relevance - a.relevance;
            // always award the tie to the base language
            // ie if C++ and Arduino are tied, it's more likely to be C++
            if (a.language && b.language) {
                if (getLanguage(a.language).supersetOf === b.language) return 1;
                else if (getLanguage(b.language).supersetOf === a.language) return -1;
            }
            // otherwise say they are equal, which has the effect of sorting on
            // relevance while preserving the original ordering - which is how ties
            // have historically been settled, ie the language that comes first always
            // wins in the case of a tie
            return 0;
        });
        const [best, secondBest] = sorted;
        /** @type {AutoHighlightResult} */ const result = best;
        result.secondBest = secondBest;
        return result;
    }
    /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */ function updateClassName(element, currentLang, resultLang) {
        const language = currentLang && aliases[currentLang] || resultLang;
        element.classList.add("hljs");
        element.classList.add(`language-${language}`);
    }
    /**
   * Applies highlighting to a DOM node containing code.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */ function highlightElement(element) {
        /** @type HTMLElement */ let node = null;
        const language = blockLanguage(element);
        if (shouldNotHighlight(language)) return;
        fire("before:highlightElement", {
            el: element,
            language: language
        });
        if (element.dataset.highlighted) {
            console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", element);
            return;
        }
        // we should be all text, no child nodes (unescaped HTML) - this is possibly
        // an HTML injection attack - it's likely too late if this is already in
        // production (the code has likely already done its damage by the time
        // we're seeing it)... but we yell loudly about this so that hopefully it's
        // more likely to be caught in development before making it to production
        if (element.children.length > 0) {
            if (!options.ignoreUnescapedHTML) {
                console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
                console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
                console.warn("The element with unescaped HTML:");
                console.warn(element);
            }
            if (options.throwUnescapedHTML) {
                const err = new $096de701954268a2$var$HTMLInjectionError("One of your code blocks includes unescaped HTML.", element.innerHTML);
                throw err;
            }
        }
        node = element;
        const text = node.textContent;
        const result = language ? highlight(text, {
            language: language,
            ignoreIllegals: true
        }) : highlightAuto(text);
        element.innerHTML = result.value;
        element.dataset.highlighted = "yes";
        updateClassName(element, language, result.language);
        element.result = {
            language: result.language,
            // TODO: remove with version 11.0
            re: result.relevance,
            relevance: result.relevance
        };
        if (result.secondBest) element.secondBest = {
            language: result.secondBest.language,
            relevance: result.secondBest.relevance
        };
        fire("after:highlightElement", {
            el: element,
            result: result,
            text: text
        });
    }
    /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */ function configure(userOptions) {
        options = $096de701954268a2$var$inherit(options, userOptions);
    }
    // TODO: remove v12, deprecated
    const initHighlighting = ()=>{
        highlightAll();
        $096de701954268a2$var$deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    // TODO: remove v12, deprecated
    function initHighlightingOnLoad() {
        highlightAll();
        $096de701954268a2$var$deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let wantsHighlight = false;
    /**
   * auto-highlights all pre>code elements on the page
   */ function highlightAll() {
        function boot() {
            // if a highlight was requested before DOM was loaded, do now
            highlightAll();
        }
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
            // make sure the event listener is only added once
            if (!wantsHighlight) window.addEventListener('DOMContentLoaded', boot, false);
            wantsHighlight = true;
            return;
        }
        const blocks = document.querySelectorAll(options.cssSelector);
        blocks.forEach(highlightElement);
    }
    /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */ function registerLanguage(languageName, languageDefinition) {
        let lang = null;
        try {
            lang = languageDefinition(hljs);
        } catch (error$1) {
            $096de701954268a2$var$error("Language definition for '{}' could not be registered.".replace("{}", languageName));
            // hard or soft error
            if (!SAFE_MODE) throw error$1;
            else $096de701954268a2$var$error(error$1);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);
        if (lang.aliases) registerAliases(lang.aliases, {
            languageName: languageName
        });
    }
    /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */ function unregisterLanguage(languageName) {
        delete languages[languageName];
        for (const alias of Object.keys(aliases))if (aliases[alias] === languageName) delete aliases[alias];
    }
    /**
   * @returns {string[]} List of language internal names
   */ function listLanguages() {
        return Object.keys(languages);
    }
    /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */ function getLanguage(name) {
        name = (name || '').toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */ function registerAliases(aliasList, { languageName: languageName }) {
        if (typeof aliasList === 'string') aliasList = [
            aliasList
        ];
        aliasList.forEach((alias)=>{
            aliases[alias.toLowerCase()] = languageName;
        });
    }
    /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */ function autoDetection(name) {
        const lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */ function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) plugin["before:highlightElement"] = (data)=>{
            plugin["before:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) plugin["after:highlightElement"] = (data)=>{
            plugin["after:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function removePlugin(plugin) {
        const index = plugins.indexOf(plugin);
        if (index !== -1) plugins.splice(index, 1);
    }
    /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */ function fire(event, args) {
        const cb = event;
        plugins.forEach(function(plugin) {
            if (plugin[cb]) plugin[cb](args);
        });
    }
    /**
   * DEPRECATED
   * @param {HighlightedHTMLElement} el
   */ function deprecateHighlightBlock(el) {
        $096de701954268a2$var$deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        $096de701954268a2$var$deprecated("10.7.0", "Please use highlightElement now.");
        return highlightElement(el);
    }
    /* Interface definition */ Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        autoDetection: autoDetection,
        inherit: $096de701954268a2$var$inherit,
        addPlugin: addPlugin,
        removePlugin: removePlugin
    });
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    hljs.safeMode = function() {
        SAFE_MODE = true;
    };
    hljs.versionString = $096de701954268a2$var$version;
    hljs.regex = {
        concat: $096de701954268a2$var$concat,
        lookahead: $096de701954268a2$var$lookahead,
        either: $096de701954268a2$var$either,
        optional: $096de701954268a2$var$optional,
        anyNumberOfTimes: $096de701954268a2$var$anyNumberOfTimes
    };
    for(const key in $096de701954268a2$var$MODES)// @ts-ignore
    if (typeof $096de701954268a2$var$MODES[key] === "object") // @ts-ignore
    $096de701954268a2$var$deepFreeze($096de701954268a2$var$MODES[key]);
    // merge all the modes/regexes into our main object
    Object.assign(hljs, $096de701954268a2$var$MODES);
    return hljs;
};
// Other names for the variable may break build script
const $096de701954268a2$var$highlight = $096de701954268a2$var$HLJS({});
// returns a new instance of the highlighter to be used for extensions
// check https://github.com/wooorm/lowlight/issues/47
$096de701954268a2$var$highlight.newInstance = ()=>$096de701954268a2$var$HLJS({});
$096de701954268a2$exports = $096de701954268a2$var$highlight;
$096de701954268a2$var$highlight.HighlightJS = $096de701954268a2$var$highlight;
$096de701954268a2$var$highlight.default = $096de701954268a2$var$highlight;


var $c68f397613df4d31$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($096de701954268a2$exports)));


/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common, scripting
*/ /** @type LanguageFn */ function $cb37c5af6f7deacf$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const VAR = {};
    const BRACED_VAR = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    VAR
                ]
            } // default values
        ]
    };
    Object.assign(VAR, {
        className: 'variable',
        variants: [
            {
                begin: regex.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![\\w\\d])(?![$])`)
            },
            BRACED_VAR
        ]
    });
    const SUBST = {
        className: 'subst',
        begin: /\$\(/,
        end: /\)/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const COMMENT = hljs.inherit(hljs.COMMENT(), {
        match: [
            /(^|\s)/,
            /#.*$/
        ],
        scope: {
            2: 'comment'
        }
    });
    const HERE_DOC = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                hljs.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: 'string'
                })
            ]
        }
    };
    const QUOTE_STRING = {
        className: 'string',
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            SUBST
        ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
        match: /\\"/
    };
    const APOS_STRING = {
        className: 'string',
        begin: /'/,
        end: /'/
    };
    const ESCAPED_APOS = {
        match: /\\'/
    };
    const ARITHMETIC = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            hljs.NUMBER_MODE,
            VAR
        ]
    };
    const SH_LIKE_SHELLS = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
        binary: `(${SH_LIKE_SHELLS.join("|")})`,
        relevance: 10
    });
    const FUNCTION = {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    };
    const KEYWORDS = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "time",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "coproc",
        "function",
        "select"
    ];
    const LITERALS = [
        "true",
        "false"
    ];
    // to consume paths to prevent keyword matches inside them
    const PATH_MODE = {
        match: /(\/[a-z._-]+)+/
    };
    // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
    const SHELL_BUILT_INS = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ];
    const BASH_BUILT_INS = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "sudo",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ];
    const ZSH_BUILT_INS = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ];
    const GNU_CORE_UTILS = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: 'Bash',
        aliases: [
            'sh',
            'zsh'
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: [
                ...SHELL_BUILT_INS,
                ...BASH_BUILT_INS,
                // Shell modifiers
                "set",
                "shopt",
                ...ZSH_BUILT_INS,
                ...GNU_CORE_UTILS
            ]
        },
        contains: [
            KNOWN_SHEBANG,
            hljs.SHEBANG(),
            FUNCTION,
            ARITHMETIC,
            COMMENT,
            HERE_DOC,
            PATH_MODE,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            ESCAPED_APOS,
            VAR
        ]
    };
}


const $2a3933687d11bb55$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            scope: 'meta',
            begin: '!important'
        },
        BLOCK_COMMENT: hljs.C_BLOCK_COMMENT_MODE,
        HEXCOLOR: {
            scope: 'number',
            begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
        },
        FUNCTION_DISPATCH: {
            className: "built_in",
            begin: /[\w-]+(?=\()/
        },
        ATTRIBUTE_SELECTOR_MODE: {
            scope: 'selector-attr',
            begin: /\[/,
            end: /\]/,
            illegal: '$',
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        },
        CSS_NUMBER_MODE: {
            scope: 'number',
            begin: hljs.NUMBER_RE + '(' + '%|em|ex|ch|rem' + '|vw|vh|vmin|vmax' + '|cm|mm|in|pt|pc|px' + '|deg|grad|rad|turn' + '|s|ms' + '|Hz|kHz' + '|dpi|dpcm|dppx' + ')?',
            relevance: 0
        },
        CSS_VARIABLE: {
            className: "attr",
            begin: /--[A-Za-z_][A-Za-z0-9_-]*/
        }
    };
};
const $2a3933687d11bb55$var$HTML_TAGS = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'dd',
    'del',
    'details',
    'dfn',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'mark',
    'menu',
    'nav',
    'object',
    'ol',
    'optgroup',
    'option',
    'p',
    'picture',
    'q',
    'quote',
    'samp',
    'section',
    'select',
    'source',
    'span',
    'strong',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'ul',
    'var',
    'video'
];
const $2a3933687d11bb55$var$SVG_TAGS = [
    'defs',
    'g',
    'marker',
    'mask',
    'pattern',
    'svg',
    'switch',
    'symbol',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feFlood',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMorphology',
    'feOffset',
    'feSpecularLighting',
    'feTile',
    'feTurbulence',
    'linearGradient',
    'radialGradient',
    'stop',
    'circle',
    'ellipse',
    'image',
    'line',
    'path',
    'polygon',
    'polyline',
    'rect',
    'text',
    'use',
    'textPath',
    'tspan',
    'foreignObject',
    'clipPath'
];
const $2a3933687d11bb55$var$TAGS = [
    ...$2a3933687d11bb55$var$HTML_TAGS,
    ...$2a3933687d11bb55$var$SVG_TAGS
];
// Sorting, then reversing makes sure longer attributes/elements like
// `font-weight` are matched fully instead of getting false positives on say `font`
const $2a3933687d11bb55$var$MEDIA_FEATURES = [
    'any-hover',
    'any-pointer',
    'aspect-ratio',
    'color',
    'color-gamut',
    'color-index',
    'device-aspect-ratio',
    'device-height',
    'device-width',
    'display-mode',
    'forced-colors',
    'grid',
    'height',
    'hover',
    'inverted-colors',
    'monochrome',
    'orientation',
    'overflow-block',
    'overflow-inline',
    'pointer',
    'prefers-color-scheme',
    'prefers-contrast',
    'prefers-reduced-motion',
    'prefers-reduced-transparency',
    'resolution',
    'scan',
    'scripting',
    'update',
    'width',
    // TODO: find a better solution?
    'min-width',
    'max-width',
    'min-height',
    'max-height'
].sort().reverse();
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $2a3933687d11bb55$var$PSEUDO_CLASSES = [
    'active',
    'any-link',
    'blank',
    'checked',
    'current',
    'default',
    'defined',
    'dir',
    'disabled',
    'drop',
    'empty',
    'enabled',
    'first',
    'first-child',
    'first-of-type',
    'fullscreen',
    'future',
    'focus',
    'focus-visible',
    'focus-within',
    'has',
    'host',
    'host-context',
    'hover',
    'indeterminate',
    'in-range',
    'invalid',
    'is',
    'lang',
    'last-child',
    'last-of-type',
    'left',
    'link',
    'local-link',
    'not',
    'nth-child',
    'nth-col',
    'nth-last-child',
    'nth-last-col',
    'nth-last-of-type',
    'nth-of-type',
    'only-child',
    'only-of-type',
    'optional',
    'out-of-range',
    'past',
    'placeholder-shown',
    'read-only',
    'read-write',
    'required',
    'right',
    'root',
    'scope',
    'target',
    'target-within',
    'user-invalid',
    'valid',
    'visited',
    'where' // where()
].sort().reverse();
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $2a3933687d11bb55$var$PSEUDO_ELEMENTS = [
    'after',
    'backdrop',
    'before',
    'cue',
    'cue-region',
    'first-letter',
    'first-line',
    'grammar-error',
    'marker',
    'part',
    'placeholder',
    'selection',
    'slotted',
    'spelling-error'
].sort().reverse();
const $2a3933687d11bb55$var$ATTRIBUTES = [
    'accent-color',
    'align-content',
    'align-items',
    'align-self',
    'alignment-baseline',
    'all',
    'anchor-name',
    'animation',
    'animation-composition',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-range',
    'animation-range-end',
    'animation-range-start',
    'animation-timeline',
    'animation-timing-function',
    'appearance',
    'aspect-ratio',
    'backdrop-filter',
    'backface-visibility',
    'background',
    'background-attachment',
    'background-blend-mode',
    'background-clip',
    'background-color',
    'background-image',
    'background-origin',
    'background-position',
    'background-position-x',
    'background-position-y',
    'background-repeat',
    'background-size',
    'baseline-shift',
    'block-size',
    'border',
    'border-block',
    'border-block-color',
    'border-block-end',
    'border-block-end-color',
    'border-block-end-style',
    'border-block-end-width',
    'border-block-start',
    'border-block-start-color',
    'border-block-start-style',
    'border-block-start-width',
    'border-block-style',
    'border-block-width',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-end-end-radius',
    'border-end-start-radius',
    'border-image',
    'border-image-outset',
    'border-image-repeat',
    'border-image-slice',
    'border-image-source',
    'border-image-width',
    'border-inline',
    'border-inline-color',
    'border-inline-end',
    'border-inline-end-color',
    'border-inline-end-style',
    'border-inline-end-width',
    'border-inline-start',
    'border-inline-start-color',
    'border-inline-start-style',
    'border-inline-start-width',
    'border-inline-style',
    'border-inline-width',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-start-end-radius',
    'border-start-start-radius',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'bottom',
    'box-align',
    'box-decoration-break',
    'box-direction',
    'box-flex',
    'box-flex-group',
    'box-lines',
    'box-ordinal-group',
    'box-orient',
    'box-pack',
    'box-shadow',
    'box-sizing',
    'break-after',
    'break-before',
    'break-inside',
    'caption-side',
    'caret-color',
    'clear',
    'clip',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'color-scheme',
    'column-count',
    'column-fill',
    'column-gap',
    'column-rule',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-span',
    'column-width',
    'columns',
    'contain',
    'contain-intrinsic-block-size',
    'contain-intrinsic-height',
    'contain-intrinsic-inline-size',
    'contain-intrinsic-size',
    'contain-intrinsic-width',
    'container',
    'container-name',
    'container-type',
    'content',
    'content-visibility',
    'counter-increment',
    'counter-reset',
    'counter-set',
    'cue',
    'cue-after',
    'cue-before',
    'cursor',
    'cx',
    'cy',
    'direction',
    'display',
    'dominant-baseline',
    'empty-cells',
    'enable-background',
    'field-sizing',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'flex',
    'flex-basis',
    'flex-direction',
    'flex-flow',
    'flex-grow',
    'flex-shrink',
    'flex-wrap',
    'float',
    'flood-color',
    'flood-opacity',
    'flow',
    'font',
    'font-display',
    'font-family',
    'font-feature-settings',
    'font-kerning',
    'font-language-override',
    'font-optical-sizing',
    'font-palette',
    'font-size',
    'font-size-adjust',
    'font-smooth',
    'font-smoothing',
    'font-stretch',
    'font-style',
    'font-synthesis',
    'font-synthesis-position',
    'font-synthesis-small-caps',
    'font-synthesis-style',
    'font-synthesis-weight',
    'font-variant',
    'font-variant-alternates',
    'font-variant-caps',
    'font-variant-east-asian',
    'font-variant-emoji',
    'font-variant-ligatures',
    'font-variant-numeric',
    'font-variant-position',
    'font-variation-settings',
    'font-weight',
    'forced-color-adjust',
    'gap',
    'glyph-orientation-horizontal',
    'glyph-orientation-vertical',
    'grid',
    'grid-area',
    'grid-auto-columns',
    'grid-auto-flow',
    'grid-auto-rows',
    'grid-column',
    'grid-column-end',
    'grid-column-start',
    'grid-gap',
    'grid-row',
    'grid-row-end',
    'grid-row-start',
    'grid-template',
    'grid-template-areas',
    'grid-template-columns',
    'grid-template-rows',
    'hanging-punctuation',
    'height',
    'hyphenate-character',
    'hyphenate-limit-chars',
    'hyphens',
    'icon',
    'image-orientation',
    'image-rendering',
    'image-resolution',
    'ime-mode',
    'initial-letter',
    'initial-letter-align',
    'inline-size',
    'inset',
    'inset-area',
    'inset-block',
    'inset-block-end',
    'inset-block-start',
    'inset-inline',
    'inset-inline-end',
    'inset-inline-start',
    'isolation',
    'justify-content',
    'justify-items',
    'justify-self',
    'kerning',
    'left',
    'letter-spacing',
    'lighting-color',
    'line-break',
    'line-height',
    'line-height-step',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-block',
    'margin-block-end',
    'margin-block-start',
    'margin-bottom',
    'margin-inline',
    'margin-inline-end',
    'margin-inline-start',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-trim',
    'marker',
    'marker-end',
    'marker-mid',
    'marker-start',
    'marks',
    'mask',
    'mask-border',
    'mask-border-mode',
    'mask-border-outset',
    'mask-border-repeat',
    'mask-border-slice',
    'mask-border-source',
    'mask-border-width',
    'mask-clip',
    'mask-composite',
    'mask-image',
    'mask-mode',
    'mask-origin',
    'mask-position',
    'mask-repeat',
    'mask-size',
    'mask-type',
    'masonry-auto-flow',
    'math-depth',
    'math-shift',
    'math-style',
    'max-block-size',
    'max-height',
    'max-inline-size',
    'max-width',
    'min-block-size',
    'min-height',
    'min-inline-size',
    'min-width',
    'mix-blend-mode',
    'nav-down',
    'nav-index',
    'nav-left',
    'nav-right',
    'nav-up',
    'none',
    'normal',
    'object-fit',
    'object-position',
    'offset',
    'offset-anchor',
    'offset-distance',
    'offset-path',
    'offset-position',
    'offset-rotate',
    'opacity',
    'order',
    'orphans',
    'outline',
    'outline-color',
    'outline-offset',
    'outline-style',
    'outline-width',
    'overflow',
    'overflow-anchor',
    'overflow-block',
    'overflow-clip-margin',
    'overflow-inline',
    'overflow-wrap',
    'overflow-x',
    'overflow-y',
    'overlay',
    'overscroll-behavior',
    'overscroll-behavior-block',
    'overscroll-behavior-inline',
    'overscroll-behavior-x',
    'overscroll-behavior-y',
    'padding',
    'padding-block',
    'padding-block-end',
    'padding-block-start',
    'padding-bottom',
    'padding-inline',
    'padding-inline-end',
    'padding-inline-start',
    'padding-left',
    'padding-right',
    'padding-top',
    'page',
    'page-break-after',
    'page-break-before',
    'page-break-inside',
    'paint-order',
    'pause',
    'pause-after',
    'pause-before',
    'perspective',
    'perspective-origin',
    'place-content',
    'place-items',
    'place-self',
    'pointer-events',
    'position',
    'position-anchor',
    'position-visibility',
    'print-color-adjust',
    'quotes',
    'r',
    'resize',
    'rest',
    'rest-after',
    'rest-before',
    'right',
    'rotate',
    'row-gap',
    'ruby-align',
    'ruby-position',
    'scale',
    'scroll-behavior',
    'scroll-margin',
    'scroll-margin-block',
    'scroll-margin-block-end',
    'scroll-margin-block-start',
    'scroll-margin-bottom',
    'scroll-margin-inline',
    'scroll-margin-inline-end',
    'scroll-margin-inline-start',
    'scroll-margin-left',
    'scroll-margin-right',
    'scroll-margin-top',
    'scroll-padding',
    'scroll-padding-block',
    'scroll-padding-block-end',
    'scroll-padding-block-start',
    'scroll-padding-bottom',
    'scroll-padding-inline',
    'scroll-padding-inline-end',
    'scroll-padding-inline-start',
    'scroll-padding-left',
    'scroll-padding-right',
    'scroll-padding-top',
    'scroll-snap-align',
    'scroll-snap-stop',
    'scroll-snap-type',
    'scroll-timeline',
    'scroll-timeline-axis',
    'scroll-timeline-name',
    'scrollbar-color',
    'scrollbar-gutter',
    'scrollbar-width',
    'shape-image-threshold',
    'shape-margin',
    'shape-outside',
    'shape-rendering',
    'speak',
    'speak-as',
    'src',
    'stop-color',
    'stop-opacity',
    'stroke',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'tab-size',
    'table-layout',
    'text-align',
    'text-align-all',
    'text-align-last',
    'text-anchor',
    'text-combine-upright',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-skip',
    'text-decoration-skip-ink',
    'text-decoration-style',
    'text-decoration-thickness',
    'text-emphasis',
    'text-emphasis-color',
    'text-emphasis-position',
    'text-emphasis-style',
    'text-indent',
    'text-justify',
    'text-orientation',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-size-adjust',
    'text-transform',
    'text-underline-offset',
    'text-underline-position',
    'text-wrap',
    'text-wrap-mode',
    'text-wrap-style',
    'timeline-scope',
    'top',
    'touch-action',
    'transform',
    'transform-box',
    'transform-origin',
    'transform-style',
    'transition',
    'transition-behavior',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'translate',
    'unicode-bidi',
    'user-modify',
    'user-select',
    'vector-effect',
    'vertical-align',
    'view-timeline',
    'view-timeline-axis',
    'view-timeline-inset',
    'view-timeline-name',
    'view-transition-name',
    'visibility',
    'voice-balance',
    'voice-duration',
    'voice-family',
    'voice-pitch',
    'voice-range',
    'voice-rate',
    'voice-stress',
    'voice-volume',
    'white-space',
    'white-space-collapse',
    'widows',
    'width',
    'will-change',
    'word-break',
    'word-spacing',
    'word-wrap',
    'writing-mode',
    'x',
    'y',
    'z-index',
    'zoom'
].sort().reverse();
/*
Language: CSS
Category: common, css, web
Website: https://developer.mozilla.org/en-US/docs/Web/CSS
*/ /** @type LanguageFn */ function $2a3933687d11bb55$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const modes = $2a3933687d11bb55$var$MODES(hljs);
    const VENDOR_PREFIX = {
        begin: /-(webkit|moz|ms|o)-(?=[a-z])/
    };
    const AT_MODIFIERS = "and or not only";
    const AT_PROPERTY_RE = /@-?\w[\w]*(-\w+)*/; // @-webkit-keyframes
    const IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
    const STRINGS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ];
    return {
        name: 'CSS',
        case_insensitive: true,
        illegal: /[=|'\$]/,
        keywords: {
            keyframePosition: "from to"
        },
        classNameAliases: {
            // for visual continuity with `tag {}` and because we
            // don't have a great class for this?
            keyframePosition: "selector-tag"
        },
        contains: [
            modes.BLOCK_COMMENT,
            VENDOR_PREFIX,
            // to recognize keyframe 40% etc which are outside the scope of our
            // attribute value mode
            modes.CSS_NUMBER_MODE,
            {
                className: 'selector-id',
                begin: /#[A-Za-z0-9_-]+/,
                relevance: 0
            },
            {
                className: 'selector-class',
                begin: '\\.' + IDENT_RE,
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: 'selector-pseudo',
                variants: [
                    {
                        begin: ':(' + $2a3933687d11bb55$var$PSEUDO_CLASSES.join('|') + ')'
                    },
                    {
                        begin: ':(:)?(' + $2a3933687d11bb55$var$PSEUDO_ELEMENTS.join('|') + ')'
                    }
                ]
            },
            // we may actually need this (12/2020)
            // { // pseudo-selector params
            //   begin: /\(/,
            //   end: /\)/,
            //   contains: [ hljs.CSS_NUMBER_MODE ]
            // },
            modes.CSS_VARIABLE,
            {
                className: 'attribute',
                begin: '\\b(' + $2a3933687d11bb55$var$ATTRIBUTES.join('|') + ')\\b'
            },
            // attribute values
            {
                begin: /:/,
                end: /[;}{]/,
                contains: [
                    modes.BLOCK_COMMENT,
                    modes.HEXCOLOR,
                    modes.IMPORTANT,
                    modes.CSS_NUMBER_MODE,
                    ...STRINGS,
                    // needed to highlight these as strings and to avoid issues with
                    // illegal characters that might be inside urls that would tigger the
                    // languages illegal stack
                    {
                        begin: /(url|data-uri)\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: {
                            built_in: "url data-uri"
                        },
                        contains: [
                            ...STRINGS,
                            {
                                className: "string",
                                // any character other than `)` as in `url()` will be the start
                                // of a string, which ends with `)` (from the parent mode)
                                begin: /[^)]/,
                                endsWithParent: true,
                                excludeEnd: true
                            }
                        ]
                    },
                    modes.FUNCTION_DISPATCH
                ]
            },
            {
                begin: regex.lookahead(/@/),
                end: '[{;]',
                relevance: 0,
                illegal: /:/,
                contains: [
                    {
                        className: 'keyword',
                        begin: AT_PROPERTY_RE
                    },
                    {
                        begin: /\s/,
                        endsWithParent: true,
                        excludeEnd: true,
                        relevance: 0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: AT_MODIFIERS,
                            attribute: $2a3933687d11bb55$var$MEDIA_FEATURES.join(" ")
                        },
                        contains: [
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: "attribute"
                            },
                            ...STRINGS,
                            modes.CSS_NUMBER_MODE
                        ]
                    }
                ]
            },
            {
                className: 'selector-tag',
                begin: '\\b(' + $2a3933687d11bb55$var$TAGS.join('|') + ')\\b'
            }
        ]
    };
}


const $492389ce22d189c0$var$IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const $492389ce22d189c0$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends",
    // It's reached stage 3, which is "recommended for implementation":
    "using"
];
const $492389ce22d189c0$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $492389ce22d189c0$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $492389ce22d189c0$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $492389ce22d189c0$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $492389ce22d189c0$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $492389ce22d189c0$var$BUILT_INS = [].concat($492389ce22d189c0$var$BUILT_IN_GLOBALS, $492389ce22d189c0$var$TYPES, $492389ce22d189c0$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $492389ce22d189c0$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $492389ce22d189c0$var$IDENT_RE;
    const FRAGMENT = {
        begin: '<>',
        end: '</>'
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $492389ce22d189c0$var$IDENT_RE,
        keyword: $492389ce22d189c0$var$KEYWORDS,
        literal: $492389ce22d189c0$var$LITERALS,
        built_in: $492389ce22d189c0$var$BUILT_INS,
        "variable.language": $492389ce22d189c0$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = '[0-9](_?[0-9])*';
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: 'number',
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}',
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: '\.?html`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'xml'
        }
    };
    const CSS_TEMPLATE = {
        begin: '\.?css`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'css'
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: '\.?gql`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'graphql'
        }
    };
    const TEMPLATE_STRING = {
        className: 'string',
        begin: '`',
        end: '`',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
        relevance: 0,
        contains: [
            {
                begin: '(?=@[A-Za-z]+)',
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    },
                    {
                        className: 'type',
                        begin: '\\{',
                        end: '\\}',
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: 'variable',
                        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /(\s*)\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: 'params',
        // convert this to negative lookbehind in v12
        begin: /(\s*)\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$492389ce22d189c0$var$TYPES,
                ...$492389ce22d189c0$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$492389ce22d189c0$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ].map((x)=>`${x}\\s*\\(`)), IDENT_RE$1, regex.lookahead(/\s*\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: 'JavaScript',
        aliases: [
            'js',
            'jsx',
            'mjs',
            'cjs'
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                scope: 'attr',
                match: IDENT_RE$1 + regex.lookahead(':'),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
                keywords: 'return throw case',
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: 'function',
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: '\\s*=>',
                        contains: [
                            {
                                className: 'params',
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /(\s*)\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                'on:begin': XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: 'xml',
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    'self'
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
                '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: '\\$' + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}


/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: http://www.json.org
Category: common, protocols, web
*/ function $b43b096b944cdbed$export$2e2bcd8739ae039(hljs) {
    const ATTRIBUTE = {
        className: 'attr',
        begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
        relevance: 1.01
    };
    const PUNCTUATION = {
        match: /[{}[\],:]/,
        className: "punctuation",
        relevance: 0
    };
    const LITERALS = [
        "true",
        "false",
        "null"
    ];
    // NOTE: normally we would rely on `keywords` for this but using a mode here allows us
    // - to use the very tight `illegal: \S` rule later to flag any other character
    // - as illegal indicating that despite looking like JSON we do not truly have
    // - JSON and thus improve false-positively greatly since JSON will try and claim
    // - all sorts of JSON looking stuff
    const LITERALS_MODE = {
        scope: "literal",
        beginKeywords: LITERALS.join(" ")
    };
    return {
        name: 'JSON',
        aliases: [
            'jsonc'
        ],
        keywords: {
            literal: LITERALS
        },
        contains: [
            ATTRIBUTE,
            PUNCTUATION,
            hljs.QUOTE_STRING_MODE,
            LITERALS_MODE,
            hljs.C_NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ],
        illegal: '\\S'
    };
}


/*
Language: Markdown
Requires: xml.js
Author: John Crepezzi <john.crepezzi@gmail.com>
Website: https://daringfireball.net/projects/markdown/
Category: common, markup
*/ function $551e005fa09f7536$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const INLINE_HTML = {
        begin: /<\/?[A-Za-z_]/,
        end: '>',
        subLanguage: 'xml',
        relevance: 0
    };
    const HORIZONTAL_RULE = {
        begin: '^[-\\*]{3,}',
        end: '$'
    };
    const CODE = {
        className: 'code',
        variants: [
            // TODO: fix to allow these to work with sublanguage also
            {
                begin: '(`{3,})[^`](.|\\n)*?\\1`*[ ]*'
            },
            {
                begin: '(~{3,})[^~](.|\\n)*?\\1~*[ ]*'
            },
            // needed to allow markdown as a sublanguage to work
            {
                begin: '```',
                end: '```+[ ]*$'
            },
            {
                begin: '~~~',
                end: '~~~+[ ]*$'
            },
            {
                begin: '`.+?`'
            },
            {
                begin: '(?=^( {4}|\\t))',
                // use contains to gobble up multiple lines to allow the block to be whatever size
                // but only have a single open/close tag vs one per line
                contains: [
                    {
                        begin: '^( {4}|\\t)',
                        end: '(\\n)$'
                    }
                ],
                relevance: 0
            }
        ]
    };
    const LIST = {
        className: 'bullet',
        begin: '^[ \t]*([*+-]|(\\d+\\.))(?=\\s+)',
        end: '\\s+',
        excludeEnd: true
    };
    const LINK_REFERENCE = {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
            {
                className: 'symbol',
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: 'link',
                begin: /:\s*/,
                end: /$/,
                excludeBegin: true
            }
        ]
    };
    const URL_SCHEME = /[A-Za-z][A-Za-z0-9+.-]*/;
    const LINK = {
        variants: [
            // too much like nested array access in so many languages
            // to have any real relevance
            {
                begin: /\[.+?\]\[.*?\]/,
                relevance: 0
            },
            // popular internet URLs
            {
                begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
                relevance: 2
            },
            {
                begin: regex.concat(/\[.+?\]\(/, URL_SCHEME, /:\/\/.*?\)/),
                relevance: 2
            },
            // relative urls
            {
                begin: /\[.+?\]\([./?&#].*?\)/,
                relevance: 1
            },
            // whatever else, lower relevance (might not be a link at all)
            {
                begin: /\[.*?\]\(.*?\)/,
                relevance: 0
            }
        ],
        returnBegin: true,
        contains: [
            {
                // empty strings for alt or link text
                match: /\[(?=\])/
            },
            {
                className: 'string',
                relevance: 0,
                begin: '\\[',
                end: '\\]',
                excludeBegin: true,
                returnEnd: true
            },
            {
                className: 'link',
                relevance: 0,
                begin: '\\]\\(',
                end: '\\)',
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: 'symbol',
                relevance: 0,
                begin: '\\]\\[',
                end: '\\]',
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
    const BOLD = {
        className: 'strong',
        contains: [],
        variants: [
            {
                begin: /_{2}(?!\s)/,
                end: /_{2}/
            },
            {
                begin: /\*{2}(?!\s)/,
                end: /\*{2}/
            }
        ]
    };
    const ITALIC = {
        className: 'emphasis',
        contains: [],
        variants: [
            {
                begin: /\*(?![*\s])/,
                end: /\*/
            },
            {
                begin: /_(?![_\s])/,
                end: /_/,
                relevance: 0
            }
        ]
    };
    // 3 level deep nesting is not allowed because it would create confusion
    // in cases like `***testing***` because where we don't know if the last
    // `***` is starting a new bold/italic or finishing the last one
    const BOLD_WITHOUT_ITALIC = hljs.inherit(BOLD, {
        contains: []
    });
    const ITALIC_WITHOUT_BOLD = hljs.inherit(ITALIC, {
        contains: []
    });
    BOLD.contains.push(ITALIC_WITHOUT_BOLD);
    ITALIC.contains.push(BOLD_WITHOUT_ITALIC);
    let CONTAINABLE = [
        INLINE_HTML,
        LINK
    ];
    [
        BOLD,
        ITALIC,
        BOLD_WITHOUT_ITALIC,
        ITALIC_WITHOUT_BOLD
    ].forEach((m)=>{
        m.contains = m.contains.concat(CONTAINABLE);
    });
    CONTAINABLE = CONTAINABLE.concat(BOLD, ITALIC);
    const HEADER = {
        className: 'section',
        variants: [
            {
                begin: '^#{1,6}',
                end: '$',
                contains: CONTAINABLE
            },
            {
                begin: '(?=^.+?\\n[=-]{2,}$)',
                contains: [
                    {
                        begin: '^[=-]*$'
                    },
                    {
                        begin: '^',
                        end: "\\n",
                        contains: CONTAINABLE
                    }
                ]
            }
        ]
    };
    const BLOCKQUOTE = {
        className: 'quote',
        begin: '^>\\s+',
        contains: CONTAINABLE,
        end: '$'
    };
    const ENTITY = {
        //https://spec.commonmark.org/0.31.2/#entity-references
        scope: 'literal',
        match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/
    };
    return {
        name: 'Markdown',
        aliases: [
            'md',
            'mkdown',
            'mkd'
        ],
        contains: [
            HEADER,
            INLINE_HTML,
            LIST,
            BOLD,
            ITALIC,
            BLOCKQUOTE,
            CODE,
            HORIZONTAL_RULE,
            LINK,
            LINK_REFERENCE,
            ENTITY
        ]
    };
}


/*
Language: Python
Description: Python is an interpreted, object-oriented, high-level programming language with dynamic semantics.
Website: https://www.python.org
Category: common
*/ function $d39b89a63fc49297$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const IDENT_RE = /[\p{XID_Start}_]\p{XID_Continue}*/u;
    const RESERVED_WORDS = [
        'and',
        'as',
        'assert',
        'async',
        'await',
        'break',
        'case',
        'class',
        'continue',
        'def',
        'del',
        'elif',
        'else',
        'except',
        'finally',
        'for',
        'from',
        'global',
        'if',
        'import',
        'in',
        'is',
        'lambda',
        'match',
        'nonlocal|10',
        'not',
        'or',
        'pass',
        'raise',
        'return',
        'try',
        'while',
        'with',
        'yield'
    ];
    const BUILT_INS = [
        '__import__',
        'abs',
        'all',
        'any',
        'ascii',
        'bin',
        'bool',
        'breakpoint',
        'bytearray',
        'bytes',
        'callable',
        'chr',
        'classmethod',
        'compile',
        'complex',
        'delattr',
        'dict',
        'dir',
        'divmod',
        'enumerate',
        'eval',
        'exec',
        'filter',
        'float',
        'format',
        'frozenset',
        'getattr',
        'globals',
        'hasattr',
        'hash',
        'help',
        'hex',
        'id',
        'input',
        'int',
        'isinstance',
        'issubclass',
        'iter',
        'len',
        'list',
        'locals',
        'map',
        'max',
        'memoryview',
        'min',
        'next',
        'object',
        'oct',
        'open',
        'ord',
        'pow',
        'print',
        'property',
        'range',
        'repr',
        'reversed',
        'round',
        'set',
        'setattr',
        'slice',
        'sorted',
        'staticmethod',
        'str',
        'sum',
        'super',
        'tuple',
        'type',
        'vars',
        'zip'
    ];
    const LITERALS = [
        '__debug__',
        'Ellipsis',
        'False',
        'None',
        'NotImplemented',
        'True'
    ];
    // https://docs.python.org/3/library/typing.html
    // TODO: Could these be supplemented by a CamelCase matcher in certain
    // contexts, leaving these remaining only for relevance hinting?
    const TYPES = [
        "Any",
        "Callable",
        "Coroutine",
        "Dict",
        "List",
        "Literal",
        "Generic",
        "Optional",
        "Sequence",
        "Set",
        "Tuple",
        "Type",
        "Union"
    ];
    const KEYWORDS = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: RESERVED_WORDS,
        built_in: BUILT_INS,
        literal: LITERALS,
        type: TYPES
    };
    const PROMPT = {
        className: 'meta',
        begin: /^(>>>|\.\.\.) /
    };
    const SUBST = {
        className: 'subst',
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS,
        illegal: /#/
    };
    const LITERAL_BRACKET = {
        begin: /\{\{/,
        relevance: 0
    };
    const STRING = {
        className: 'string',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'/,
                end: /'/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    // https://docs.python.org/3.9/reference/lexical_analysis.html#numeric-literals
    const digitpart = '[0-9](_?[0-9])*';
    const pointfloat = `(\\b(${digitpart}))?\\.(${digitpart})|\\b(${digitpart})\\.`;
    // Whitespace after a number (or any lexical token) is needed only if its absence
    // would change the tokenization
    // https://docs.python.org/3.9/reference/lexical_analysis.html#whitespace-between-tokens
    // We deviate slightly, requiring a word boundary or a keyword
    // to avoid accidentally recognizing *prefixes* (e.g., `0` in `0x41` or `08` or `0__1`)
    const lookahead = `\\b|${RESERVED_WORDS.join('|')}`;
    const NUMBER = {
        className: 'number',
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: `(\\b(${digitpart})|(${pointfloat}))[eE][+-]?(${digitpart})[jJ]?(?=${lookahead})`
            },
            {
                begin: `(${pointfloat})[jJ]?`
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${lookahead})`
            },
            {
                begin: `\\b0[bB](_?[01])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[oO](_?[0-7])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${lookahead})`
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b(${digitpart})[jJ](?=${lookahead})`
            }
        ]
    };
    const COMMENT_TYPE = {
        className: "comment",
        begin: regex.lookahead(/# type:/),
        end: /$/,
        keywords: KEYWORDS,
        contains: [
            {
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: true
            }
        ]
    };
    const PARAMS = {
        className: 'params',
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: true
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    'self',
                    PROMPT,
                    NUMBER,
                    STRING,
                    hljs.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    SUBST.contains = [
        STRING,
        NUMBER,
        PROMPT
    ];
    return {
        name: 'Python',
        aliases: [
            'py',
            'gyp',
            'ipython'
        ],
        unicodeRegex: true,
        keywords: KEYWORDS,
        illegal: /(<\/|\?)|=>/,
        contains: [
            PROMPT,
            NUMBER,
            {
                // very common convention
                scope: 'variable.language',
                match: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            {
                match: /\bor\b/,
                scope: "keyword"
            },
            STRING,
            COMMENT_TYPE,
            hljs.HASH_COMMENT_MODE,
            {
                match: [
                    /\bdef/,
                    /\s+/,
                    IDENT_RE
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            {
                variants: [
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE,
                            /\s*/,
                            /\(\s*/,
                            IDENT_RE,
                            /\s*\)/
                        ]
                    },
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE
                        ]
                    }
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    6: "title.class.inherited"
                }
            },
            {
                className: 'meta',
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    NUMBER,
                    PARAMS,
                    STRING
                ]
            }
        ]
    };
}


/*
 Language: SQL
 Website: https://en.wikipedia.org/wiki/SQL
 Category: common, database
 */ /*

Goals:

SQL is intended to highlight basic/common SQL keywords and expressions

- If pretty much every single SQL server includes supports, then it's a canidate.
- It is NOT intended to include tons of vendor specific keywords (Oracle, MySQL,
  PostgreSQL) although the list of data types is purposely a bit more expansive.
- For more specific SQL grammars please see:
  - PostgreSQL and PL/pgSQL - core
  - T-SQL - https://github.com/highlightjs/highlightjs-tsql
  - sql_more (core)

 */ function $f00738a6b250c946$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const COMMENT_MODE = hljs.COMMENT('--', '$');
    const STRING = {
        scope: 'string',
        variants: [
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        match: /''/
                    }
                ]
            }
        ]
    };
    const QUOTED_IDENTIFIER = {
        begin: /"/,
        end: /"/,
        contains: [
            {
                match: /""/
            }
        ]
    };
    const LITERALS = [
        "true",
        "false",
        // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
        // "null",
        "unknown"
    ];
    const MULTI_WORD_TYPES = [
        "double precision",
        "large object",
        "with timezone",
        "without timezone"
    ];
    const TYPES = [
        'bigint',
        'binary',
        'blob',
        'boolean',
        'char',
        'character',
        'clob',
        'date',
        'dec',
        'decfloat',
        'decimal',
        'float',
        'int',
        'integer',
        'interval',
        'nchar',
        'nclob',
        'national',
        'numeric',
        'real',
        'row',
        'smallint',
        'time',
        'timestamp',
        'varchar',
        'varying',
        'varbinary'
    ];
    const NON_RESERVED_WORDS = [
        "add",
        "asc",
        "collation",
        "desc",
        "final",
        "first",
        "last",
        "view"
    ];
    // https://jakewheat.github.io/sql-overview/sql-2016-foundation-grammar.html#reserved-word
    const RESERVED_WORDS = [
        "abs",
        "acos",
        "all",
        "allocate",
        "alter",
        "and",
        "any",
        "are",
        "array",
        "array_agg",
        "array_max_cardinality",
        "as",
        "asensitive",
        "asin",
        "asymmetric",
        "at",
        "atan",
        "atomic",
        "authorization",
        "avg",
        "begin",
        "begin_frame",
        "begin_partition",
        "between",
        "bigint",
        "binary",
        "blob",
        "boolean",
        "both",
        "by",
        "call",
        "called",
        "cardinality",
        "cascaded",
        "case",
        "cast",
        "ceil",
        "ceiling",
        "char",
        "char_length",
        "character",
        "character_length",
        "check",
        "classifier",
        "clob",
        "close",
        "coalesce",
        "collate",
        "collect",
        "column",
        "commit",
        "condition",
        "connect",
        "constraint",
        "contains",
        "convert",
        "copy",
        "corr",
        "corresponding",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "create",
        "cross",
        "cube",
        "cume_dist",
        "current",
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_row",
        "current_schema",
        "current_time",
        "current_timestamp",
        "current_path",
        "current_role",
        "current_transform_group_for_type",
        "current_user",
        "cursor",
        "cycle",
        "date",
        "day",
        "deallocate",
        "dec",
        "decimal",
        "decfloat",
        "declare",
        "default",
        "define",
        "delete",
        "dense_rank",
        "deref",
        "describe",
        "deterministic",
        "disconnect",
        "distinct",
        "double",
        "drop",
        "dynamic",
        "each",
        "element",
        "else",
        "empty",
        "end",
        "end_frame",
        "end_partition",
        "end-exec",
        "equals",
        "escape",
        "every",
        "except",
        "exec",
        "execute",
        "exists",
        "exp",
        "external",
        "extract",
        "false",
        "fetch",
        "filter",
        "first_value",
        "float",
        "floor",
        "for",
        "foreign",
        "frame_row",
        "free",
        "from",
        "full",
        "function",
        "fusion",
        "get",
        "global",
        "grant",
        "group",
        "grouping",
        "groups",
        "having",
        "hold",
        "hour",
        "identity",
        "in",
        "indicator",
        "initial",
        "inner",
        "inout",
        "insensitive",
        "insert",
        "int",
        "integer",
        "intersect",
        "intersection",
        "interval",
        "into",
        "is",
        "join",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "language",
        "large",
        "last_value",
        "lateral",
        "lead",
        "leading",
        "left",
        "like",
        "like_regex",
        "listagg",
        "ln",
        "local",
        "localtime",
        "localtimestamp",
        "log",
        "log10",
        "lower",
        "match",
        "match_number",
        "match_recognize",
        "matches",
        "max",
        "member",
        "merge",
        "method",
        "min",
        "minute",
        "mod",
        "modifies",
        "module",
        "month",
        "multiset",
        "national",
        "natural",
        "nchar",
        "nclob",
        "new",
        "no",
        "none",
        "normalize",
        "not",
        "nth_value",
        "ntile",
        "null",
        "nullif",
        "numeric",
        "octet_length",
        "occurrences_regex",
        "of",
        "offset",
        "old",
        "omit",
        "on",
        "one",
        "only",
        "open",
        "or",
        "order",
        "out",
        "outer",
        "over",
        "overlaps",
        "overlay",
        "parameter",
        "partition",
        "pattern",
        "per",
        "percent",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "period",
        "portion",
        "position",
        "position_regex",
        "power",
        "precedes",
        "precision",
        "prepare",
        "primary",
        "procedure",
        "ptf",
        "range",
        "rank",
        "reads",
        "real",
        "recursive",
        "ref",
        "references",
        "referencing",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "release",
        "result",
        "return",
        "returns",
        "revoke",
        "right",
        "rollback",
        "rollup",
        "row",
        "row_number",
        "rows",
        "running",
        "savepoint",
        "scope",
        "scroll",
        "search",
        "second",
        "seek",
        "select",
        "sensitive",
        "session_user",
        "set",
        "show",
        "similar",
        "sin",
        "sinh",
        "skip",
        "smallint",
        "some",
        "specific",
        "specifictype",
        "sql",
        "sqlexception",
        "sqlstate",
        "sqlwarning",
        "sqrt",
        "start",
        "static",
        "stddev_pop",
        "stddev_samp",
        "submultiset",
        "subset",
        "substring",
        "substring_regex",
        "succeeds",
        "sum",
        "symmetric",
        "system",
        "system_time",
        "system_user",
        "table",
        "tablesample",
        "tan",
        "tanh",
        "then",
        "time",
        "timestamp",
        "timezone_hour",
        "timezone_minute",
        "to",
        "trailing",
        "translate",
        "translate_regex",
        "translation",
        "treat",
        "trigger",
        "trim",
        "trim_array",
        "true",
        "truncate",
        "uescape",
        "union",
        "unique",
        "unknown",
        "unnest",
        "update",
        "upper",
        "user",
        "using",
        "value",
        "values",
        "value_of",
        "var_pop",
        "var_samp",
        "varbinary",
        "varchar",
        "varying",
        "versioning",
        "when",
        "whenever",
        "where",
        "width_bucket",
        "window",
        "with",
        "within",
        "without",
        "year"
    ];
    // these are reserved words we have identified to be functions
    // and should only be highlighted in a dispatch-like context
    // ie, array_agg(...), etc.
    const RESERVED_FUNCTIONS = [
        "abs",
        "acos",
        "array_agg",
        "asin",
        "atan",
        "avg",
        "cast",
        "ceil",
        "ceiling",
        "coalesce",
        "corr",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "cume_dist",
        "dense_rank",
        "deref",
        "element",
        "exp",
        "extract",
        "first_value",
        "floor",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "last_value",
        "lead",
        "listagg",
        "ln",
        "log",
        "log10",
        "lower",
        "max",
        "min",
        "mod",
        "nth_value",
        "ntile",
        "nullif",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "position",
        "position_regex",
        "power",
        "rank",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "row_number",
        "sin",
        "sinh",
        "sqrt",
        "stddev_pop",
        "stddev_samp",
        "substring",
        "substring_regex",
        "sum",
        "tan",
        "tanh",
        "translate",
        "translate_regex",
        "treat",
        "trim",
        "trim_array",
        "unnest",
        "upper",
        "value_of",
        "var_pop",
        "var_samp",
        "width_bucket"
    ];
    // these functions can
    const POSSIBLE_WITHOUT_PARENS = [
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_schema",
        "current_transform_group_for_type",
        "current_user",
        "session_user",
        "system_time",
        "system_user",
        "current_time",
        "localtime",
        "current_timestamp",
        "localtimestamp"
    ];
    // those exist to boost relevance making these very
    // "SQL like" keyword combos worth +1 extra relevance
    const COMBOS = [
        "create table",
        "insert into",
        "primary key",
        "foreign key",
        "not null",
        "alter table",
        "add constraint",
        "grouping sets",
        "on overflow",
        "character set",
        "respect nulls",
        "ignore nulls",
        "nulls first",
        "nulls last",
        "depth first",
        "breadth first"
    ];
    const FUNCTIONS = RESERVED_FUNCTIONS;
    const KEYWORDS = [
        ...RESERVED_WORDS,
        ...NON_RESERVED_WORDS
    ].filter((keyword)=>{
        return !RESERVED_FUNCTIONS.includes(keyword);
    });
    const VARIABLE = {
        scope: "variable",
        match: /@[a-z0-9][a-z0-9_]*/
    };
    const OPERATOR = {
        scope: "operator",
        match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
        relevance: 0
    };
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, regex.either(...FUNCTIONS), /\s*\(/),
        relevance: 0,
        keywords: {
            built_in: FUNCTIONS
        }
    };
    // turns a multi-word keyword combo into a regex that doesn't
    // care about extra whitespace etc.
    // input: "START QUERY"
    // output: /\bSTART\s+QUERY\b/
    function kws_to_regex(list) {
        return regex.concat(/\b/, regex.either(...list.map((kw)=>{
            return kw.replace(/\s+/, "\\s+");
        })), /\b/);
    }
    const MULTI_WORD_KEYWORDS = {
        scope: "keyword",
        match: kws_to_regex(COMBOS),
        relevance: 0
    };
    // keywords with less than 3 letters are reduced in relevancy
    function reduceRelevancy(list, { exceptions: exceptions, when: when } = {}) {
        const qualifyFn = when;
        exceptions = exceptions || [];
        return list.map((item)=>{
            if (item.match(/\|\d+$/) || exceptions.includes(item)) return item;
            else if (qualifyFn(item)) return `${item}|0`;
            else return item;
        });
    }
    return {
        name: 'SQL',
        case_insensitive: true,
        // does not include {} or HTML tags `</`
        illegal: /[{}]|<\//,
        keywords: {
            $pattern: /\b[\w\.]+/,
            keyword: reduceRelevancy(KEYWORDS, {
                when: (x)=>x.length < 3
            }),
            literal: LITERALS,
            type: TYPES,
            built_in: POSSIBLE_WITHOUT_PARENS
        },
        contains: [
            {
                scope: "type",
                match: kws_to_regex(MULTI_WORD_TYPES)
            },
            MULTI_WORD_KEYWORDS,
            FUNCTION_CALL,
            VARIABLE,
            STRING,
            QUOTED_IDENTIFIER,
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            OPERATOR
        ]
    };
}


const $aff81ef2d84fecb4$var$IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const $aff81ef2d84fecb4$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends",
    // It's reached stage 3, which is "recommended for implementation":
    "using"
];
const $aff81ef2d84fecb4$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $aff81ef2d84fecb4$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $aff81ef2d84fecb4$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $aff81ef2d84fecb4$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $aff81ef2d84fecb4$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $aff81ef2d84fecb4$var$BUILT_INS = [].concat($aff81ef2d84fecb4$var$BUILT_IN_GLOBALS, $aff81ef2d84fecb4$var$TYPES, $aff81ef2d84fecb4$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $aff81ef2d84fecb4$var$javascript(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $aff81ef2d84fecb4$var$IDENT_RE;
    const FRAGMENT = {
        begin: '<>',
        end: '</>'
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $aff81ef2d84fecb4$var$IDENT_RE,
        keyword: $aff81ef2d84fecb4$var$KEYWORDS,
        literal: $aff81ef2d84fecb4$var$LITERALS,
        built_in: $aff81ef2d84fecb4$var$BUILT_INS,
        "variable.language": $aff81ef2d84fecb4$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = '[0-9](_?[0-9])*';
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: 'number',
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}',
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: '\.?html`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'xml'
        }
    };
    const CSS_TEMPLATE = {
        begin: '\.?css`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'css'
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: '\.?gql`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'graphql'
        }
    };
    const TEMPLATE_STRING = {
        className: 'string',
        begin: '`',
        end: '`',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
        relevance: 0,
        contains: [
            {
                begin: '(?=@[A-Za-z]+)',
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    },
                    {
                        className: 'type',
                        begin: '\\{',
                        end: '\\}',
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: 'variable',
                        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /(\s*)\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: 'params',
        // convert this to negative lookbehind in v12
        begin: /(\s*)\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$aff81ef2d84fecb4$var$TYPES,
                ...$aff81ef2d84fecb4$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$aff81ef2d84fecb4$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ].map((x)=>`${x}\\s*\\(`)), IDENT_RE$1, regex.lookahead(/\s*\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: 'JavaScript',
        aliases: [
            'js',
            'jsx',
            'mjs',
            'cjs'
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                scope: 'attr',
                match: IDENT_RE$1 + regex.lookahead(':'),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
                keywords: 'return throw case',
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: 'function',
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: '\\s*=>',
                        contains: [
                            {
                                className: 'params',
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /(\s*)\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                'on:begin': XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: 'xml',
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    'self'
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
                '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: '\\$' + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/ /** @type LanguageFn */ function $aff81ef2d84fecb4$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    const tsLanguage = $aff81ef2d84fecb4$var$javascript(hljs);
    const IDENT_RE$1 = $aff81ef2d84fecb4$var$IDENT_RE;
    const TYPES = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "symbol",
        "bigint",
        "unknown"
    ];
    const NAMESPACE = {
        begin: [
            /namespace/,
            /\s+/,
            hljs.IDENT_RE
        ],
        beginScope: {
            1: "keyword",
            3: "title.class"
        }
    };
    const INTERFACE = {
        beginKeywords: 'interface',
        end: /\{/,
        excludeEnd: true,
        keywords: {
            keyword: 'interface extends',
            built_in: TYPES
        },
        contains: [
            tsLanguage.exports.CLASS_REFERENCE
        ]
    };
    const USE_STRICT = {
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    };
    const TS_SPECIFIC_KEYWORDS = [
        "type",
        // "namespace",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly",
        "enum",
        "override",
        "satisfies"
    ];
    /*
    namespace is a TS keyword but it's fine to use it as a variable name too.
    const message = 'foo';
    const namespace = 'bar';
  */ const KEYWORDS$1 = {
        $pattern: $aff81ef2d84fecb4$var$IDENT_RE,
        keyword: $aff81ef2d84fecb4$var$KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
        literal: $aff81ef2d84fecb4$var$LITERALS,
        built_in: $aff81ef2d84fecb4$var$BUILT_INS.concat(TYPES),
        "variable.language": $aff81ef2d84fecb4$var$BUILT_IN_VARIABLES
    };
    const DECORATOR = {
        className: 'meta',
        begin: '@' + IDENT_RE$1
    };
    const swapMode = (mode, label, replacement)=>{
        const indx = mode.contains.findIndex((m)=>m.label === label);
        if (indx === -1) throw new Error("can not find mode to replace");
        mode.contains.splice(indx, 1, replacement);
    };
    // this should update anywhere keywords is used since
    // it will be the same actual JS object
    Object.assign(tsLanguage.keywords, KEYWORDS$1);
    tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
    // highlight the function params
    const ATTRIBUTE_HIGHLIGHT = tsLanguage.contains.find((c)=>c.scope === "attr");
    // take default attr rule and extend it to support optionals
    const OPTIONAL_KEY_OR_ARGUMENT = Object.assign({}, ATTRIBUTE_HIGHLIGHT, {
        match: regex.concat(IDENT_RE$1, regex.lookahead(/\s*\?:/))
    });
    tsLanguage.exports.PARAMS_CONTAINS.push([
        tsLanguage.exports.CLASS_REFERENCE,
        ATTRIBUTE_HIGHLIGHT,
        OPTIONAL_KEY_OR_ARGUMENT
    ]);
    // Add the optional property assignment highlighting for objects or classes
    tsLanguage.contains = tsLanguage.contains.concat([
        DECORATOR,
        NAMESPACE,
        INTERFACE,
        OPTIONAL_KEY_OR_ARGUMENT
    ]);
    // TS gets a simpler shebang rule than JS
    swapMode(tsLanguage, "shebang", hljs.SHEBANG());
    // JS use strict rule purposely excludes `asm` which makes no sense
    swapMode(tsLanguage, "use_strict", USE_STRICT);
    const functionDeclaration = tsLanguage.contains.find((m)=>m.label === "func.def");
    functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript
    Object.assign(tsLanguage, {
        name: 'TypeScript',
        aliases: [
            'ts',
            'tsx',
            'mts',
            'cts'
        ]
    });
    return tsLanguage;
}


/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common, web
Audit: 2020
*/ /** @type LanguageFn */ function $c1fae4de0ffeee41$export$2e2bcd8739ae039(hljs) {
    const regex = hljs.regex;
    // XML names can have the following additional letters: https://www.w3.org/TR/xml/#NT-NameChar
    // OTHER_NAME_CHARS = /[:\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;
    // Element names start with NAME_START_CHAR followed by optional other Unicode letters, ASCII digits, hyphens, underscores, and periods
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);;
    // const XML_IDENT_RE = /[A-Z_a-z:\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]+/;
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);
    // however, to cater for performance and more Unicode support rely simply on the Unicode letter class
    const TAG_NAME_RE = regex.concat(/[\p{L}_]/u, regex.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u);
    const XML_IDENT_RE = /[\p{L}0-9._:-]+/u;
    const XML_ENTITIES = {
        className: 'symbol',
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    };
    const XML_META_KEYWORDS = {
        begin: /\s/,
        contains: [
            {
                className: 'keyword',
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    };
    const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: /\(/,
        end: /\)/
    });
    const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: 'string'
    });
    const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: 'string'
    });
    const TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: 'attr',
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: 'string',
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: 'HTML, XML',
        aliases: [
            'html',
            'xhtml',
            'rss',
            'atom',
            'xjb',
            'xsd',
            'xsl',
            'plist',
            'wsf',
            'svg'
        ],
        case_insensitive: true,
        unicodeRegex: true,
        contains: [
            {
                className: 'meta',
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: 'meta',
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            XML_ENTITIES,
            // xml processing instructions
            {
                className: 'meta',
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            QUOTE_META_STRING_MODE
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: 'tag',
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'style'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: true,
                    subLanguage: [
                        'css',
                        'xml'
                    ]
                }
            },
            {
                className: 'tag',
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'script'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: true,
                    subLanguage: [
                        'javascript',
                        'handlebars',
                        'xml'
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: 'tag',
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: 'tag',
                begin: regex.concat(/</, regex.lookahead(regex.concat(TAG_NAME_RE, // <tag/>
                // <tag>
                // <tag ...
                regex.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0,
                        starts: TAG_INTERNALS
                    }
                ]
            },
            // close tag
            {
                className: 'tag',
                begin: regex.concat(/<\//, regex.lookahead(regex.concat(TAG_NAME_RE, />/))),
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: true
                    }
                ]
            }
        ]
    };
}


/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts
function $338e5c1bfb697578$export$212bb2fc580a90a8() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var $338e5c1bfb697578$export$ebe90cb607ad99e = $338e5c1bfb697578$export$212bb2fc580a90a8();
function $338e5c1bfb697578$var$changeDefaults(newDefaults) {
    $338e5c1bfb697578$export$ebe90cb607ad99e = newDefaults;
}
// src/rules.ts
var $338e5c1bfb697578$var$noopTest = {
    exec: ()=>null
};
function $338e5c1bfb697578$var$edit(regex, opt = "") {
    let source = typeof regex === "string" ? regex : regex.source;
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace($338e5c1bfb697578$var$other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var $338e5c1bfb697578$var$other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
    hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
    htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var $338e5c1bfb697578$var$newline = /^(?:[ \t]*(?:\n|$))+/;
var $338e5c1bfb697578$var$blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var $338e5c1bfb697578$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var $338e5c1bfb697578$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var $338e5c1bfb697578$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var $338e5c1bfb697578$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
var $338e5c1bfb697578$var$lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var $338e5c1bfb697578$var$lheading = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$lheadingCore).replace(/bull/g, $338e5c1bfb697578$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var $338e5c1bfb697578$var$lheadingGfm = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$lheadingCore).replace(/bull/g, $338e5c1bfb697578$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var $338e5c1bfb697578$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var $338e5c1bfb697578$var$blockText = /^[^\n]+/;
var $338e5c1bfb697578$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var $338e5c1bfb697578$var$def = $338e5c1bfb697578$var$edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $338e5c1bfb697578$var$_blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var $338e5c1bfb697578$var$list = $338e5c1bfb697578$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $338e5c1bfb697578$var$bullet).getRegex();
var $338e5c1bfb697578$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var $338e5c1bfb697578$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var $338e5c1bfb697578$var$html = $338e5c1bfb697578$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $338e5c1bfb697578$var$_comment).replace("tag", $338e5c1bfb697578$var$_tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var $338e5c1bfb697578$var$paragraph = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$_paragraph).replace("hr", $338e5c1bfb697578$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $338e5c1bfb697578$var$_tag).getRegex();
var $338e5c1bfb697578$var$blockquote = $338e5c1bfb697578$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $338e5c1bfb697578$var$paragraph).getRegex();
var $338e5c1bfb697578$var$blockNormal = {
    blockquote: $338e5c1bfb697578$var$blockquote,
    code: $338e5c1bfb697578$var$blockCode,
    def: $338e5c1bfb697578$var$def,
    fences: $338e5c1bfb697578$var$fences,
    heading: $338e5c1bfb697578$var$heading,
    hr: $338e5c1bfb697578$var$hr,
    html: $338e5c1bfb697578$var$html,
    lheading: $338e5c1bfb697578$var$lheading,
    list: $338e5c1bfb697578$var$list,
    newline: $338e5c1bfb697578$var$newline,
    paragraph: $338e5c1bfb697578$var$paragraph,
    table: $338e5c1bfb697578$var$noopTest,
    text: $338e5c1bfb697578$var$blockText
};
var $338e5c1bfb697578$var$gfmTable = $338e5c1bfb697578$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $338e5c1bfb697578$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $338e5c1bfb697578$var$_tag).getRegex();
var $338e5c1bfb697578$var$blockGfm = {
    ...$338e5c1bfb697578$var$blockNormal,
    lheading: $338e5c1bfb697578$var$lheadingGfm,
    table: $338e5c1bfb697578$var$gfmTable,
    paragraph: $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$_paragraph).replace("hr", $338e5c1bfb697578$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $338e5c1bfb697578$var$gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $338e5c1bfb697578$var$_tag).getRegex()
};
var $338e5c1bfb697578$var$blockPedantic = {
    ...$338e5c1bfb697578$var$blockNormal,
    html: $338e5c1bfb697578$var$edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $338e5c1bfb697578$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $338e5c1bfb697578$var$noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$_paragraph).replace("hr", $338e5c1bfb697578$var$hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", $338e5c1bfb697578$var$lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var $338e5c1bfb697578$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var $338e5c1bfb697578$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var $338e5c1bfb697578$var$br = /^( {2,}|\\)\n(?!\s*$)/;
var $338e5c1bfb697578$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var $338e5c1bfb697578$var$_punctuation = /[\p{P}\p{S}]/u;
var $338e5c1bfb697578$var$_punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var $338e5c1bfb697578$var$_notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var $338e5c1bfb697578$var$punctuation = $338e5c1bfb697578$var$edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $338e5c1bfb697578$var$_punctuationOrSpace).getRegex();
var $338e5c1bfb697578$var$_punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var $338e5c1bfb697578$var$_punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var $338e5c1bfb697578$var$_notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var $338e5c1bfb697578$var$blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var $338e5c1bfb697578$var$emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var $338e5c1bfb697578$var$emStrongLDelim = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$emStrongLDelimCore, "u").replace(/punct/g, $338e5c1bfb697578$var$_punctuation).getRegex();
var $338e5c1bfb697578$var$emStrongLDelimGfm = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$emStrongLDelimCore, "u").replace(/punct/g, $338e5c1bfb697578$var$_punctuationGfmStrongEm).getRegex();
var $338e5c1bfb697578$var$emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var $338e5c1bfb697578$var$emStrongRDelimAst = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $338e5c1bfb697578$var$_notPunctuationOrSpace).replace(/punctSpace/g, $338e5c1bfb697578$var$_punctuationOrSpace).replace(/punct/g, $338e5c1bfb697578$var$_punctuation).getRegex();
var $338e5c1bfb697578$var$emStrongRDelimAstGfm = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $338e5c1bfb697578$var$_notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, $338e5c1bfb697578$var$_punctuationOrSpaceGfmStrongEm).replace(/punct/g, $338e5c1bfb697578$var$_punctuationGfmStrongEm).getRegex();
var $338e5c1bfb697578$var$emStrongRDelimUnd = $338e5c1bfb697578$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $338e5c1bfb697578$var$_notPunctuationOrSpace).replace(/punctSpace/g, $338e5c1bfb697578$var$_punctuationOrSpace).replace(/punct/g, $338e5c1bfb697578$var$_punctuation).getRegex();
var $338e5c1bfb697578$var$anyPunctuation = $338e5c1bfb697578$var$edit(/\\(punct)/, "gu").replace(/punct/g, $338e5c1bfb697578$var$_punctuation).getRegex();
var $338e5c1bfb697578$var$autolink = $338e5c1bfb697578$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var $338e5c1bfb697578$var$_inlineComment = $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$_comment).replace("(?:-->|$)", "-->").getRegex();
var $338e5c1bfb697578$var$tag = $338e5c1bfb697578$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $338e5c1bfb697578$var$_inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var $338e5c1bfb697578$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var $338e5c1bfb697578$var$link = $338e5c1bfb697578$var$edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", $338e5c1bfb697578$var$_inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var $338e5c1bfb697578$var$reflink = $338e5c1bfb697578$var$edit(/^!?\[(label)\]\[(ref)\]/).replace("label", $338e5c1bfb697578$var$_inlineLabel).replace("ref", $338e5c1bfb697578$var$_blockLabel).getRegex();
var $338e5c1bfb697578$var$nolink = $338e5c1bfb697578$var$edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", $338e5c1bfb697578$var$_blockLabel).getRegex();
var $338e5c1bfb697578$var$reflinkSearch = $338e5c1bfb697578$var$edit("reflink|nolink(?!\\()", "g").replace("reflink", $338e5c1bfb697578$var$reflink).replace("nolink", $338e5c1bfb697578$var$nolink).getRegex();
var $338e5c1bfb697578$var$inlineNormal = {
    _backpedal: $338e5c1bfb697578$var$noopTest,
    anyPunctuation: // only used for GFM url
    $338e5c1bfb697578$var$anyPunctuation,
    autolink: $338e5c1bfb697578$var$autolink,
    blockSkip: $338e5c1bfb697578$var$blockSkip,
    br: $338e5c1bfb697578$var$br,
    code: $338e5c1bfb697578$var$inlineCode,
    del: $338e5c1bfb697578$var$noopTest,
    emStrongLDelim: $338e5c1bfb697578$var$emStrongLDelim,
    emStrongRDelimAst: $338e5c1bfb697578$var$emStrongRDelimAst,
    emStrongRDelimUnd: $338e5c1bfb697578$var$emStrongRDelimUnd,
    escape: $338e5c1bfb697578$var$escape,
    link: $338e5c1bfb697578$var$link,
    nolink: $338e5c1bfb697578$var$nolink,
    punctuation: $338e5c1bfb697578$var$punctuation,
    reflink: $338e5c1bfb697578$var$reflink,
    reflinkSearch: $338e5c1bfb697578$var$reflinkSearch,
    tag: $338e5c1bfb697578$var$tag,
    text: $338e5c1bfb697578$var$inlineText,
    url: $338e5c1bfb697578$var$noopTest
};
var $338e5c1bfb697578$var$inlinePedantic = {
    ...$338e5c1bfb697578$var$inlineNormal,
    link: $338e5c1bfb697578$var$edit(/^!?\[(label)\]\((.*?)\)/).replace("label", $338e5c1bfb697578$var$_inlineLabel).getRegex(),
    reflink: $338e5c1bfb697578$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $338e5c1bfb697578$var$_inlineLabel).getRegex()
};
var $338e5c1bfb697578$var$inlineGfm = {
    ...$338e5c1bfb697578$var$inlineNormal,
    emStrongRDelimAst: $338e5c1bfb697578$var$emStrongRDelimAstGfm,
    emStrongLDelim: $338e5c1bfb697578$var$emStrongLDelimGfm,
    url: $338e5c1bfb697578$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var $338e5c1bfb697578$var$inlineBreaks = {
    ...$338e5c1bfb697578$var$inlineGfm,
    br: $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$br).replace("{2,}", "*").getRegex(),
    text: $338e5c1bfb697578$var$edit($338e5c1bfb697578$var$inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var $338e5c1bfb697578$var$block = {
    normal: $338e5c1bfb697578$var$blockNormal,
    gfm: $338e5c1bfb697578$var$blockGfm,
    pedantic: $338e5c1bfb697578$var$blockPedantic
};
var $338e5c1bfb697578$var$inline = {
    normal: $338e5c1bfb697578$var$inlineNormal,
    gfm: $338e5c1bfb697578$var$inlineGfm,
    breaks: $338e5c1bfb697578$var$inlineBreaks,
    pedantic: $338e5c1bfb697578$var$inlinePedantic
};
// src/helpers.ts
var $338e5c1bfb697578$var$escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var $338e5c1bfb697578$var$getEscapeReplacement = (ch)=>$338e5c1bfb697578$var$escapeReplacements[ch];
function $338e5c1bfb697578$var$escape2(html2, encode) {
    if (encode) {
        if ($338e5c1bfb697578$var$other.escapeTest.test(html2)) return html2.replace($338e5c1bfb697578$var$other.escapeReplace, $338e5c1bfb697578$var$getEscapeReplacement);
    } else {
        if ($338e5c1bfb697578$var$other.escapeTestNoEncode.test(html2)) return html2.replace($338e5c1bfb697578$var$other.escapeReplaceNoEncode, $338e5c1bfb697578$var$getEscapeReplacement);
    }
    return html2;
}
function $338e5c1bfb697578$var$cleanUrl(href) {
    try {
        href = encodeURI(href).replace($338e5c1bfb697578$var$other.percentDecode, "%");
    } catch  {
        return null;
    }
    return href;
}
function $338e5c1bfb697578$var$splitCells(tableRow, count) {
    const row = tableRow.replace($338e5c1bfb697578$var$other.findPipe, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split($338e5c1bfb697578$var$other.splitPipe);
    let i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace($338e5c1bfb697578$var$other.slashPipe, "|");
    return cells;
}
function $338e5c1bfb697578$var$rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return "";
    let suffLen = 0;
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $338e5c1bfb697578$var$findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function $338e5c1bfb697578$var$outputLink(cap, link2, raw, lexer2, rules) {
    const href = link2.href;
    const title = link2.title || null;
    const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    const token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function $338e5c1bfb697578$var$indentCodeCompensation(raw, text, rules) {
    const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split("\n").map((node)=>{
        const matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var $338e5c1bfb697578$export$55e8b082af4aa63e = class {
    options;
    rules;
    // set by the lexer
    lexer;
    // set by the lexer
    constructor(options2){
        this.options = options2 || $338e5c1bfb697578$export$ebe90cb607ad99e;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? $338e5c1bfb697578$var$rtrim(text, "\n") : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $338e5c1bfb697578$var$indentCodeCompensation(raw, cap[3] || "", this.rules);
            return {
                type: "code",
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            if (this.rules.other.endingHash.test(text)) {
                const trimmed = $338e5c1bfb697578$var$rtrim(text, "#");
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
            }
            return {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: "hr",
            raw: $338e5c1bfb697578$var$rtrim(cap[0], "\n")
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = $338e5c1bfb697578$var$rtrim(cap[0], "\n").split("\n");
            let raw = "";
            let text = "";
            const tokens = [];
            while(lines.length > 0){
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for(i = 0; i < lines.length; i++){
                    if (this.rules.other.blockquoteStart.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    } else if (!inBlockquote) currentLines.push(lines[i]);
                    else break;
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join("\n");
                const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                text = text ? `${text}
${currentText}` : currentText;
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                if (lines.length === 0) break;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "code") break;
                else if (lastToken?.type === "blockquote") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                } else if (lastToken?.type === "list") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: raw,
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list2 = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            const itemRegex = this.rules.other.listItemRegex(bull);
            let endsWithBlankLine = false;
            while(src){
                let endEarly = false;
                let raw = "";
                let itemContents = "";
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                let nextLine = src.split("\n", 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else if (blankLine) indent = cap[1].length + 1;
                else {
                    indent = cap[2].search(this.rules.other.nonSpaceChar);
                    indent = indent > 4 ? 1 : indent;
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                    raw += nextLine + "\n";
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                    const hrRegex = this.rules.other.hrRegex(indent);
                    const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                    const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                    const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                    while(src){
                        const rawLine = src.split("\n", 1)[0];
                        let nextLineWithoutTabs;
                        nextLine = rawLine;
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                            nextLineWithoutTabs = nextLine;
                        } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                        if (fencesBeginRegex.test(nextLine)) break;
                        if (headingBeginRegex.test(nextLine)) break;
                        if (htmlBeginRegex.test(nextLine)) break;
                        if (nextBulletRegex.test(nextLine)) break;
                        if (hrRegex.test(nextLine)) break;
                        if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                        else {
                            if (blankLine) break;
                            if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += "\n" + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src = src.substring(rawLine.length + 1);
                        line = nextLineWithoutTabs.slice(indent);
                    }
                }
                if (!list2.loose) {
                    if (endsWithBlankLine) list2.loose = true;
                    else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                if (this.options.gfm) {
                    istask = this.rules.other.listIsTask.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                    }
                }
                list2.items.push({
                    type: "list_item",
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list2.raw += raw;
            }
            const lastItem = list2.items.at(-1);
            if (lastItem) {
                lastItem.raw = lastItem.raw.trimEnd();
                lastItem.text = lastItem.text.trimEnd();
            } else return;
            list2.raw = list2.raw.trimEnd();
            for(let i = 0; i < list2.items.length; i++){
                this.lexer.state.top = false;
                list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                if (!list2.loose) {
                    const spacers = list2.items[i].tokens.filter((t)=>t.type === "space");
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                    list2.loose = hasMultipleLineBreaks;
                }
            }
            if (list2.loose) for(let i = 0; i < list2.items.length; i++)list2.items[i].loose = true;
            return list2;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: "html",
                block: true,
                raw: cap[0],
                pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
            const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
            return {
                type: "def",
                tag: tag2,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!this.rules.other.tableDelimiter.test(cap[2])) return;
        const headers = $338e5c1bfb697578$var$splitCells(cap[1]);
        const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
        const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
        const item = {
            type: "table",
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) return;
        for (const align of aligns){
            if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
            else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
            else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
            else item.align.push(null);
        }
        for(let i = 0; i < headers.length; i++)item.header.push({
            text: headers[i],
            tokens: this.lexer.inline(headers[i]),
            header: true,
            align: item.align[i]
        });
        for (const row of rows)item.rows.push($338e5c1bfb697578$var$splitCells(row, item.header.length).map((cell, i)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell),
                header: false,
                align: item.align[i]
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
            return {
                type: "paragraph",
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: cap[1]
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                const rtrimSlash = $338e5c1bfb697578$var$rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                const lastParenIndex = $338e5c1bfb697578$var$findClosingBracket(cap[2], "()");
                if (lastParenIndex === -2) return;
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title = "";
            if (this.options.pedantic) {
                const link2 = this.rules.other.pedanticHrefTitle.exec(href);
                if (link2) {
                    href = link2[1];
                    title = link2[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (this.rules.other.startAngleBracket.test(href)) {
                if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $338e5c1bfb697578$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
            }, cap[0], this.lexer, this.rules);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
            const link2 = links[linkString.toLowerCase()];
            if (!link2) {
                const text = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text,
                    text: text
                };
            }
            return $338e5c1bfb697578$var$outputLink(cap, link2, cap[0], this.lexer, this.rules);
        }
    }
    emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue;
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue;
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue;
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                if (Math.min(lLength, rLength) % 2) {
                    const text2 = raw.slice(1, -1);
                    return {
                        type: "em",
                        raw: raw,
                        text: text2,
                        tokens: this.lexer.inlineTokens(text2)
                    };
                }
                const text = raw.slice(2, -2);
                return {
                    type: "strong",
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
            const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
            const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            return {
                type: "codespan",
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[1];
                href = "mailto:" + text;
            } else {
                text = cap[1];
                href = text;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[0];
                href = "mailto:" + text;
            } else {
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                }while (prevCapZero !== cap[0]);
                text = cap[0];
                if (cap[1] === "www.") href = "http://" + cap[0];
                else href = cap[0];
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            const escaped = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                escaped: escaped
            };
        }
    }
};
// src/Lexer.ts
var $338e5c1bfb697578$export$6168dc8908a6c652 = class __Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options2){
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || $338e5c1bfb697578$export$ebe90cb607ad99e;
        this.options.tokenizer = this.options.tokenizer || new $338e5c1bfb697578$export$55e8b082af4aa63e();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            other: $338e5c1bfb697578$var$other,
            block: $338e5c1bfb697578$var$block.normal,
            inline: $338e5c1bfb697578$var$inline.normal
        };
        if (this.options.pedantic) {
            rules.block = $338e5c1bfb697578$var$block.pedantic;
            rules.inline = $338e5c1bfb697578$var$inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = $338e5c1bfb697578$var$block.gfm;
            if (this.options.breaks) rules.inline = $338e5c1bfb697578$var$inline.breaks;
            else rules.inline = $338e5c1bfb697578$var$inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: $338e5c1bfb697578$var$block,
            inline: $338e5c1bfb697578$var$inline
        };
    }
    /**
   * Static Lex Method
   */ static lex(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.lex(src);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.inlineTokens(src);
    }
    /**
   * Preprocessing
   */ lex(src) {
        src = src.replace($338e5c1bfb697578$var$other.carriageReturn, "\n");
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) src = src.replace($338e5c1bfb697578$var$other.tabCharGlobal, "    ").replace($338e5c1bfb697578$var$other.spaceLine, "");
        while(src){
            let token;
            if (this.options.extensions?.block?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.raw;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                const lastToken = tokens.at(-1);
                if (lastParagraphClipped && lastToken?.type === "paragraph") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
        let maskedSrc = src;
        let match = null;
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        let keepPrevChar = false;
        let prevChar = "";
        while(src){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            let token;
            if (this.options.extensions?.inline?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.type === "text" && lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
};
// src/Renderer.ts
var $338e5c1bfb697578$export$88530751e3977073 = class {
    options;
    parser;
    // set by the parser
    constructor(options2){
        this.options = options2 || $338e5c1bfb697578$export$ebe90cb607ad99e;
    }
    space(token) {
        return "";
    }
    code({ text: text, lang: lang, escaped: escaped }) {
        const langString = (lang || "").match($338e5c1bfb697578$var$other.notSpaceStart)?.[0];
        const code = text.replace($338e5c1bfb697578$var$other.endingNewline, "") + "\n";
        if (!langString) return "<pre><code>" + (escaped ? code : $338e5c1bfb697578$var$escape2(code, true)) + "</code></pre>\n";
        return '<pre><code class="language-' + $338e5c1bfb697578$var$escape2(langString) + '">' + (escaped ? code : $338e5c1bfb697578$var$escape2(code, true)) + "</code></pre>\n";
    }
    blockquote({ tokens: tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>
${body}</blockquote>
`;
    }
    html({ text: text }) {
        return text;
    }
    heading({ tokens: tokens, depth: depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
    }
    hr(token) {
        return "<hr>\n";
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = "";
        for(let j = 0; j < token.items.length; j++){
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? "ol" : "ul";
        const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
    }
    listitem(item) {
        let itemBody = "";
        if (item.task) {
            const checkbox = this.checkbox({
                checked: !!item.checked
            });
            if (item.loose) {
                if (item.tokens[0]?.type === "paragraph") {
                    item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                        item.tokens[0].tokens[0].text = checkbox + " " + $338e5c1bfb697578$var$escape2(item.tokens[0].tokens[0].text);
                        item.tokens[0].tokens[0].escaped = true;
                    }
                } else item.tokens.unshift({
                    type: "text",
                    raw: checkbox + " ",
                    text: checkbox + " ",
                    escaped: true
                });
            } else itemBody += checkbox + " ";
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>
`;
    }
    checkbox({ checked: checked }) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens: tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>
`;
    }
    table(token) {
        let header = "";
        let cell = "";
        for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
        header += this.tablerow({
            text: cell
        });
        let body = "";
        for(let j = 0; j < token.rows.length; j++){
            const row = token.rows[j];
            cell = "";
            for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
            body += this.tablerow({
                text: cell
            });
        }
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
    }
    tablerow({ text: text }) {
        return `<tr>
${text}</tr>
`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? "th" : "td";
        const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
        return tag2 + content + `</${type}>
`;
    }
    /**
   * span level renderer
   */ strong({ tokens: tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens: tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text: text }) {
        return `<code>${$338e5c1bfb697578$var$escape2(text, true)}</code>`;
    }
    br(token) {
        return "<br>";
    }
    del({ tokens: tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href: href, title: title, tokens: tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = $338e5c1bfb697578$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + $338e5c1bfb697578$var$escape2(title) + '"';
        out += ">" + text + "</a>";
        return out;
    }
    image({ href: href, title: title, text: text, tokens: tokens }) {
        if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
        const cleanHref = $338e5c1bfb697578$var$cleanUrl(href);
        if (cleanHref === null) return $338e5c1bfb697578$var$escape2(text);
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${$338e5c1bfb697578$var$escape2(title)}"`;
        out += ">";
        return out;
    }
    text(token) {
        return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : $338e5c1bfb697578$var$escape2(token.text);
    }
};
// src/TextRenderer.ts
var $338e5c1bfb697578$export$75ebcd2c8ed5b901 = class {
    // no need for block level renderers
    strong({ text: text }) {
        return text;
    }
    em({ text: text }) {
        return text;
    }
    codespan({ text: text }) {
        return text;
    }
    del({ text: text }) {
        return text;
    }
    html({ text: text }) {
        return text;
    }
    text({ text: text }) {
        return text;
    }
    link({ text: text }) {
        return "" + text;
    }
    image({ text: text }) {
        return "" + text;
    }
    br() {
        return "";
    }
};
// src/Parser.ts
var $338e5c1bfb697578$export$7acfa6ed01010e37 = class __Parser {
    options;
    renderer;
    textRenderer;
    constructor(options2){
        this.options = options2 || $338e5c1bfb697578$export$ebe90cb607ad99e;
        this.options.renderer = this.options.renderer || new $338e5c1bfb697578$export$88530751e3977073();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new $338e5c1bfb697578$export$75ebcd2c8ed5b901();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top = true) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(genericToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "space":
                    out += this.renderer.space(token);
                    continue;
                case "hr":
                    out += this.renderer.hr(token);
                    continue;
                case "heading":
                    out += this.renderer.heading(token);
                    continue;
                case "code":
                    out += this.renderer.code(token);
                    continue;
                case "table":
                    out += this.renderer.table(token);
                    continue;
                case "blockquote":
                    out += this.renderer.blockquote(token);
                    continue;
                case "list":
                    out += this.renderer.list(token);
                    continue;
                case "html":
                    out += this.renderer.html(token);
                    continue;
                case "paragraph":
                    out += this.renderer.paragraph(token);
                    continue;
                case "text":
                    {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                            textToken = tokens[++i];
                            body += "\n" + this.renderer.text(textToken);
                        }
                        if (top) out += this.renderer.paragraph({
                            type: "paragraph",
                            raw: body,
                            text: body,
                            tokens: [
                                {
                                    type: "text",
                                    raw: body,
                                    text: body,
                                    escaped: true
                                }
                            ]
                        });
                        else out += body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({
                    parser: this
                }, anyToken);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(anyToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "escape":
                    out += renderer.text(token);
                    break;
                case "html":
                    out += renderer.html(token);
                    break;
                case "link":
                    out += renderer.link(token);
                    break;
                case "image":
                    out += renderer.image(token);
                    break;
                case "strong":
                    out += renderer.strong(token);
                    break;
                case "em":
                    out += renderer.em(token);
                    break;
                case "codespan":
                    out += renderer.codespan(token);
                    break;
                case "br":
                    out += renderer.br(token);
                    break;
                case "del":
                    out += renderer.del(token);
                    break;
                case "text":
                    out += renderer.text(token);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
};
// src/Hooks.ts
var $338e5c1bfb697578$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(options2){
        this.options = options2 || $338e5c1bfb697578$export$ebe90cb607ad99e;
    }
    static passThroughHooks = /* @__PURE__ */ new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    /**
   * Process markdown before marked
   */ preprocess(markdown) {
        return markdown;
    }
    /**
   * Process HTML after marked is finished
   */ postprocess(html2) {
        return html2;
    }
    /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
        return tokens;
    }
    /**
   * Provide function to tokenize markdown
   */ provideLexer() {
        return this.block ? $338e5c1bfb697578$export$6168dc8908a6c652.lex : $338e5c1bfb697578$export$6168dc8908a6c652.lexInline;
    }
    /**
   * Provide function to parse tokens
   */ provideParser() {
        return this.block ? $338e5c1bfb697578$export$7acfa6ed01010e37.parse : $338e5c1bfb697578$export$7acfa6ed01010e37.parseInline;
    }
};
// src/Instance.ts
var $338e5c1bfb697578$export$164128c95a350e30 = class {
    defaults = $338e5c1bfb697578$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(true);
    parseInline = this.parseMarkdown(false);
    Parser = $338e5c1bfb697578$export$7acfa6ed01010e37;
    Renderer = $338e5c1bfb697578$export$88530751e3977073;
    TextRenderer = $338e5c1bfb697578$export$75ebcd2c8ed5b901;
    Lexer = $338e5c1bfb697578$export$6168dc8908a6c652;
    Tokenizer = $338e5c1bfb697578$export$55e8b082af4aa63e;
    Hooks = $338e5c1bfb697578$export$5fbefe39e79899a6;
    constructor(...args){
        this.use(...args);
    }
    /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case "table":
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case "list":
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens2 = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens2, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            const opts = {
                ...pack
            };
            opts.async = this.defaults.async || opts.async || false;
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error("extension name required");
                    if ("renderer" in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                            let ret = ext.renderer.apply(this, args2);
                            if (ret === false) ret = prevRenderer.apply(this, args2);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ("tokenizer" in ext) {
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new $338e5c1bfb697578$export$88530751e3977073(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(prop)) continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    renderer[rendererProp] = (...args2)=>{
                        let ret = rendererFunc.apply(renderer, args2);
                        if (ret === false) ret = prevRenderer.apply(renderer, args2);
                        return ret || "";
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new $338e5c1bfb697578$export$55e8b082af4aa63e(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    tokenizer[tokenizerProp] = (...args2)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args2);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new $338e5c1bfb697578$export$5fbefe39e79899a6();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(prop)) continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ($338e5c1bfb697578$export$5fbefe39e79899a6.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2)=>{
                            return prevHook.call(hooks, ret2);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksProp] = (...args2)=>{
                        let ret = hooksFunc.apply(hooks, args2);
                        if (ret === false) ret = prevHook.apply(hooks, args2);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            if (pack.walkTokens) {
                const walkTokens2 = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options2) {
        return $338e5c1bfb697578$export$6168dc8908a6c652.lex(src, options2 ?? this.defaults);
    }
    parser(tokens, options2) {
        return $338e5c1bfb697578$export$7acfa6ed01010e37.parse(tokens, options2 ?? this.defaults);
    }
    parseMarkdown(blockType) {
        const parse2 = (src, options2)=>{
            const origOpt = {
                ...options2
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            const throwError = this.onError(!!opt.silent, !!opt.async);
            if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            if (opt.hooks) {
                opt.hooks.options = opt;
                opt.hooks.block = blockType;
            }
            const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? $338e5c1bfb697578$export$6168dc8908a6c652.lex : $338e5c1bfb697578$export$6168dc8908a6c652.lexInline;
            const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? $338e5c1bfb697578$export$7acfa6ed01010e37.parse : $338e5c1bfb697578$export$7acfa6ed01010e37.parseInline;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2)=>lexer2(src2, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser2(tokens, opt)).then((html2)=>opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer2(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html2 = parser2(tokens, opt);
                if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                return html2;
            } catch (e) {
                return throwError(e);
            }
        };
        return parse2;
    }
    onError(silent, async) {
        return (e)=>{
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                const msg = "<p>An error occurred:</p><pre>" + $338e5c1bfb697578$var$escape2(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
};
// src/marked.ts
var $338e5c1bfb697578$var$markedInstance = new $338e5c1bfb697578$export$164128c95a350e30();
function $338e5c1bfb697578$export$db8f131360c543a5(src, opt) {
    return $338e5c1bfb697578$var$markedInstance.parse(src, opt);
}
$338e5c1bfb697578$export$db8f131360c543a5.options = $338e5c1bfb697578$export$db8f131360c543a5.setOptions = function(options2) {
    $338e5c1bfb697578$var$markedInstance.setOptions(options2);
    $338e5c1bfb697578$export$db8f131360c543a5.defaults = $338e5c1bfb697578$var$markedInstance.defaults;
    $338e5c1bfb697578$var$changeDefaults($338e5c1bfb697578$export$db8f131360c543a5.defaults);
    return $338e5c1bfb697578$export$db8f131360c543a5;
};
$338e5c1bfb697578$export$db8f131360c543a5.getDefaults = $338e5c1bfb697578$export$212bb2fc580a90a8;
$338e5c1bfb697578$export$db8f131360c543a5.defaults = $338e5c1bfb697578$export$ebe90cb607ad99e;
$338e5c1bfb697578$export$db8f131360c543a5.use = function(...args) {
    $338e5c1bfb697578$var$markedInstance.use(...args);
    $338e5c1bfb697578$export$db8f131360c543a5.defaults = $338e5c1bfb697578$var$markedInstance.defaults;
    $338e5c1bfb697578$var$changeDefaults($338e5c1bfb697578$export$db8f131360c543a5.defaults);
    return $338e5c1bfb697578$export$db8f131360c543a5;
};
$338e5c1bfb697578$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $338e5c1bfb697578$var$markedInstance.walkTokens(tokens, callback);
};
$338e5c1bfb697578$export$db8f131360c543a5.parseInline = $338e5c1bfb697578$var$markedInstance.parseInline;
$338e5c1bfb697578$export$db8f131360c543a5.Parser = $338e5c1bfb697578$export$7acfa6ed01010e37;
$338e5c1bfb697578$export$db8f131360c543a5.parser = $338e5c1bfb697578$export$7acfa6ed01010e37.parse;
$338e5c1bfb697578$export$db8f131360c543a5.Renderer = $338e5c1bfb697578$export$88530751e3977073;
$338e5c1bfb697578$export$db8f131360c543a5.TextRenderer = $338e5c1bfb697578$export$75ebcd2c8ed5b901;
$338e5c1bfb697578$export$db8f131360c543a5.Lexer = $338e5c1bfb697578$export$6168dc8908a6c652;
$338e5c1bfb697578$export$db8f131360c543a5.lexer = $338e5c1bfb697578$export$6168dc8908a6c652.lex;
$338e5c1bfb697578$export$db8f131360c543a5.Tokenizer = $338e5c1bfb697578$export$55e8b082af4aa63e;
$338e5c1bfb697578$export$db8f131360c543a5.Hooks = $338e5c1bfb697578$export$5fbefe39e79899a6;
$338e5c1bfb697578$export$db8f131360c543a5.parse = $338e5c1bfb697578$export$db8f131360c543a5;
var $338e5c1bfb697578$export$41c562ebe57d11e2 = $338e5c1bfb697578$export$db8f131360c543a5.options;
var $338e5c1bfb697578$export$add91eafeaeab287 = $338e5c1bfb697578$export$db8f131360c543a5.setOptions;
var $338e5c1bfb697578$export$1f96ae73734a86cc = $338e5c1bfb697578$export$db8f131360c543a5.use;
var $338e5c1bfb697578$export$3eedd5437d43cb76 = $338e5c1bfb697578$export$db8f131360c543a5.walkTokens;
var $338e5c1bfb697578$export$c7679c2b5e355e6f = $338e5c1bfb697578$export$db8f131360c543a5.parseInline;
var $338e5c1bfb697578$export$98e6a39c04603d36 = $338e5c1bfb697578$export$db8f131360c543a5;
var $338e5c1bfb697578$export$8f49e4af10703ce3 = $338e5c1bfb697578$export$7acfa6ed01010e37.parse;
var $338e5c1bfb697578$export$43feed32102720d2 = $338e5c1bfb697578$export$6168dc8908a6c652.lex;


function $1eccb725e9e3f1d9$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) destination[key] = source[key];
    }
    return destination;
}
function $1eccb725e9e3f1d9$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $1eccb725e9e3f1d9$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $1eccb725e9e3f1d9$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $1eccb725e9e3f1d9$var$trimNewlines(string) {
    return $1eccb725e9e3f1d9$var$trimTrailingNewlines($1eccb725e9e3f1d9$var$trimLeadingNewlines(string));
}
var $1eccb725e9e3f1d9$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $1eccb725e9e3f1d9$var$isBlock(node) {
    return $1eccb725e9e3f1d9$var$is(node, $1eccb725e9e3f1d9$var$blockElements);
}
var $1eccb725e9e3f1d9$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $1eccb725e9e3f1d9$var$isVoid(node) {
    return $1eccb725e9e3f1d9$var$is(node, $1eccb725e9e3f1d9$var$voidElements);
}
function $1eccb725e9e3f1d9$var$hasVoid(node) {
    return $1eccb725e9e3f1d9$var$has(node, $1eccb725e9e3f1d9$var$voidElements);
}
var $1eccb725e9e3f1d9$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $1eccb725e9e3f1d9$var$isMeaningfulWhenBlank(node) {
    return $1eccb725e9e3f1d9$var$is(node, $1eccb725e9e3f1d9$var$meaningfulWhenBlankElements);
}
function $1eccb725e9e3f1d9$var$hasMeaningfulWhenBlank(node) {
    return $1eccb725e9e3f1d9$var$has(node, $1eccb725e9e3f1d9$var$meaningfulWhenBlankElements);
}
function $1eccb725e9e3f1d9$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $1eccb725e9e3f1d9$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $1eccb725e9e3f1d9$var$markdownEscapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $1eccb725e9e3f1d9$var$escapeMarkdown(string) {
    return $1eccb725e9e3f1d9$var$markdownEscapes.reduce(function(accumulator, escape) {
        return accumulator.replace(escape[0], escape[1]);
    }, string);
}
var $1eccb725e9e3f1d9$var$rules = {};
$1eccb725e9e3f1d9$var$rules.paragraph = {
    filter: 'p',
    replacement: function(content) {
        return '\n\n' + content + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.lineBreak = {
    filter: 'br',
    replacement: function(content, node, options) {
        return options.br + '\n';
    }
};
$1eccb725e9e3f1d9$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $1eccb725e9e3f1d9$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $1eccb725e9e3f1d9$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function(content) {
        content = $1eccb725e9e3f1d9$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.listItem = {
    filter: 'li',
    replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $1eccb725e9e3f1d9$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$1eccb725e9e3f1d9$var$rules.indentedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.fencedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $1eccb725e9e3f1d9$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$1eccb725e9e3f1d9$var$rules.inlineLink = {
    filter: function(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node) {
        var href = $1eccb725e9e3f1d9$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $1eccb725e9e3f1d9$var$escapeLinkTitle($1eccb725e9e3f1d9$var$cleanAttribute(node.getAttribute('title')));
        var titlePart = title ? ' "' + title + '"' : '';
        return '[' + content + '](' + href + titlePart + ')';
    }
};
$1eccb725e9e3f1d9$var$rules.referenceLink = {
    filter: function(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node, options) {
        var href = $1eccb725e9e3f1d9$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $1eccb725e9e3f1d9$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + $1eccb725e9e3f1d9$var$escapeLinkTitle(title) + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$1eccb725e9e3f1d9$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$1eccb725e9e3f1d9$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$1eccb725e9e3f1d9$var$rules.code = {
    filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$1eccb725e9e3f1d9$var$rules.image = {
    filter: 'img',
    replacement: function(content, node) {
        var alt = $1eccb725e9e3f1d9$var$escapeMarkdown($1eccb725e9e3f1d9$var$cleanAttribute(node.getAttribute('alt')));
        var src = $1eccb725e9e3f1d9$var$escapeLinkDestination(node.getAttribute('src') || '');
        var title = $1eccb725e9e3f1d9$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + $1eccb725e9e3f1d9$var$escapeLinkTitle(title) + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $1eccb725e9e3f1d9$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
function $1eccb725e9e3f1d9$var$escapeLinkDestination(destination) {
    var escaped = destination.replace(/([<>()])/g, '\\$1');
    return escaped.indexOf(' ') >= 0 ? '<' + escaped + '>' : escaped;
}
function $1eccb725e9e3f1d9$var$escapeLinkTitle(title) {
    return title.replace(/"/g, '\\"');
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $1eccb725e9e3f1d9$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$1eccb725e9e3f1d9$var$Rules.prototype = {
    add: function(key, rule) {
        this.array.unshift(rule);
    },
    keep: function(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function() {
                return '';
            }
        });
    },
    forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $1eccb725e9e3f1d9$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $1eccb725e9e3f1d9$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $1eccb725e9e3f1d9$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $1eccb725e9e3f1d9$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($1eccb725e9e3f1d9$var$filterValue(rule, node, options)) return rule;
    }
    return undefined;
}
function $1eccb725e9e3f1d9$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $1eccb725e9e3f1d9$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $1eccb725e9e3f1d9$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $1eccb725e9e3f1d9$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $1eccb725e9e3f1d9$var$remove(node);
            continue;
        }
        var nextNode = $1eccb725e9e3f1d9$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $1eccb725e9e3f1d9$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $1eccb725e9e3f1d9$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $1eccb725e9e3f1d9$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $1eccb725e9e3f1d9$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $1eccb725e9e3f1d9$var$canParseHTMLNatively() {
    var Parser = $1eccb725e9e3f1d9$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $1eccb725e9e3f1d9$var$createHTMLParser() {
    var Parser = function() {};
    if ($1eccb725e9e3f1d9$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $1eccb725e9e3f1d9$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($1eccb725e9e3f1d9$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $1eccb725e9e3f1d9$var$HTMLParser = $1eccb725e9e3f1d9$var$canParseHTMLNatively() ? $1eccb725e9e3f1d9$var$root.DOMParser : $1eccb725e9e3f1d9$var$createHTMLParser();
function $1eccb725e9e3f1d9$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $1eccb725e9e3f1d9$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $1eccb725e9e3f1d9$var$collapseWhitespace({
        element: root,
        isBlock: $1eccb725e9e3f1d9$var$isBlock,
        isVoid: $1eccb725e9e3f1d9$var$isVoid,
        isPre: options.preformattedCode ? $1eccb725e9e3f1d9$var$isPreOrCode : null
    });
    return root;
}
var $1eccb725e9e3f1d9$var$_htmlParser;
function $1eccb725e9e3f1d9$var$htmlParser() {
    $1eccb725e9e3f1d9$var$_htmlParser = $1eccb725e9e3f1d9$var$_htmlParser || new $1eccb725e9e3f1d9$var$HTMLParser();
    return $1eccb725e9e3f1d9$var$_htmlParser;
}
function $1eccb725e9e3f1d9$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $1eccb725e9e3f1d9$var$Node(node, options) {
    node.isBlock = $1eccb725e9e3f1d9$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $1eccb725e9e3f1d9$var$isBlank(node);
    node.flankingWhitespace = $1eccb725e9e3f1d9$var$flankingWhitespace(node, options);
    return node;
}
function $1eccb725e9e3f1d9$var$isBlank(node) {
    return !$1eccb725e9e3f1d9$var$isVoid(node) && !$1eccb725e9e3f1d9$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$1eccb725e9e3f1d9$var$hasVoid(node) && !$1eccb725e9e3f1d9$var$hasMeaningfulWhenBlank(node);
}
function $1eccb725e9e3f1d9$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $1eccb725e9e3f1d9$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $1eccb725e9e3f1d9$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $1eccb725e9e3f1d9$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $1eccb725e9e3f1d9$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        // whole string for whitespace-only strings
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        // empty for whitespace-only strings
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $1eccb725e9e3f1d9$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$1eccb725e9e3f1d9$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $1eccb725e9e3f1d9$var$reduce = Array.prototype.reduce;
function $1eccb725e9e3f1d9$export$2e2bcd8739ae039(options) {
    if (!(this instanceof $1eccb725e9e3f1d9$export$2e2bcd8739ae039)) return new $1eccb725e9e3f1d9$export$2e2bcd8739ae039(options);
    var defaults = {
        rules: $1eccb725e9e3f1d9$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $1eccb725e9e3f1d9$var$extend({}, defaults, options);
    this.rules = new $1eccb725e9e3f1d9$var$Rules(this.options);
}
$1eccb725e9e3f1d9$export$2e2bcd8739ae039.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function(input) {
        if (!$1eccb725e9e3f1d9$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $1eccb725e9e3f1d9$var$process.call(this, new $1eccb725e9e3f1d9$var$RootNode(input, this.options));
        return $1eccb725e9e3f1d9$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function(string) {
        return $1eccb725e9e3f1d9$var$escapeMarkdown(string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $1eccb725e9e3f1d9$var$process(parentNode) {
    var self = this;
    return $1eccb725e9e3f1d9$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $1eccb725e9e3f1d9$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $1eccb725e9e3f1d9$var$replacementForNode.call(self, node);
        return $1eccb725e9e3f1d9$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $1eccb725e9e3f1d9$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $1eccb725e9e3f1d9$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $1eccb725e9e3f1d9$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $1eccb725e9e3f1d9$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $1eccb725e9e3f1d9$var$join(output, replacement) {
    var s1 = $1eccb725e9e3f1d9$var$trimTrailingNewlines(output);
    var s2 = $1eccb725e9e3f1d9$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $1eccb725e9e3f1d9$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}


const $54a362fffda0374a$export$947b02d780c9a7f1 = 1;
const $54a362fffda0374a$export$fbfd612cb8efd2c6 = Object.freeze({
    theme: 'clean',
    font: 'system',
    fontSize: 16,
    lineHeight: 1.85,
    accent: '#0f6575',
    width: 'standard',
    phonePreview: false,
    externalFootnotes: false,
    scrollSync: true,
    view: 'split'
});
function $54a362fffda0374a$export$4cf11838cdc2a8a8(value = '') {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
function $54a362fffda0374a$export$c383cdd2a518017a(value = '') {
    const slug = String(value).trim().toLowerCase().normalize('NFKC').replace(/[^\p{Letter}\p{Number}_-]+/gu, '-').replace(/^-+|-+$/g, '');
    return slug || 'section';
}
function $54a362fffda0374a$export$364496161d416a8(value = "\u672A\u547D\u540D\u6587\u6863") {
    const cleaned = String(value).replace(/[\\/:*?"<>|\u0000-\u001f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 80);
    return cleaned || "\u672A\u547D\u540D\u6587\u6863";
}
function $54a362fffda0374a$export$f0a7a72d6a038c2e(value = '') {
    const url = String(value).trim();
    if (!url) return false;
    if (url.startsWith('#')) return /^#[\w\p{Letter}\p{Number}_.:-]+$/u.test(url);
    try {
        const parsed = new URL(url);
        return [
            'http:',
            'https:',
            'mailto:',
            'tel:'
        ].includes(parsed.protocol);
    } catch  {
        return false;
    }
}
function $54a362fffda0374a$export$1c9353028587d7fa(value = '') {
    const url = String(value).trim();
    if (/^data:image\/(?:png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i.test(url)) return true;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch  {
        return false;
    }
}
function $54a362fffda0374a$export$cdf4f5796ad55bea(raw = {}) {
    const source = raw && typeof raw === 'object' ? raw : {};
    const themes = new Set([
        'clean',
        'wechat',
        'toutiao',
        'developer',
        'notebook'
    ]);
    const fonts = new Set([
        'system',
        'sans',
        'serif',
        'mono'
    ]);
    const widths = new Set([
        'narrow',
        'standard',
        'wide'
    ]);
    const views = new Set([
        'editor',
        'split',
        'preview'
    ]);
    const fontSize = Number(source.fontSize);
    const lineHeight = Number(source.lineHeight);
    return {
        theme: themes.has(source.theme) ? source.theme : $54a362fffda0374a$export$fbfd612cb8efd2c6.theme,
        font: fonts.has(source.font) ? source.font : $54a362fffda0374a$export$fbfd612cb8efd2c6.font,
        fontSize: Number.isFinite(fontSize) ? Math.min(22, Math.max(14, fontSize)) : $54a362fffda0374a$export$fbfd612cb8efd2c6.fontSize,
        lineHeight: Number.isFinite(lineHeight) ? Math.min(2.15, Math.max(1.55, lineHeight)) : $54a362fffda0374a$export$fbfd612cb8efd2c6.lineHeight,
        accent: /^#[0-9a-f]{6}$/i.test(source.accent || '') ? source.accent.toLowerCase() : $54a362fffda0374a$export$fbfd612cb8efd2c6.accent,
        width: widths.has(source.width) ? source.width : $54a362fffda0374a$export$fbfd612cb8efd2c6.width,
        phonePreview: source.phonePreview === true,
        externalFootnotes: source.externalFootnotes === true,
        scrollSync: source.scrollSync !== false,
        view: views.has(source.view) ? source.view : $54a362fffda0374a$export$fbfd612cb8efd2c6.view
    };
}
function $54a362fffda0374a$export$a2a04c192c7d3572(markdown = '', fallback = "\u672A\u547D\u540D\u6587\u6863") {
    const heading = String(markdown).match(/^\s*#\s+(.+?)\s*#*\s*$/m);
    return $54a362fffda0374a$export$364496161d416a8(heading ? heading[1] : fallback);
}
function $54a362fffda0374a$export$9d385d4ab5f1705f(markdown = '') {
    const text = String(markdown);
    const characters = Array.from(text).length;
    const cjkCharacters = (text.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu) || []).length;
    const latinWords = (text.replace(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu, ' ').match(/[\p{Letter}\p{Number}]+(?:['’-][\p{Letter}\p{Number}]+)*/gu) || []).length;
    const words = cjkCharacters + latinWords;
    const paragraphs = text.trim() ? text.trim().split(/\n\s*\n/).filter((block)=>block.trim()).length : 0;
    const readingMinutes = words ? Math.max(1, Math.ceil(cjkCharacters / 300 + latinWords / 200)) : 0;
    return {
        characters: characters,
        words: words,
        paragraphs: paragraphs,
        readingMinutes: readingMinutes
    };
}
function $54a362fffda0374a$export$47774cf7fb07bfc4(value = '', selectionStart = 0) {
    const safeOffset = Math.max(0, Math.min(Number(selectionStart) || 0, String(value).length));
    const before = String(value).slice(0, safeOffset);
    const lines = before.split('\n');
    return {
        line: lines.length,
        column: (lines.at(-1) || '').length + 1
    };
}
function $54a362fffda0374a$var$lineRange(value, start, end) {
    const rangeStart = value.lastIndexOf('\n', Math.max(0, start - 1)) + 1;
    const nextBreak = value.indexOf('\n', end);
    const rangeEnd = nextBreak === -1 ? value.length : nextBreak;
    return {
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        text: value.slice(rangeStart, rangeEnd)
    };
}
function $54a362fffda0374a$var$wrapSelection(source, start, end, before, after, placeholder) {
    const selected = source.slice(start, end);
    const content = selected || placeholder;
    const wrapped = `${before}${content}${after}`;
    const value = source.slice(0, start) + wrapped + source.slice(end);
    if (selected) return {
        value: value,
        selectionStart: start + before.length,
        selectionEnd: start + before.length + selected.length
    };
    return {
        value: value,
        selectionStart: start + before.length,
        selectionEnd: start + before.length + placeholder.length
    };
}
function $54a362fffda0374a$var$toggleWrap(source, start, end, marker, placeholder) {
    const selected = source.slice(start, end);
    if (selected && source.slice(start - marker.length, start) === marker && source.slice(end, end + marker.length) === marker) return {
        value: source.slice(0, start - marker.length) + selected + source.slice(end + marker.length),
        selectionStart: start - marker.length,
        selectionEnd: end - marker.length
    };
    return $54a362fffda0374a$var$wrapSelection(source, start, end, marker, marker, placeholder);
}
function $54a362fffda0374a$var$prefixLines(source, start, end, formatter) {
    const { rangeStart: rangeStart, rangeEnd: rangeEnd, text: text } = $54a362fffda0374a$var$lineRange(source, start, end);
    const lines = text.split('\n');
    const replacement = lines.map((line, index)=>formatter(line, index)).join('\n');
    return {
        value: source.slice(0, rangeStart) + replacement + source.slice(rangeEnd),
        selectionStart: rangeStart,
        selectionEnd: rangeStart + replacement.length
    };
}
function $54a362fffda0374a$var$blockInsertion(source, start, end, content, selectText = '') {
    const leading = start > 0 && source[start - 1] !== '\n' ? '\n\n' : '';
    const trailing = end < source.length && source[end] !== '\n' ? '\n\n' : '';
    const insertion = `${leading}${content}${trailing}`;
    const value = source.slice(0, start) + insertion + source.slice(end);
    const selectionOffset = selectText ? insertion.indexOf(selectText) : insertion.length;
    return {
        value: value,
        selectionStart: start + selectionOffset,
        selectionEnd: start + selectionOffset + selectText.length
    };
}
function $54a362fffda0374a$export$e956be82b8b99c9(source = '', start = 0, end = start, action, options = {}) {
    const value = String(source);
    const safeStart = Math.max(0, Math.min(start, value.length));
    const safeEnd = Math.max(safeStart, Math.min(end, value.length));
    const selected = value.slice(safeStart, safeEnd);
    switch(action){
        case 'bold':
            return $54a362fffda0374a$var$toggleWrap(value, safeStart, safeEnd, '**', "\u91CD\u70B9\u6587\u5B57");
        case 'italic':
            return $54a362fffda0374a$var$toggleWrap(value, safeStart, safeEnd, '*', "\u5F3A\u8C03\u6587\u5B57");
        case 'strike':
            return $54a362fffda0374a$var$toggleWrap(value, safeStart, safeEnd, '~~', "\u5220\u9664\u6587\u5B57");
        case 'inline-code':
            return $54a362fffda0374a$var$toggleWrap(value, safeStart, safeEnd, '`', 'code');
        case 'link':
            {
                const label = selected || options.label || "\u94FE\u63A5\u6587\u5B57";
                const url = options.url || 'https://example.com';
                return $54a362fffda0374a$var$wrapSelection(value, safeStart, safeEnd, '[', `](${url})`, label);
            }
        case 'image':
            {
                const alt = options.alt || selected || "\u56FE\u7247\u8BF4\u660E";
                const url = options.url || 'https://example.com/image.jpg';
                const markdown = `![${alt}](${url})`;
                return $54a362fffda0374a$var$blockInsertion(value, safeStart, safeEnd, markdown, options.url ? '' : url);
            }
        case 'code-block':
            {
                const language = String(options.language || '').replace(/[^a-z0-9_+#.-]/gi, '').slice(0, 30);
                const code = selected || options.placeholder || "\u5728\u8FD9\u91CC\u8F93\u5165\u4EE3\u7801";
                return $54a362fffda0374a$var$blockInsertion(value, safeStart, safeEnd, `\`\`\`${language}\n${code}\n\`\`\``, code);
            }
        case 'heading-1':
        case 'heading-2':
        case 'heading-3':
            {
                const level = Number(action.at(-1));
                return $54a362fffda0374a$var$prefixLines(value, safeStart, safeEnd, (line)=>`${'#'.repeat(level)} ${line.replace(/^#{1,6}\s+/, '') || "\u6807\u9898"}`);
            }
        case 'quote':
            return $54a362fffda0374a$var$prefixLines(value, safeStart, safeEnd, (line)=>`> ${line.replace(/^>\s?/, '')}`);
        case 'unordered-list':
            return $54a362fffda0374a$var$prefixLines(value, safeStart, safeEnd, (line)=>`- ${line.replace(/^\s*(?:[-+*]|\d+[.)])\s+/, '') || "\u5217\u8868\u9879"}`);
        case 'ordered-list':
            return $54a362fffda0374a$var$prefixLines(value, safeStart, safeEnd, (line, index)=>`${index + 1}. ${line.replace(/^\s*(?:[-+*]|\d+[.)])\s+/, '') || "\u5217\u8868\u9879"}`);
        case 'task-list':
            return $54a362fffda0374a$var$prefixLines(value, safeStart, safeEnd, (line)=>`- [ ] ${line.replace(/^\s*[-+*]\s+(?:\[[ xX]\]\s*)?/, '') || "\u5F85\u529E\u4E8B\u9879"}`);
        case 'table':
            return $54a362fffda0374a$var$blockInsertion(value, safeStart, safeEnd, "| \u9879\u76EE | \u8BF4\u660E | \u72B6\u6001 |\n| --- | --- | --- |\n| \u793A\u4F8B | \u53EF\u76F4\u63A5\u4FEE\u6539 | \u5B8C\u6210 |", "\u793A\u4F8B");
        case 'horizontal-rule':
            return $54a362fffda0374a$var$blockInsertion(value, safeStart, safeEnd, '---');
        case 'toc':
            return $54a362fffda0374a$var$blockInsertion(value, safeStart, safeEnd, '[TOC]');
        default:
            return {
                value: value,
                selectionStart: safeStart,
                selectionEnd: safeEnd
            };
    }
}
function $54a362fffda0374a$export$2a533ee113497df1(raw, createFallback) {
    const fallback = typeof createFallback === 'function' ? createFallback : ()=>({
            id: 'draft',
            name: "\u672A\u547D\u540D\u6587\u6863",
            content: ''
        });
    if (!raw || typeof raw !== 'object' || !Array.isArray(raw.documents)) {
        const document = fallback();
        return {
            version: $54a362fffda0374a$export$947b02d780c9a7f1,
            activeId: document.id,
            documents: [
                document
            ]
        };
    }
    const seenIds = new Set();
    const documents = raw.documents.filter((item)=>item && typeof item === 'object' && typeof item.id === 'string').slice(0, 100).filter((item)=>{
        const id = item.id.slice(0, 100);
        if (!id || seenIds.has(id)) return false;
        seenIds.add(id);
        return true;
    }).map((item)=>({
            id: item.id.slice(0, 100),
            name: $54a362fffda0374a$export$364496161d416a8(item.name),
            content: typeof item.content === 'string' ? item.content : '',
            createdAt: Number.isFinite(item.createdAt) ? item.createdAt : Date.now(),
            updatedAt: Number.isFinite(item.updatedAt) ? item.updatedAt : Date.now()
        }));
    if (!documents.length) documents.push(fallback());
    const activeId = documents.some((item)=>item.id === raw.activeId) ? raw.activeId : documents[0].id;
    return {
        version: $54a362fffda0374a$export$947b02d780c9a7f1,
        activeId: activeId,
        documents: documents
    };
}



const $f0987e643bba202a$var$BASE_EXPORT_CSS = `
*,*::before,*::after{box-sizing:border-box}
html{scroll-behavior:smooth;background:var(--page-bg)}
body{margin:0;background:var(--page-bg);color:var(--text);font-family:var(--document-font);font-size:var(--document-size);line-height:var(--document-leading);-webkit-font-smoothing:antialiased}
.export-page{width:min(calc(100% - 32px),var(--document-width));min-height:100vh;margin:0 auto;padding:64px 0 96px}
.export-header{margin:0 0 44px;padding:0 0 24px;border-bottom:1px solid var(--border)}
.export-kicker{margin:0 0 8px;color:var(--accent);font:700 12px/1.4 ui-monospace,SFMono-Regular,Menlo,monospace;letter-spacing:.12em;text-transform:uppercase}
.export-header h1{margin:0;color:var(--heading);font-size:clamp(32px,7vw,52px);line-height:1.08;letter-spacing:-.04em;text-wrap:balance}
.export-meta{margin:12px 0 0;color:var(--muted);font-size:.82em}
.md-content{overflow-wrap:anywhere}
.md-content h1,.md-content h2,.md-content h3,.md-content h4,.md-content h5,.md-content h6{color:var(--heading);line-height:1.28;text-wrap:balance;scroll-margin-top:24px}
.md-content h1{margin:2em 0 .65em;font-size:2em;letter-spacing:-.03em}
.md-content h2{margin:1.8em 0 .65em;font-size:1.5em;letter-spacing:-.02em}
.md-content h3{margin:1.6em 0 .55em;font-size:1.2em}
.md-content h4,.md-content h5,.md-content h6{margin:1.45em 0 .5em;font-size:1em}
.md-content p{margin:0 0 1em}
.md-content a{color:var(--accent);text-decoration-thickness:1px;text-underline-offset:3px}
.md-content strong{color:var(--heading);font-weight:700}
.md-content ul,.md-content ol{margin:.75em 0 1.15em;padding-left:1.5em}
.md-content li{margin:.35em 0;padding-left:.15em}
.md-content li.task-list-item{list-style:none;margin-left:-1.25em}
.md-content input[type=checkbox]{margin:0 .55em 0 0;accent-color:var(--accent)}
.md-content blockquote{margin:1.4em 0;padding:.9em 1.1em;border-left:4px solid var(--accent);background:var(--quote-bg);color:var(--muted)}
.md-content blockquote p:last-child{margin-bottom:0}
.md-content hr{height:1px;margin:2.25em 0;border:0;background:var(--border)}
.md-content img{display:block;max-width:100%;height:auto;margin:1.4em auto;border-radius:10px}
.md-content table{display:table;width:100%;margin:1.4em 0;border-collapse:collapse;font-size:.9em}
.md-content th,.md-content td{padding:.68em .8em;border:1px solid var(--border);text-align:left;vertical-align:top}
.md-content th{background:var(--table-head);color:var(--heading);font-weight:700}
.md-content code{padding:.15em .38em;border-radius:4px;background:var(--inline-code-bg);color:var(--inline-code);font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-size:.88em}
.md-content pre{position:relative;margin:1.4em 0;padding:18px 20px;overflow:auto;border:1px solid var(--code-border);border-radius:10px;background:var(--code-bg);color:var(--code-text);line-height:1.62;tab-size:2}
.md-content pre code{padding:0;background:transparent;color:inherit;font-size:.82em;white-space:pre}
.md-toc{margin:1.35em 0;padding:18px 20px;border:1px solid var(--border);border-radius:10px;background:var(--surface)}
.md-toc-title{margin:0 0 8px;color:var(--heading);font-weight:700}
.md-toc a{display:block;padding:3px 0;color:var(--muted);text-decoration:none}
.md-toc a:hover{color:var(--accent)}
.md-toc .toc-level-2{padding-left:1em}.md-toc .toc-level-3{padding-left:2em}.md-toc .toc-level-4{padding-left:3em}
.footnote-ref{margin-left:2px;font-size:.72em;vertical-align:super}.link-footnotes{margin-top:3em;padding-top:1.2em;border-top:1px solid var(--border);font-size:.82em;color:var(--muted)}
.studio-diagram{margin:1.5em 0;padding:14px;overflow:auto;border:1px solid var(--border);border-radius:10px;background:var(--surface)}
.studio-diagram svg{display:block;min-width:520px;max-width:100%;height:auto;margin:auto}.diagram-node{fill:var(--surface);stroke:var(--accent);stroke-width:2}.diagram-edge{stroke:var(--muted);stroke-width:1.5}.diagram-label{fill:var(--heading);font:500 13px var(--document-font)}
.math-expression{font-family:'Times New Roman','Songti SC',serif;letter-spacing:.015em}.math-display{display:block;margin:1.3em 0;padding:.75em 1em;overflow:auto;text-align:center}.math-fraction{display:inline-flex;flex-direction:column;align-items:center;vertical-align:middle;line-height:1.1}.math-fraction>span:first-child{padding:0 .2em .1em;border-bottom:1px solid currentColor}.math-fraction>span:last-child{padding:.1em .2em 0}
.tok-comment{color:#77818f;font-style:italic}.tok-string{color:#a7d7a2}.tok-number{color:#efb57a}.tok-keyword{color:#89b9f8;font-weight:600}.tok-literal{color:#cf9cf2}.tok-tag{color:#7bdff2}.tok-attr{color:#f3cf7a}
.enhancement-fallback{margin:1.25em 0;border:1px solid var(--border);border-radius:10px;overflow:hidden}.enhancement-fallback strong{display:block;padding:9px 12px;background:var(--table-head);color:var(--heading);font-size:.78em}.enhancement-fallback pre{margin:0;border:0;border-radius:0}
.export-footer{margin-top:64px;padding-top:18px;border-top:1px solid var(--border);color:var(--muted);font-size:12px}
@media(max-width:680px){.export-page{width:min(calc(100% - 28px),var(--document-width));padding:36px 0 64px}.export-header{margin-bottom:32px}.md-content table{display:block;overflow-x:auto}.md-content pre{padding:15px}}
@media print{@page{margin:16mm 15mm}.export-page{width:100%;max-width:none;padding:0}.export-footer{display:none}.md-content a{color:inherit}.md-content pre,.md-content blockquote,.md-content table,.studio-diagram{break-inside:avoid}html,body{background:#fff!important}}
`;
const $f0987e643bba202a$export$b8020e85ad90bfe5 = [
    {
        id: 'clean',
        name: 'Clean',
        desc: "\u6E05\u6670\u3001\u4E2D\u6027\u7684\u901A\u7528\u53D1\u5E03\u7248\u5F0F",
        css: `
:root{--page-bg:#eef2f5;--surface:#fff;--text:#374151;--heading:#101827;--muted:#667085;--border:#dce3e9;--quote-bg:#f2f8fa;--table-head:#f5f7f9;--inline-code-bg:#edf2f5;--inline-code:#155e75;--code-bg:#172033;--code-border:#26334a;--code-text:#e7edf7}
.export-page{max-width:calc(var(--document-width) + 96px);padding:64px 48px 96px;background:#fff;box-shadow:0 22px 70px rgba(30,48,72,.11)}
.export-header{border-bottom-width:2px;border-bottom-color:var(--accent)}
`
    },
    {
        id: 'wechat',
        name: 'WeChat',
        desc: "\u9002\u5408\u516C\u4F17\u53F7\u5BCC\u6587\u672C\u7C98\u8D34\u7684\u8212\u5C55\u4E2D\u6587\u6392\u7248",
        css: `
:root{--page-bg:#f3f4f5;--surface:#fff;--text:#3f3f3f;--heading:#171717;--muted:#7a7a7a;--border:#e7e7e7;--quote-bg:#f4faf7;--table-head:#f5f5f5;--inline-code-bg:#f3f5f7;--inline-code:#45536a;--code-bg:#f6f8fa;--code-border:#e4e8ec;--code-text:#263243}
.export-page{max-width:640px;padding:46px 32px 80px;background:#fff;box-shadow:0 16px 60px rgba(17,24,39,.07)}
.export-header{text-align:center}.export-kicker{color:var(--muted)}.export-header h1{font-size:36px;letter-spacing:-.025em}
.md-content{line-height:2}.md-content h2{padding-left:12px;border-left:4px solid var(--accent)}.md-content h1{text-align:center}.md-content h1::after{display:block;width:42px;height:3px;margin:12px auto 0;background:var(--accent);content:''}
.md-content p{text-align:justify}.md-content img{border-radius:4px}
`
    },
    {
        id: 'toutiao',
        name: 'Toutiao',
        desc: "\u6807\u9898\u9192\u76EE\u3001\u6B63\u6587\u7D27\u51D1\u7684\u8D44\u8BAF\u6587\u7AE0\u7248\u5F0F",
        css: `
:root{--page-bg:#f4f5f6;--surface:#fff;--text:#333;--heading:#161616;--muted:#777;--border:#e8e8e8;--quote-bg:#fff6f6;--table-head:#f5f6f7;--inline-code-bg:#f5f6f7;--inline-code:#3f4550;--code-bg:#f7f8fa;--code-border:#e8e9eb;--code-text:#2d3748}
.export-page{max-width:700px;padding:42px 34px 78px;background:#fff;box-shadow:0 12px 40px rgba(31,41,55,.06)}
.export-header{border-bottom:0}.export-header h1{font-size:40px;font-weight:800}.export-kicker{color:var(--accent)}
.md-content h1,.md-content h2{position:relative;padding-left:14px}.md-content h1::before,.md-content h2::before{position:absolute;top:.12em;bottom:.12em;left:0;width:4px;border-radius:2px;background:var(--accent);content:''}
.md-content p{text-align:justify}.md-content blockquote{border-radius:0 8px 8px 0}
`
    },
    {
        id: 'developer',
        name: 'Developer',
        desc: "\u4EE3\u7801\u3001\u8868\u683C\u548C\u6280\u672F\u6587\u6863\u4F18\u5148\u7684\u5F00\u53D1\u8005\u4E3B\u9898",
        css: `
:root{--page-bg:#e9eef3;--surface:#fff;--text:#334155;--heading:#0f172a;--muted:#64748b;--border:#cfd9e4;--quote-bg:#edf8fa;--table-head:#eef3f7;--inline-code-bg:#e5edf3;--inline-code:#0e7490;--code-bg:#0b1320;--code-border:#233248;--code-text:#dce7f4}
.export-page{max-width:calc(var(--document-width) + 100px);padding:64px 50px 96px;background:#fff;box-shadow:0 22px 70px rgba(30,48,72,.12)}.export-header{border-bottom-color:var(--accent)}
.export-header h1,.md-content h1,.md-content h2{font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace}.md-content h2::before{color:var(--accent);content:'## ';font-weight:500}.md-content h3::before{color:var(--accent);content:'### ';font-weight:500}
.md-content img{border:1px solid var(--border)}
`
    },
    {
        id: 'notebook',
        name: 'Notebook',
        desc: "\u6E29\u6696\u7EB8\u5F20\u611F\uFF0C\u9002\u5408\u968F\u7B14\u3001\u8BFB\u4E66\u7B14\u8BB0\u548C\u957F\u6587",
        css: `
:root{--page-bg:#ece8df;--surface:#fffdf7;--text:#443f38;--heading:#25211d;--muted:#746d64;--border:#ddd5c6;--quote-bg:#f5f0e5;--table-head:#f3ede1;--inline-code-bg:#eee7da;--inline-code:#7c4a25;--code-bg:#292722;--code-border:#3b3831;--code-text:#eee8dc}
.export-page{max-width:calc(var(--document-width) + 112px);padding:68px 56px 104px;background:#fffdf7;box-shadow:0 24px 70px rgba(68,54,37,.13)}
.export-header h1,.md-content h1,.md-content h2,.md-content h3{font-family:Georgia,'Songti SC','STSong',serif}.export-kicker{color:var(--accent)}
.md-content{font-family:Georgia,'Songti SC','STSong',serif}.md-content h2{padding-bottom:.35em;border-bottom:1px solid var(--border)}
`
    }
];
function $f0987e643bba202a$export$9b1a70d8e05b0fa6(templateId = 'clean') {
    return $f0987e643bba202a$export$b8020e85ad90bfe5.find((template)=>template.id === templateId) || $f0987e643bba202a$export$b8020e85ad90bfe5[0];
}
function $f0987e643bba202a$export$f5216173b9833475(html = '') {
    const counters = new Map();
    return String(html).replace(/<h([1-6])([^>]*)>([\s\S]*?)<\/h\1>/gi, (match, level, attributes, innerHtml)=>{
        if (/\sid\s*=\s*["']/i.test(attributes)) return match;
        const text = innerHtml.replace(/<[^>]+>/g, '');
        const base = (0, $54a362fffda0374a$export$c383cdd2a518017a)(text);
        const count = (counters.get(base) || 0) + 1;
        counters.set(base, count);
        const id = count === 1 ? base : `${base}-${count}`;
        return `<h${level}${attributes} id="${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(id)}">${innerHtml}</h${level}>`;
    });
}
function $f0987e643bba202a$export$1cd209268f609233(html = '') {
    return String(html);
}
function $f0987e643bba202a$var$normalizeOptions(options = {}) {
    const fontMap = {
        system: "-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC',sans-serif",
        sans: "'Avenir Next','PingFang SC','Microsoft YaHei',sans-serif",
        serif: "Georgia,'Songti SC','STSong',serif",
        mono: "ui-monospace,SFMono-Regular,Menlo,Consolas,'PingFang SC',monospace"
    };
    const widthMap = {
        narrow: 620,
        standard: 760,
        wide: 980
    };
    const fontSize = Math.min(24, Math.max(13, Number(options.fontSize) || 16));
    const lineHeight = Math.min(2.4, Math.max(1.35, Number(options.lineHeight) || 1.8));
    const accent = /^#[0-9a-f]{6}$/i.test(options.accent || '') ? options.accent : '#0f6575';
    const width = widthMap[options.width] || widthMap.standard;
    return {
        font: fontMap[options.font] || fontMap.system,
        fontSize: fontSize,
        lineHeight: lineHeight,
        accent: accent,
        width: width
    };
}
function $f0987e643bba202a$export$a0a6d751ded41a34(body, templateId = 'clean', title = "\u672A\u547D\u540D\u6587\u6863", options = {}) {
    const template = $f0987e643bba202a$export$9b1a70d8e05b0fa6(templateId);
    const settings = $f0987e643bba202a$var$normalizeOptions(options);
    const safeTitle = (0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(title || "\u672A\u547D\u540D\u6587\u6863");
    const exportedAt = options.exportedAt || new Date().toLocaleDateString('zh-CN');
    const titleBlock = options.includeTitle === false ? '' : `<header class="export-header"><p class="export-kicker">Markdown document</p><h1>${safeTitle}</h1><p class="export-meta">\u{5BFC}\u{51FA}\u{4E8E} ${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(exportedAt)}</p></header>`;
    return `<!doctype html>
<html lang="zh-CN">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <meta name="referrer" content="no-referrer">
  <title>${safeTitle}</title>
  <style>
    :root{--accent:${settings.accent};--document-font:${settings.font};--document-size:${settings.fontSize}px;--document-leading:${settings.lineHeight};--document-width:${settings.width}px}
    ${$f0987e643bba202a$var$BASE_EXPORT_CSS}
    ${template.css}
  </style>
</head>
<body>
  <main class="export-page">
    ${titleBlock}
    <article class="md-content">${body}</article>
    <footer class="export-footer">\u{7531} Practical Tools Markdown \u{53D1}\u{5E03}\u{5DE5}\u{4F5C}\u{5BA4}\u{5BFC}\u{51FA}</footer>
  </main>
</body>
</html>`;
}


const $4e9d41a2c9416514$var$MERMAID_RUNTIME_URL = '/vendor/mermaid.min.js';
const $4e9d41a2c9416514$var$DOCUMENT_STORAGE_KEY = 'practicaltools.markdown-studio.documents.v1';
const $4e9d41a2c9416514$var$SETTINGS_STORAGE_KEY = 'practicaltools.markdown-studio.settings.v1';
const $4e9d41a2c9416514$var$CORRUPT_BACKUP_KEY = 'practicaltools.markdown-studio.corrupt-backup.v1';
const $4e9d41a2c9416514$var$AUTOSAVE_DELAY = 550;
const $4e9d41a2c9416514$var$PREVIEW_DELAY = 90;
const $4e9d41a2c9416514$var$LARGE_IMAGE_DATA_LENGTH = 900000;
const $4e9d41a2c9416514$var$MAX_IMAGE_EDGE = 1800;
const $4e9d41a2c9416514$var$MAX_DOCUMENT_BYTES = 20971520;
const $4e9d41a2c9416514$var$MAX_IMAGE_BYTES = 12582912;
const $4e9d41a2c9416514$var$DEFAULT_MARKDOWN = `# \u{4E00}\u{7BC7}\u{53EF}\u{53D1}\u{5E03}\u{7684} Markdown \u{8349}\u{7A3F}

\u{5728}\u{5DE6}\u{4FA7}\u{5199}\u{4F5C}\u{FF0C}\u{53F3}\u{4FA7}\u{4F1A}\u{663E}\u{793A}\u{7ECF}\u{8FC7}\u{5B89}\u{5168}\u{5904}\u{7406}\u{7684}\u{5B9E}\u{65F6}\u{9884}\u{89C8}\u{3002}\u{8349}\u{7A3F}\u{53EA}\u{4FDD}\u{5B58}\u{5728}\u{5F53}\u{524D}\u{6D4F}\u{89C8}\u{5668}\u{FF0C}\u{8BF7}\u{4E3A}\u{91CD}\u{8981}\u{5185}\u{5BB9}\u{5B9A}\u{671F}\u{5BFC}\u{51FA} Markdown\u{3002}

[TOC]

## \u{4ECE}\u{7ED3}\u{6784}\u{5F00}\u{59CB}

\u{4F7F}\u{7528} **\u{7C97}\u{4F53}**\u{3001}*\u{659C}\u{4F53}*\u{3001}~~\u{5220}\u{9664}\u{7EBF}~~\u{3001}[\u{5B89}\u{5168}\u{94FE}\u{63A5}](https://practicaltools.xyz/) \u{548C} \`inline code\`\u{3002}

- [x] \u{5199}\u{4E0B}\u{6838}\u{5FC3}\u{89C2}\u{70B9}
- [ ] \u{68C0}\u{67E5}\u{79FB}\u{52A8}\u{7AEF}\u{9884}\u{89C8}
- [ ] \u{7C98}\u{8D34}\u{5230}\u{76EE}\u{6807}\u{53D1}\u{5E03}\u{5E73}\u{53F0}\u{590D}\u{67E5}

## \u{53D1}\u{5E03}\u{68C0}\u{67E5}\u{8868}

| \u{68C0}\u{67E5}\u{9879} | \u{5EFA}\u{8BAE} |
| --- | --- |
| \u{6807}\u{9898}\u{5C42}\u{7EA7} | \u{4ECE} H1 \u{5230} H3 \u{4F9D}\u{6B21}\u{4F7F}\u{7528} |
| \u{56FE}\u{7247} | \u{5927}\u{56FE}\u{4F1A}\u{5728}\u{672C}\u{5730}\u{538B}\u{7F29}\u{5E76}\u{5185}\u{5D4C} |
| \u{5907}\u{4EFD} | \u{4E0B}\u{8F7D}\u{4E00}\u{4EFD} .md \u{6E90}\u{7A3F} |

> \u{5BCC}\u{6587}\u{672C}\u{590D}\u{5236}\u{4F1A}\u{5185}\u{8054}\u{5F53}\u{524D}\u{9884}\u{89C8}\u{7684}\u{5173}\u{952E}\u{6837}\u{5F0F}\u{FF0C}\u{4F46}\u{516C}\u{4F17}\u{53F7}\u{3001}\u{5934}\u{6761}\u{7B49}\u{5E73}\u{53F0}\u{4ECD}\u{53EF}\u{80FD}\u{4E8C}\u{6B21}\u{8FC7}\u{6EE4}\u{6392}\u{7248}\u{3002}

\`\`\`javascript
const sourceOfTruth = 'Markdown';
console.log(sourceOfTruth);
\`\`\`
`;
const $4e9d41a2c9416514$var$FONT_STACKS = {
    system: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', sans-serif",
    sans: "'Avenir Next', 'PingFang SC', 'Microsoft YaHei', sans-serif",
    serif: "Georgia, 'Songti SC', 'STSong', serif",
    mono: "ui-monospace, SFMono-Regular, Menlo, Consolas, 'PingFang SC', monospace"
};
const $4e9d41a2c9416514$var$WIDTHS = {
    narrow: '620px',
    standard: '760px',
    wide: '980px'
};
const $4e9d41a2c9416514$var$SANITIZE_CONFIG = {
    USE_PROFILES: {
        html: true,
        svg: true,
        svgFilters: true,
        mathMl: true
    },
    ADD_ATTR: [
        'target',
        'rel',
        'loading',
        'decoding',
        'referrerpolicy',
        'aria-label',
        'aria-hidden',
        'role'
    ],
    FORBID_TAGS: [
        'script',
        'style',
        'iframe',
        'object',
        'embed',
        'form',
        'button',
        'textarea',
        'select',
        'option',
        'meta',
        'link',
        'base'
    ],
    FORBID_ATTR: [
        'srcdoc'
    ],
    ALLOW_DATA_ATTR: true
};
const $4e9d41a2c9416514$var$INLINE_STYLE_PROPERTIES = [
    'background-color',
    'border-bottom-color',
    'border-bottom-style',
    'border-bottom-width',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-top-color',
    'border-top-style',
    'border-top-width',
    'box-sizing',
    'color',
    'display',
    'font-family',
    'font-size',
    'font-style',
    'font-weight',
    'height',
    'letter-spacing',
    'line-height',
    'list-style-position',
    'list-style-type',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'max-width',
    'min-width',
    'overflow-wrap',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'text-align',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-style',
    'text-indent',
    'vertical-align',
    'white-space',
    'width',
    'word-break'
];
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('bash', (0, $cb37c5af6f7deacf$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('css', (0, $2a3933687d11bb55$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('javascript', (0, $492389ce22d189c0$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('json', (0, $b43b096b944cdbed$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('markdown', (0, $551e005fa09f7536$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('python', (0, $d39b89a63fc49297$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('sql', (0, $f00738a6b250c946$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('typescript', (0, $aff81ef2d84fecb4$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerLanguage('xml', (0, $c1fae4de0ffeee41$export$2e2bcd8739ae039));
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'sh',
    'shell',
    'zsh'
], {
    languageName: 'bash'
});
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'js',
    'jsx'
], {
    languageName: 'javascript'
});
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'ts',
    'tsx'
], {
    languageName: 'typescript'
});
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'html',
    'svg'
], {
    languageName: 'xml'
});
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'md'
], {
    languageName: 'markdown'
});
(0, $c68f397613df4d31$export$2e2bcd8739ae039).registerAliases([
    'py'
], {
    languageName: 'python'
});
const $4e9d41a2c9416514$var$turndown = new (0, $1eccb725e9e3f1d9$export$2e2bcd8739ae039)({
    headingStyle: 'atx',
    codeBlockStyle: 'fenced',
    bulletListMarker: '-',
    emDelimiter: '*',
    strongDelimiter: '**'
});
$4e9d41a2c9416514$var$turndown.remove([
    'script',
    'style',
    'iframe',
    'object',
    'embed',
    'form',
    'noscript'
]);
$4e9d41a2c9416514$var$turndown.addRule('strikethrough', {
    filter: [
        'del',
        's',
        'strike'
    ],
    replacement (content) {
        return content.trim() ? `~~${content}~~` : '';
    }
});
$4e9d41a2c9416514$var$turndown.addRule('tableCell', {
    filter: [
        'th',
        'td'
    ],
    replacement (content) {
        return ` ${content.trim().replace(/\|/g, '\\|')} |`;
    }
});
$4e9d41a2c9416514$var$turndown.addRule('tableRow', {
    filter: 'tr',
    replacement (content, node) {
        const row = `|${content}\n`;
        if (!node.parentElement || node.parentElement.querySelector('tr') !== node) return row;
        const columns = Math.max(1, node.querySelectorAll('th,td').length);
        return `${row}|${' --- |'.repeat(columns)}\n`;
    }
});
$4e9d41a2c9416514$var$turndown.addRule('table', {
    filter: 'table',
    replacement (content) {
        return `\n\n${content.trim()}\n\n`;
    }
});
function $4e9d41a2c9416514$var$renderCode({ text: text, lang: lang = '' }) {
    const language = String(lang || '').trim().split(/\s+/)[0].toLowerCase();
    if (language === 'mermaid') return `<div class="enhancement-fallback mermaid-fallback"><strong>Mermaid \u{56FE}\u{8868} \xb7 \u{6B63}\u{5728}\u{5B89}\u{5168}\u{6E32}\u{67D3}</strong><pre><code class="language-mermaid">${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(text)}</code></pre></div>`;
    let highlighted = (0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(text);
    let languageClass = '';
    if (language && (0, $c68f397613df4d31$export$2e2bcd8739ae039).getLanguage(language)) {
        highlighted = (0, $c68f397613df4d31$export$2e2bcd8739ae039).highlight(text, {
            language: language,
            ignoreIllegals: true
        }).value;
        languageClass = ` language-${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(language)}`;
    }
    return `<pre><code class="hljs${languageClass}">${highlighted}</code></pre>`;
}
const $4e9d41a2c9416514$var$markdownParser = new (0, $338e5c1bfb697578$export$164128c95a350e30)({
    gfm: true,
    breaks: true,
    renderer: {
        html (token) {
            const source = (0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(token.text || '');
            return token.block ? `<pre class="studio-raw-html"><code>${source}</code></pre>` : `<code class="studio-raw-html">${source}</code>`;
        },
        code (token) {
            return $4e9d41a2c9416514$var$renderCode(token);
        }
    },
    extensions: [
        {
            name: 'mathBlock',
            level: 'block',
            start (source) {
                return source.indexOf('$$');
            },
            tokenizer (source) {
                const match = /^\$\$[ \t]*\n?([\s\S]+?)\n?\$\$(?:\n|$)/.exec(source);
                if (!match) return undefined;
                return {
                    type: 'mathBlock',
                    raw: match[0],
                    text: match[1].trim()
                };
            },
            renderer (token) {
                return `<div class="math-placeholder math-display" data-display-mode="true">${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(token.text)}</div>`;
            }
        },
        {
            name: 'mathInline',
            level: 'inline',
            start (source) {
                return source.indexOf('$');
            },
            tokenizer (source) {
                const match = /^\$([^$\n]+?)\$/.exec(source);
                if (!match) return undefined;
                return {
                    type: 'mathInline',
                    raw: match[0],
                    text: match[1].trim()
                };
            },
            renderer (token) {
                return `<span class="math-placeholder" data-display-mode="false">${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(token.text)}</span>`;
            }
        }
    ]
});
const $4e9d41a2c9416514$var$$ = (id)=>document.getElementById(id);
const $4e9d41a2c9416514$var$app = $4e9d41a2c9416514$var$$('app');
if ($4e9d41a2c9416514$var$app) $4e9d41a2c9416514$var$initializeStudio();



function $4e9d41a2c9416514$var$initializeStudio() {
    const elements = {
        accentInput: $4e9d41a2c9416514$var$$('accentInput'),
        accentOutput: $4e9d41a2c9416514$var$$('accentOutput'),
        characterStat: $4e9d41a2c9416514$var$$('characterStat'),
        confirmDialog: $4e9d41a2c9416514$var$$('confirmDialog'),
        confirmDialogForm: $4e9d41a2c9416514$var$$('confirmDialogForm'),
        confirmDialogMessage: $4e9d41a2c9416514$var$$('confirmDialogMessage'),
        cursorStat: $4e9d41a2c9416514$var$$('cursorStat'),
        deleteDocumentButton: $4e9d41a2c9416514$var$$('deleteDocumentButton'),
        documentDialog: $4e9d41a2c9416514$var$$('documentDialog'),
        documentDialogDescription: $4e9d41a2c9416514$var$$('documentDialogDescription'),
        documentDialogForm: $4e9d41a2c9416514$var$$('documentDialogForm'),
        documentDialogTitle: $4e9d41a2c9416514$var$$('documentDialogTitle'),
        documentImportInput: $4e9d41a2c9416514$var$$('documentImportInput'),
        documentList: $4e9d41a2c9416514$var$$('documentList'),
        documentNameInput: $4e9d41a2c9416514$var$$('documentNameInput'),
        documentTitle: $4e9d41a2c9416514$var$$('documentTitle'),
        documentsPanel: $4e9d41a2c9416514$var$$('documentsPanel'),
        drawerScrim: $4e9d41a2c9416514$var$$('drawerScrim'),
        duplicateDocumentButton: $4e9d41a2c9416514$var$$('duplicateDocumentButton'),
        editorDropZone: $4e9d41a2c9416514$var$$('editorDropZone'),
        enhancementStatus: $4e9d41a2c9416514$var$$('enhancementStatus'),
        exportMenu: $4e9d41a2c9416514$var$$('exportMenu'),
        fontSelect: $4e9d41a2c9416514$var$$('fontSelect'),
        fontSizeSelect: $4e9d41a2c9416514$var$$('fontSizeSelect'),
        footnoteToggle: $4e9d41a2c9416514$var$$('footnoteToggle'),
        formatToolbar: $4e9d41a2c9416514$var$$('formatToolbar'),
        imageAltInput: $4e9d41a2c9416514$var$$('imageAltInput'),
        imageDialog: $4e9d41a2c9416514$var$$('imageDialog'),
        imageDialogForm: $4e9d41a2c9416514$var$$('imageDialogForm'),
        imageInput: $4e9d41a2c9416514$var$$('imageInput'),
        imageUrlInput: $4e9d41a2c9416514$var$$('imageUrlInput'),
        importButton: $4e9d41a2c9416514$var$$('importButton'),
        lineHeightSelect: $4e9d41a2c9416514$var$$('lineHeightSelect'),
        linkDialog: $4e9d41a2c9416514$var$$('linkDialog'),
        linkDialogForm: $4e9d41a2c9416514$var$$('linkDialogForm'),
        linkTextInput: $4e9d41a2c9416514$var$$('linkTextInput'),
        linkUrlInput: $4e9d41a2c9416514$var$$('linkUrlInput'),
        markdownSource: $4e9d41a2c9416514$var$$('markdownSource'),
        mobilePreviewToggle: $4e9d41a2c9416514$var$$('mobilePreviewToggle'),
        newDocumentButton: $4e9d41a2c9416514$var$$('newDocumentButton'),
        outlineCount: $4e9d41a2c9416514$var$$('outlineCount'),
        outlineList: $4e9d41a2c9416514$var$$('outlineList'),
        paragraphStat: $4e9d41a2c9416514$var$$('paragraphStat'),
        previewDocument: $4e9d41a2c9416514$var$$('previewDocument'),
        previewScroller: $4e9d41a2c9416514$var$$('previewScroller'),
        readingStat: $4e9d41a2c9416514$var$$('readingStat'),
        renameDocumentButton: $4e9d41a2c9416514$var$$('renameDocumentButton'),
        richCopyButton: $4e9d41a2c9416514$var$$('richCopyButton'),
        saveStatus: $4e9d41a2c9416514$var$$('saveStatus'),
        scrollSyncToggle: $4e9d41a2c9416514$var$$('scrollSyncToggle'),
        settingsPanel: $4e9d41a2c9416514$var$$('settingsPanel'),
        sidebarToggle: $4e9d41a2c9416514$var$$('sidebarToggle'),
        storageWarning: $4e9d41a2c9416514$var$$('storageWarning'),
        themeSelect: $4e9d41a2c9416514$var$$('themeSelect'),
        toastRegion: $4e9d41a2c9416514$var$$('toastRegion'),
        widthSelect: $4e9d41a2c9416514$var$$('widthSelect'),
        wordStat: $4e9d41a2c9416514$var$$('wordStat')
    };
    let storageIssue = '';
    let imageSizeWarning = false;
    let documentsState = loadDocuments();
    let settings = loadSettings();
    let previewTimer = 0;
    let saveTimer = 0;
    let toastTimer = 0;
    let renderGeneration = 0;
    let dragDepth = 0;
    let scrollLock = false;
    let mermaidInstance = null;
    let enhancementPromise = Promise.resolve();
    let mermaidLoadPromise = null;
    populateThemeOptions();
    applySettingsToControls();
    renderDocumentList();
    loadActiveDocument();
    bindEvents();
    applySettings();
    renderPreview();
    updateStats();
    updateCursor();
    persistDocuments();
    function makeDocument(name = "\u672A\u547D\u540D\u6587\u6863", content = '') {
        const timestamp = Date.now();
        return {
            id: globalThis.crypto?.randomUUID?.() || `draft-${timestamp}-${Math.random().toString(36).slice(2, 9)}`,
            name: (0, $54a362fffda0374a$export$364496161d416a8)(name),
            content: String(content),
            createdAt: timestamp,
            updatedAt: timestamp
        };
    }
    function fallbackDocument() {
        return makeDocument("\u5165\u95E8\u793A\u4F8B", $4e9d41a2c9416514$var$DEFAULT_MARKDOWN);
    }
    function activeDocument() {
        return documentsState.documents.find((document1)=>document1.id === documentsState.activeId) || documentsState.documents[0];
    }
    function loadDocuments() {
        try {
            const serialized = localStorage.getItem($4e9d41a2c9416514$var$DOCUMENT_STORAGE_KEY);
            if (!serialized) return (0, $54a362fffda0374a$export$2a533ee113497df1)(null, fallbackDocument);
            try {
                return (0, $54a362fffda0374a$export$2a533ee113497df1)(JSON.parse(serialized), fallbackDocument);
            } catch (error) {
                try {
                    localStorage.setItem($4e9d41a2c9416514$var$CORRUPT_BACKUP_KEY, serialized.slice(0, 2000000));
                } catch  {
                // The primary recovery path below still works if the backup also exceeds quota.
                }
                storageIssue = "\u68C0\u6D4B\u5230\u635F\u574F\u7684\u672C\u5730\u8349\u7A3F\u6570\u636E\u3002\u5DF2\u6253\u5F00\u6062\u590D\u6587\u6863\uFF1B\u8BF7\u5148\u5BFC\u51FA Markdown \u518D\u7EE7\u7EED\u3002";
                console.warn('Markdown Studio could not parse stored drafts.', error);
                return (0, $54a362fffda0374a$export$2a533ee113497df1)(null, ()=>makeDocument("\u6062\u590D\u6587\u6863", $4e9d41a2c9416514$var$DEFAULT_MARKDOWN));
            }
        } catch (error) {
            storageIssue = "\u6D4F\u89C8\u5668\u963B\u6B62\u4E86\u672C\u5730\u5B58\u50A8\u3002\u5F53\u524D\u5185\u5BB9\u53EA\u5728\u672C\u9875\u6253\u5F00\u671F\u95F4\u4FDD\u7559\uFF0C\u8BF7\u53CA\u65F6\u5BFC\u51FA Markdown\u3002";
            console.warn('Markdown Studio local storage is unavailable.', error);
            return (0, $54a362fffda0374a$export$2a533ee113497df1)(null, fallbackDocument);
        }
    }
    function loadSettings() {
        try {
            const value = localStorage.getItem($4e9d41a2c9416514$var$SETTINGS_STORAGE_KEY);
            return (0, $54a362fffda0374a$export$cdf4f5796ad55bea)(value ? JSON.parse(value) : (0, $54a362fffda0374a$export$fbfd612cb8efd2c6));
        } catch (error) {
            console.warn('Markdown Studio settings could not be restored.', error);
            return (0, $54a362fffda0374a$export$cdf4f5796ad55bea)((0, $54a362fffda0374a$export$fbfd612cb8efd2c6));
        }
    }
    function persistDocuments({ announce: announce = false } = {}) {
        window.clearTimeout(saveTimer);
        saveTimer = 0;
        elements.saveStatus.textContent = "\u6B63\u5728\u4FDD\u5B58\u2026";
        try {
            localStorage.setItem($4e9d41a2c9416514$var$DOCUMENT_STORAGE_KEY, JSON.stringify(documentsState));
            if (!storageIssue || storageIssue.startsWith("\u68C0\u6D4B\u5230\u635F\u574F")) storageIssue = '';
            updateStorageWarning();
            elements.saveStatus.textContent = `\u{5DF2}\u{4FDD}\u{5B58}\u{4E8E} ${formatTime(Date.now())}`;
            if (announce) showToast("\u8349\u7A3F\u5DF2\u4FDD\u5B58\u5728\u5F53\u524D\u6D4F\u89C8\u5668");
            return true;
        } catch (error) {
            const quota = error?.name === 'QuotaExceededError' || error?.code === 22;
            storageIssue = quota ? "\u672C\u5730\u5B58\u50A8\u7A7A\u95F4\u4E0D\u8DB3\uFF0C\u6700\u65B0\u4FEE\u6539\u5C1A\u672A\u4FDD\u5B58\u3002\u8BF7\u7ACB\u5373\u5BFC\u51FA Markdown\uFF1B\u5185\u5D4C\u56FE\u7247\u901A\u5E38\u5360\u7528\u6700\u591A\u7A7A\u95F4\u3002" : "\u6D4F\u89C8\u5668\u672A\u80FD\u4FDD\u5B58\u6700\u65B0\u4FEE\u6539\u3002\u5F53\u524D\u5185\u5BB9\u4ECD\u5728\u672C\u9875\u4E2D\uFF0C\u8BF7\u5148\u5BFC\u51FA Markdown\u3002";
            elements.saveStatus.textContent = quota ? "\u672A\u4FDD\u5B58 \xb7 \u7A7A\u95F4\u4E0D\u8DB3" : "\u672A\u4FDD\u5B58 \xb7 \u5B58\u50A8\u4E0D\u53EF\u7528";
            updateStorageWarning();
            console.warn('Markdown Studio could not save drafts.', error);
            return false;
        }
    }
    function persistSettings() {
        try {
            localStorage.setItem($4e9d41a2c9416514$var$SETTINGS_STORAGE_KEY, JSON.stringify(settings));
        } catch (error) {
            console.warn('Markdown Studio could not save settings.', error);
            showToast("\u6392\u7248\u8BBE\u7F6E\u672A\u80FD\u4FDD\u5B58\uFF0C\u4F46\u672C\u6B21\u9884\u89C8\u4ECD\u53EF\u4F7F\u7528", 'warning');
        }
    }
    function scheduleSave() {
        window.clearTimeout(saveTimer);
        elements.saveStatus.textContent = "\u6709\u672A\u4FDD\u5B58\u7684\u4FEE\u6539";
        saveTimer = window.setTimeout(()=>persistDocuments(), $4e9d41a2c9416514$var$AUTOSAVE_DELAY);
    }
    function updateStorageWarning() {
        if (storageIssue) {
            elements.storageWarning.textContent = storageIssue;
            elements.storageWarning.hidden = false;
            return;
        }
        if (imageSizeWarning) {
            elements.storageWarning.textContent = "\u8FD9\u7BC7\u8349\u7A3F\u5305\u542B\u8F83\u5927\u7684\u5185\u5D4C\u56FE\u7247\u3002\u6D4F\u89C8\u5668\u5B58\u50A8\u5BB9\u91CF\u6709\u9650\uFF0C\u8BF7\u4E0B\u8F7D Markdown \u4F5C\u4E3A\u5907\u4EFD\u3002";
            elements.storageWarning.hidden = false;
            return;
        }
        elements.storageWarning.hidden = true;
    }
    function markDocumentChanged() {
        const current = activeDocument();
        current.content = elements.markdownSource.value;
        current.updatedAt = Date.now();
        scheduleSave();
        schedulePreview();
        updateStats();
        updateCursor();
    }
    function loadActiveDocument() {
        const current = activeDocument();
        documentsState.activeId = current.id;
        elements.markdownSource.value = current.content;
        elements.documentTitle.value = current.name;
        elements.saveStatus.textContent = "\u5DF2\u8F7D\u5165\u672C\u5730\u8349\u7A3F";
        imageSizeWarning = current.content.length > 3500000;
        updateStorageWarning();
        renderDocumentList();
        updateStats();
        updateCursor();
        renderPreview();
    }
    function renderDocumentList() {
        const fragment = document.createDocumentFragment();
        documentsState.documents.slice().sort((a, b)=>b.updatedAt - a.updatedAt).forEach((documentItem)=>{
            const selected = documentItem.id === documentsState.activeId;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'studio-document-item';
            button.dataset.documentId = documentItem.id;
            button.setAttribute('role', 'option');
            button.setAttribute('aria-selected', String(selected));
            button.tabIndex = selected ? 0 : -1;
            const name = document.createElement('strong');
            name.textContent = documentItem.name;
            const meta = document.createElement('span');
            const stats = (0, $54a362fffda0374a$export$9d385d4ab5f1705f)(documentItem.content);
            meta.textContent = `${stats.words} \u{5B57}\u{8BCD} \xb7 ${formatRelativeDate(documentItem.updatedAt)}`;
            button.append(name, meta);
            fragment.append(button);
        });
        elements.documentList.replaceChildren(fragment);
    }
    function schedulePreview() {
        window.clearTimeout(previewTimer);
        previewTimer = window.setTimeout(renderPreview, $4e9d41a2c9416514$var$PREVIEW_DELAY);
    }
    async function ensurePreviewReady() {
        if (previewTimer) renderPreview();
        await enhancementPromise;
    }
    function renderPreview() {
        window.clearTimeout(previewTimer);
        previewTimer = 0;
        const generation = ++renderGeneration;
        const markdownSource = elements.markdownSource.value;
        if (!markdownSource.trim()) {
            elements.previewDocument.innerHTML = '<div class="studio-preview-empty"><strong>\u9884\u89C8\u4F1A\u663E\u793A\u5728\u8FD9\u91CC</strong><p>\u5F00\u59CB\u8F93\u5165 Markdown\uFF0C\u6216\u5BFC\u5165\u4E00\u4E2A\u6587\u6863\u3002</p></div>';
            elements.outlineCount.textContent = "0 \u9879";
            elements.outlineList.innerHTML = '<p class="studio-empty-state">\u6DFB\u52A0\u6807\u9898\u540E\u4F1A\u5728\u8FD9\u91CC\u751F\u6210\u5927\u7EB2\u3002</p>';
            elements.enhancementStatus.textContent = "\u5B89\u5168\u6E32\u67D3";
            enhancementPromise = Promise.resolve();
            return;
        }
        let rendered = '';
        try {
            rendered = $4e9d41a2c9416514$var$markdownParser.parse(markdownSource);
        } catch (error) {
            console.error('Markdown render failed.', error);
            rendered = `<div class="enhancement-fallback"><strong>Markdown \u{6E32}\u{67D3}\u{5931}\u{8D25}</strong><pre><code>${(0, $54a362fffda0374a$export$4cf11838cdc2a8a8)(markdownSource)}</code></pre></div>`;
        }
        const safeHtml = (0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize((0, $f0987e643bba202a$export$f5216173b9833475)(rendered), $4e9d41a2c9416514$var$SANITIZE_CONFIG);
        elements.previewDocument.innerHTML = safeHtml;
        hardenPreviewContent();
        const headings = collectPreviewHeadings();
        replaceTocMarkers(headings);
        if (settings.externalFootnotes) addExternalLinkFootnotes();
        updateOutline(headings);
        const needsEnhancement = elements.previewDocument.querySelector('.math-placeholder, .language-mermaid');
        elements.enhancementStatus.textContent = needsEnhancement ? "\u6B63\u5728\u589E\u5F3A\u516C\u5F0F\u4E0E\u56FE\u8868\u2026" : "\u5B89\u5168\u6E32\u67D3";
        enhancementPromise = needsEnhancement ? enhancePreview(generation) : Promise.resolve();
    }
    function hardenPreviewContent() {
        elements.previewDocument.querySelectorAll('a').forEach((link)=>{
            const href = link.getAttribute('href') || '';
            if (!(0, $54a362fffda0374a$export$f0a7a72d6a038c2e)(href)) {
                link.replaceWith(document.createTextNode(link.textContent || href));
                return;
            }
            if (/^https?:/i.test(href)) {
                link.target = '_blank';
                link.rel = 'noopener noreferrer nofollow';
            }
        });
        elements.previewDocument.querySelectorAll('img').forEach((image)=>{
            const src = image.getAttribute('src') || '';
            if (!(0, $54a362fffda0374a$export$1c9353028587d7fa)(src)) {
                const fallback = document.createElement('span');
                fallback.className = 'studio-removed-resource';
                fallback.textContent = `\u{56FE}\u{7247}\u{5730}\u{5740}\u{5DF2}\u{79FB}\u{9664}${image.alt ? `\u{FF1A}${image.alt}` : ''}`;
                image.replaceWith(fallback);
                return;
            }
            image.loading = 'lazy';
            image.decoding = 'async';
            image.referrerPolicy = 'no-referrer';
            if (!image.alt) image.alt = "\u6587\u7AE0\u56FE\u7247";
        });
        elements.previewDocument.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
            checkbox.disabled = true;
            checkbox.setAttribute('aria-label', checkbox.checked ? "\u5DF2\u5B8C\u6210\u4EFB\u52A1" : "\u672A\u5B8C\u6210\u4EFB\u52A1");
        });
    }
    function collectPreviewHeadings() {
        return Array.from(elements.previewDocument.querySelectorAll('h1[id],h2[id],h3[id],h4[id],h5[id],h6[id]')).map((heading)=>({
                id: heading.id,
                level: Number(heading.tagName.slice(1)),
                text: heading.textContent.trim() || "\u672A\u547D\u540D\u6807\u9898",
                element: heading
            }));
    }
    function findPreviewTarget(id) {
        return Array.from(elements.previewDocument.querySelectorAll('[id]')).find((node)=>node.id === id) || null;
    }
    function replaceTocMarkers(headings) {
        elements.previewDocument.querySelectorAll('p').forEach((paragraph)=>{
            if (paragraph.textContent.trim().toUpperCase() !== '[TOC]') return;
            const nav = document.createElement('nav');
            nav.className = 'md-toc';
            nav.setAttribute('aria-label', "\u6587\u5185\u76EE\u5F55");
            const title = document.createElement('p');
            title.className = 'md-toc-title';
            title.textContent = "\u76EE\u5F55";
            nav.append(title);
            if (!headings.length) {
                const empty = document.createElement('span');
                empty.textContent = "\u6DFB\u52A0\u6807\u9898\u540E\u4F1A\u751F\u6210\u76EE\u5F55\u3002";
                nav.append(empty);
            } else headings.forEach((item)=>{
                const link = document.createElement('a');
                link.href = `#${item.id}`;
                link.className = `toc-level-${Math.min(item.level, 4)}`;
                link.textContent = item.text;
                nav.append(link);
            });
            paragraph.replaceWith(nav);
        });
    }
    function addExternalLinkFootnotes() {
        const links = Array.from(elements.previewDocument.querySelectorAll('a[href^="http://"],a[href^="https://"]')).filter((link)=>!link.closest('.md-toc, .link-footnotes'));
        if (!links.length) return;
        const urls = new Map();
        links.forEach((link)=>{
            const href = link.href;
            if (!urls.has(href)) urls.set(href, urls.size + 1);
            const index = urls.get(href);
            const reference = document.createElement('sup');
            reference.className = 'footnote-ref';
            const referenceLink = document.createElement('a');
            referenceLink.href = `#external-link-${index}`;
            referenceLink.textContent = `[${index}]`;
            reference.append(referenceLink);
            link.after(reference);
        });
        const section = document.createElement('section');
        section.className = 'link-footnotes';
        section.setAttribute('aria-label', "\u5916\u90E8\u94FE\u63A5\u811A\u6CE8");
        const title = document.createElement('h2');
        title.textContent = "\u5916\u90E8\u94FE\u63A5";
        const list = document.createElement('ol');
        urls.forEach((index, href)=>{
            const item = document.createElement('li');
            item.id = `external-link-${index}`;
            const link = document.createElement('a');
            link.href = href;
            link.target = '_blank';
            link.rel = 'noopener noreferrer nofollow';
            link.textContent = href;
            item.append(link);
            list.append(item);
        });
        section.append(title, list);
        elements.previewDocument.append(section);
    }
    function updateOutline(headings) {
        elements.outlineCount.textContent = `${headings.length} \u{9879}`;
        if (!headings.length) {
            elements.outlineList.innerHTML = '<p class="studio-empty-state">\u6DFB\u52A0\u6807\u9898\u540E\u4F1A\u5728\u8FD9\u91CC\u751F\u6210\u5927\u7EB2\u3002</p>';
            return;
        }
        const fragment = document.createDocumentFragment();
        headings.forEach((item)=>{
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.headingId = item.id;
            button.dataset.level = String(item.level);
            button.textContent = item.text;
            button.title = `\u{8DF3}\u{5230}\u{201C}${item.text}\u{201D}`;
            fragment.append(button);
        });
        elements.outlineList.replaceChildren(fragment);
    }
    async function enhancePreview(generation) {
        const mathNodes = Array.from(elements.previewDocument.querySelectorAll('.math-placeholder'));
        const mermaidNodes = Array.from(elements.previewDocument.querySelectorAll('.mermaid-fallback'));
        const results = await Promise.allSettled([
            mathNodes.length ? enhanceMath(mathNodes, generation) : Promise.resolve({
                failures: 0
            }),
            mermaidNodes.length ? enhanceMermaid(mermaidNodes, generation) : Promise.resolve({
                failures: 0
            })
        ]);
        if (generation !== renderGeneration) return;
        const failures = results.reduce((total, result)=>{
            if (result.status === 'rejected') return total + 1;
            return total + (result.value?.failures || 0);
        }, 0);
        elements.enhancementStatus.textContent = failures ? `\u{5B89}\u{5168}\u{6E32}\u{67D3} \xb7 ${failures} \u{9879}\u{4F7F}\u{7528}\u{6E90}\u{7801}\u{56DE}\u{9000}` : "\u5B89\u5168\u6E32\u67D3 \xb7 \u589E\u5F3A\u5B8C\u6210";
    }
    let katexStylesPromise = null;
    function ensureKatexStyles() {
        if (katexStylesPromise) return katexStylesPromise;
        katexStylesPromise = new Promise((resolve, reject)=>{
            var existing = document.querySelector('link[data-katex-styles]');
            if (existing) {
                if (existing.dataset.loaded === 'true') resolve();
                else {
                    existing.addEventListener('load', resolve, {
                        once: true
                    });
                    existing.addEventListener('error', reject, {
                        once: true
                    });
                }
                return;
            }
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = '/vendor/katex/katex.min.css';
            link.setAttribute('data-katex-styles', 'true');
            link.addEventListener('load', ()=>{
                link.dataset.loaded = 'true';
                resolve();
            }, {
                once: true
            });
            link.addEventListener('error', reject, {
                once: true
            });
            document.head.appendChild(link);
        });
        return katexStylesPromise;
    }
    async function enhanceMath(nodes, generation) {
        let katex;
        try {
            const [module] = await Promise.all([
                (parcelRequire("eF5U7")),
                ensureKatexStyles()
            ]);
            katex = module.default || module;
        } catch (error) {
            nodes.forEach((node)=>markEnhancementFallback(node, "KaTeX \u672A\u80FD\u8F7D\u5165\uFF0C\u5DF2\u4FDD\u7559\u516C\u5F0F\u6E90\u7801"));
            console.warn('KaTeX enhancement could not load.', error);
            return {
                failures: nodes.length
            };
        }
        if (generation !== renderGeneration) return {
            failures: 0
        };
        let failures = 0;
        nodes.forEach((node)=>{
            const expression = node.textContent;
            try {
                katex.render(expression, node, {
                    displayMode: node.dataset.displayMode === 'true',
                    throwOnError: true,
                    strict: 'warn',
                    trust: false,
                    output: 'htmlAndMathml'
                });
                node.classList.add('math-rendered');
            } catch (error) {
                failures += 1;
                markEnhancementFallback(node, "\u516C\u5F0F\u65E0\u6CD5\u89E3\u6790\uFF0C\u5DF2\u4FDD\u7559\u6E90\u7801");
                console.warn('KaTeX expression could not render.', error);
            }
        });
        return {
            failures: failures
        };
    }
    async function enhanceMermaid(nodes, generation) {
        try {
            if (!mermaidInstance) {
                mermaidInstance = await loadMermaidRuntime();
                mermaidInstance.initialize({
                    startOnLoad: false,
                    securityLevel: 'strict',
                    theme: 'base',
                    suppressErrorRendering: true,
                    fontFamily: $4e9d41a2c9416514$var$FONT_STACKS.system
                });
            }
        } catch (error) {
            nodes.forEach((node)=>markEnhancementFallback(node, "Mermaid \u672A\u80FD\u8F7D\u5165\uFF0C\u5DF2\u4FDD\u7559\u56FE\u8868\u6E90\u7801"));
            console.warn('Mermaid enhancement could not load.', error);
            return {
                failures: nodes.length
            };
        }
        if (generation !== renderGeneration) return {
            failures: 0
        };
        let failures = 0;
        for (const [index, node] of nodes.entries()){
            const source = node.querySelector('code')?.textContent || '';
            try {
                const renderId = `studio-mermaid-${generation}-${index}`;
                const result = await mermaidInstance.render(renderId, source);
                if (generation !== renderGeneration) return {
                    failures: failures
                };
                const wrapper = document.createElement('div');
                wrapper.className = 'studio-diagram';
                wrapper.setAttribute('role', 'img');
                wrapper.setAttribute('aria-label', "Mermaid \u56FE\u8868");
                wrapper.innerHTML = (0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(result.svg, {
                    USE_PROFILES: {
                        svg: true,
                        svgFilters: true
                    },
                    FORBID_TAGS: [
                        'script',
                        'foreignObject'
                    ],
                    FORBID_ATTR: [
                        'onload',
                        'onclick',
                        'onerror'
                    ]
                });
                node.replaceWith(wrapper);
            } catch (error) {
                failures += 1;
                markEnhancementFallback(node, "Mermaid \u56FE\u8868\u65E0\u6CD5\u89E3\u6790\uFF0C\u5DF2\u4FDD\u7559\u6E90\u7801");
                console.warn('Mermaid diagram could not render.', error);
            }
        }
        return {
            failures: failures
        };
    }
    async function loadMermaidRuntime() {
        const readRuntime = ()=>{
            const runtime = globalThis.mermaid || globalThis.__esbuild_esm_mermaid_nm?.mermaid;
            return runtime ? runtime.default || runtime : null;
        };
        const availableRuntime = readRuntime();
        if (availableRuntime) return availableRuntime;
        if (!mermaidLoadPromise) mermaidLoadPromise = new Promise((resolve, reject)=>{
            const existing = document.querySelector('script[data-mermaid-runtime]');
            const script = existing || document.createElement('script');
            let timeout = 0;
            const cleanup = ()=>{
                window.clearTimeout(timeout);
                script.removeEventListener('load', onLoad);
                script.removeEventListener('error', onError);
            };
            const fail = (message)=>{
                cleanup();
                script.remove();
                reject(new Error(message));
            };
            const onLoad = ()=>{
                script.dataset.mermaidLoaded = 'true';
                const runtime = readRuntime();
                if (!runtime) {
                    fail('Mermaid runtime did not expose its browser API.');
                    return;
                }
                cleanup();
                resolve(runtime);
            };
            const onError = ()=>fail('Mermaid runtime failed to load.');
            script.addEventListener('load', onLoad, {
                once: true
            });
            script.addEventListener('error', onError, {
                once: true
            });
            timeout = window.setTimeout(()=>fail('Mermaid runtime loading timed out.'), 8000);
            if (existing?.dataset.mermaidLoaded === 'true') onLoad();
            else if (!existing) {
                script.src = $4e9d41a2c9416514$var$MERMAID_RUNTIME_URL;
                script.async = true;
                script.dataset.mermaidRuntime = 'true';
                document.head.append(script);
            }
        }).catch((error)=>{
            mermaidLoadPromise = null;
            throw error;
        });
        return mermaidLoadPromise;
    }
    function markEnhancementFallback(node, message) {
        node.classList.add('enhancement-fallback');
        node.setAttribute('aria-label', message);
        if (node.matches('.math-placeholder')) {
            const source = node.textContent;
            node.replaceChildren();
            const label = document.createElement('strong');
            label.textContent = message;
            const code = document.createElement('code');
            code.textContent = source;
            node.append(label, code);
        } else {
            const label = node.querySelector('strong');
            if (label) label.textContent = message;
        }
    }
    function updateStats() {
        const stats = (0, $54a362fffda0374a$export$9d385d4ab5f1705f)(elements.markdownSource.value);
        elements.characterStat.textContent = `${stats.characters} \u{5B57}\u{7B26}`;
        elements.wordStat.textContent = `${stats.words} \u{5B57}\u{8BCD}`;
        elements.paragraphStat.textContent = `${stats.paragraphs} \u{6BB5}`;
        elements.readingStat.textContent = `${stats.readingMinutes} \u{5206}\u{949F}\u{9605}\u{8BFB}`;
    }
    function updateCursor() {
        const cursor = (0, $54a362fffda0374a$export$47774cf7fb07bfc4)(elements.markdownSource.value, elements.markdownSource.selectionStart);
        elements.cursorStat.textContent = `\u{884C} ${cursor.line}\u{FF0C}\u{5217} ${cursor.column}`;
    }
    function populateThemeOptions() {
        elements.themeSelect.replaceChildren(...(0, $f0987e643bba202a$export$b8020e85ad90bfe5).map((template)=>{
            const option = document.createElement('option');
            option.value = template.id;
            option.textContent = template.name;
            option.title = template.desc;
            return option;
        }));
    }
    function applySettingsToControls() {
        elements.themeSelect.value = settings.theme;
        elements.fontSelect.value = settings.font;
        elements.fontSizeSelect.value = String(settings.fontSize);
        elements.lineHeightSelect.value = String(settings.lineHeight);
        elements.accentInput.value = settings.accent;
        elements.accentOutput.textContent = settings.accent;
        elements.widthSelect.value = settings.width;
        elements.mobilePreviewToggle.checked = settings.phonePreview;
        elements.footnoteToggle.checked = settings.externalFootnotes;
        elements.scrollSyncToggle.checked = settings.scrollSync;
        setView(settings.view, {
            persist: false
        });
    }
    function applySettings({ rerender: rerender = false } = {}) {
        elements.previewDocument.dataset.theme = settings.theme;
        elements.previewDocument.style.setProperty('--article-font', $4e9d41a2c9416514$var$FONT_STACKS[settings.font]);
        elements.previewDocument.style.setProperty('--article-size', `${settings.fontSize}px`);
        elements.previewDocument.style.setProperty('--article-leading', String(settings.lineHeight));
        elements.previewDocument.style.setProperty('--article-accent', settings.accent);
        elements.previewDocument.style.setProperty('--article-width', $4e9d41a2c9416514$var$WIDTHS[settings.width]);
        elements.previewScroller.classList.toggle('is-phone-preview', settings.phonePreview);
        elements.accentOutput.textContent = settings.accent;
        if (rerender) renderPreview();
    }
    function updateSetting(name, value, { rerender: rerender = false } = {}) {
        settings = (0, $54a362fffda0374a$export$cdf4f5796ad55bea)({
            ...settings,
            [name]: value
        });
        applySettings({
            rerender: rerender
        });
        persistSettings();
    }
    function setView(mode, { persist: persist = true } = {}) {
        const safeMode = [
            'editor',
            'split',
            'preview'
        ].includes(mode) ? mode : 'split';
        $4e9d41a2c9416514$var$app.dataset.view = safeMode;
        document.querySelectorAll('[data-view-mode]').forEach((button)=>{
            button.setAttribute('aria-pressed', String(button.dataset.viewMode === safeMode));
        });
        if (persist) {
            settings = (0, $54a362fffda0374a$export$cdf4f5796ad55bea)({
                ...settings,
                view: safeMode
            });
            persistSettings();
        }
    }
    function setMobileView(mode) {
        const safeMode = mode === 'preview' ? 'preview' : 'editor';
        $4e9d41a2c9416514$var$app.dataset.mobileView = safeMode;
        document.querySelectorAll('[data-mobile-tab]').forEach((button)=>{
            const selected = button.dataset.mobileTab === safeMode;
            button.setAttribute('aria-selected', String(selected));
            button.tabIndex = selected ? 0 : -1;
        });
        if (safeMode === 'preview') renderPreview();
    }
    function toggleSidebar(force) {
        const mobile = window.matchMedia('(max-width: 860px)').matches;
        if (mobile) {
            const open = typeof force === 'boolean' ? force : !$4e9d41a2c9416514$var$app.classList.contains('sidebar-open');
            $4e9d41a2c9416514$var$app.classList.toggle('sidebar-open', open);
            elements.sidebarToggle.setAttribute('aria-expanded', String(open));
        } else {
            const collapsed = typeof force === 'boolean' ? !force : !$4e9d41a2c9416514$var$app.classList.contains('sidebar-collapsed');
            $4e9d41a2c9416514$var$app.classList.toggle('sidebar-collapsed', collapsed);
            elements.sidebarToggle.setAttribute('aria-expanded', String(!collapsed));
        }
    }
    function applyAction(action, options = {}) {
        const result = (0, $54a362fffda0374a$export$e956be82b8b99c9)(elements.markdownSource.value, elements.markdownSource.selectionStart, elements.markdownSource.selectionEnd, action, options);
        elements.markdownSource.value = result.value;
        elements.markdownSource.focus();
        elements.markdownSource.setSelectionRange(result.selectionStart, result.selectionEnd);
        markDocumentChanged();
    }
    function bindEvents() {
        elements.markdownSource.addEventListener('input', markDocumentChanged);
        [
            'click',
            'keyup',
            'select'
        ].forEach((eventName)=>elements.markdownSource.addEventListener(eventName, updateCursor));
        elements.markdownSource.addEventListener('keydown', handleEditorKeydown);
        elements.markdownSource.addEventListener('paste', handleImagePaste);
        elements.documentTitle.addEventListener('input', ()=>{
            const current = activeDocument();
            current.name = elements.documentTitle.value.slice(0, 80) || "\u672A\u547D\u540D\u6587\u6863";
            current.updatedAt = Date.now();
            renderDocumentList();
            scheduleSave();
        });
        elements.documentTitle.addEventListener('blur', ()=>{
            const current = activeDocument();
            current.name = (0, $54a362fffda0374a$export$364496161d416a8)(elements.documentTitle.value);
            elements.documentTitle.value = current.name;
            renderDocumentList();
            scheduleSave();
        });
        elements.documentList.addEventListener('click', (event)=>{
            const button = event.target.closest('[data-document-id]');
            if (!button || button.dataset.documentId === documentsState.activeId) return;
            persistDocuments();
            documentsState.activeId = button.dataset.documentId;
            loadActiveDocument();
            persistDocuments();
            if (window.matchMedia('(max-width: 860px)').matches) toggleSidebar(false);
        });
        elements.documentList.addEventListener('keydown', (event)=>{
            if (![
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ].includes(event.key)) return;
            const items = Array.from(elements.documentList.querySelectorAll('[data-document-id]'));
            if (!items.length) return;
            const currentIndex = Math.max(0, items.indexOf(document.activeElement));
            let nextIndex = currentIndex;
            if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + items.length) % items.length;
            if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % items.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = items.length - 1;
            event.preventDefault();
            items[nextIndex].focus();
        });
        elements.newDocumentButton.addEventListener('click', async ()=>{
            const name = await requestDocumentName({
                title: "\u65B0\u5EFA\u672C\u5730\u6587\u6863",
                description: "\u6587\u6863\u53EA\u4FDD\u5B58\u5728\u5F53\u524D\u6D4F\u89C8\u5668\u3002",
                initialValue: "\u672A\u547D\u540D\u6587\u6863"
            });
            if (!name) return;
            const documentItem = makeDocument(name, `# ${name}\n\n`);
            documentsState.documents.push(documentItem);
            documentsState.activeId = documentItem.id;
            loadActiveDocument();
            persistDocuments();
            elements.markdownSource.focus();
            elements.markdownSource.setSelectionRange(elements.markdownSource.value.length, elements.markdownSource.value.length);
            showToast("\u5DF2\u65B0\u5EFA\u672C\u5730\u6587\u6863");
        });
        elements.renameDocumentButton.addEventListener('click', async ()=>{
            const current = activeDocument();
            const name = await requestDocumentName({
                title: "\u91CD\u547D\u540D\u6587\u6863",
                description: "\u53EA\u4FEE\u6539\u672C\u5730\u6587\u6863\u540D\u79F0\uFF0C\u4E0D\u6539\u52A8\u6B63\u6587\u6807\u9898\u3002",
                initialValue: current.name
            });
            if (!name) return;
            current.name = name;
            current.updatedAt = Date.now();
            elements.documentTitle.value = name;
            renderDocumentList();
            persistDocuments();
            showToast("\u6587\u6863\u5DF2\u91CD\u547D\u540D");
        });
        elements.duplicateDocumentButton.addEventListener('click', ()=>{
            const current = activeDocument();
            const duplicate = makeDocument(`${current.name} \u{526F}\u{672C}`, current.content);
            documentsState.documents.push(duplicate);
            documentsState.activeId = duplicate.id;
            loadActiveDocument();
            persistDocuments();
            showToast("\u5DF2\u521B\u5EFA\u6587\u6863\u526F\u672C");
        });
        elements.deleteDocumentButton.addEventListener('click', async ()=>{
            const current = activeDocument();
            const confirmed = await requestConfirmation(`\u{201C}${current.name}\u{201D}\u{5C06}\u{4ECE}\u{8FD9}\u{4E2A}\u{6D4F}\u{89C8}\u{5668}\u{4E2D}\u{5220}\u{9664}\u{FF0C}\u{4E14}\u{65E0}\u{6CD5}\u{5728}\u{672C}\u{5DE5}\u{5177}\u{5185}\u{6062}\u{590D}\u{3002}`);
            if (!confirmed) return;
            documentsState.documents = documentsState.documents.filter((document1)=>document1.id !== current.id);
            if (!documentsState.documents.length) documentsState.documents.push(makeDocument());
            documentsState.activeId = documentsState.documents[0].id;
            loadActiveDocument();
            persistDocuments();
            showToast("\u672C\u5730\u6587\u6863\u5DF2\u5220\u9664");
        });
        elements.formatToolbar.addEventListener('click', async (event)=>{
            const button = event.target.closest('[data-action]');
            if (!button) return;
            const action = button.dataset.action;
            if (action === 'local-image') {
                elements.imageInput.click();
                return;
            }
            if (action === 'link') {
                await insertLinkFromDialog();
                return;
            }
            if (action === 'image') {
                await insertImageUrlFromDialog();
                return;
            }
            applyAction(action);
        });
        elements.imageInput.addEventListener('change', async ()=>{
            const files = Array.from(elements.imageInput.files || []);
            for (const file of files)await insertLocalImage(file);
            elements.imageInput.value = '';
        });
        elements.importButton.addEventListener('click', ()=>elements.documentImportInput.click());
        elements.documentImportInput.addEventListener('change', async ()=>{
            const [file] = elements.documentImportInput.files || [];
            if (file) await importDocument(file);
            elements.documentImportInput.value = '';
        });
        elements.editorDropZone.addEventListener('dragenter', (event)=>{
            if (!hasFiles(event)) return;
            event.preventDefault();
            dragDepth += 1;
            elements.editorDropZone.classList.add('is-dragging');
        });
        elements.editorDropZone.addEventListener('dragover', (event)=>{
            if (!hasFiles(event)) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
        });
        elements.editorDropZone.addEventListener('dragleave', (event)=>{
            if (!hasFiles(event)) return;
            dragDepth = Math.max(0, dragDepth - 1);
            if (!dragDepth) elements.editorDropZone.classList.remove('is-dragging');
        });
        elements.editorDropZone.addEventListener('drop', handleDrop);
        document.querySelectorAll('[data-view-mode]').forEach((button)=>button.addEventListener('click', ()=>setView(button.dataset.viewMode)));
        const mobileTabs = Array.from(document.querySelectorAll('[data-mobile-tab]'));
        mobileTabs.forEach((button)=>button.addEventListener('click', ()=>setMobileView(button.dataset.mobileTab)));
        document.querySelector('.studio-mobile-tabs')?.addEventListener('keydown', (event)=>{
            if (![
                'ArrowLeft',
                'ArrowRight',
                'Home',
                'End'
            ].includes(event.key)) return;
            const currentIndex = Math.max(0, mobileTabs.indexOf(document.activeElement));
            let nextIndex = currentIndex;
            if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + mobileTabs.length) % mobileTabs.length;
            if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % mobileTabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = mobileTabs.length - 1;
            event.preventDefault();
            setMobileView(mobileTabs[nextIndex].dataset.mobileTab);
            mobileTabs[nextIndex].focus();
        });
        elements.sidebarToggle.addEventListener('click', ()=>toggleSidebar());
        elements.drawerScrim.addEventListener('click', ()=>toggleSidebar(false));
        elements.outlineList.addEventListener('click', (event)=>{
            const button = event.target.closest('[data-heading-id]');
            if (!button) return;
            if (window.matchMedia('(max-width: 860px)').matches) {
                setMobileView('preview');
                toggleSidebar(false);
            }
            const target = findPreviewTarget(button.dataset.headingId);
            target?.scrollIntoView({
                behavior: prefersReducedMotion() ? 'auto' : 'smooth',
                block: 'start'
            });
            target?.setAttribute('tabindex', '-1');
            target?.focus({
                preventScroll: true
            });
        });
        elements.previewDocument.addEventListener('click', (event)=>{
            const anchor = event.target.closest('a[href^="#"]');
            if (!anchor) return;
            const id = decodeURIComponent(anchor.getAttribute('href').slice(1));
            const target = findPreviewTarget(id);
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({
                behavior: prefersReducedMotion() ? 'auto' : 'smooth',
                block: 'start'
            });
        });
        elements.themeSelect.addEventListener('change', ()=>updateSetting('theme', elements.themeSelect.value, {
                rerender: true
            }));
        elements.fontSelect.addEventListener('change', ()=>updateSetting('font', elements.fontSelect.value));
        elements.fontSizeSelect.addEventListener('change', ()=>updateSetting('fontSize', Number(elements.fontSizeSelect.value)));
        elements.lineHeightSelect.addEventListener('change', ()=>updateSetting('lineHeight', Number(elements.lineHeightSelect.value)));
        elements.accentInput.addEventListener('input', ()=>updateSetting('accent', elements.accentInput.value));
        elements.widthSelect.addEventListener('change', ()=>updateSetting('width', elements.widthSelect.value));
        elements.mobilePreviewToggle.addEventListener('change', ()=>updateSetting('phonePreview', elements.mobilePreviewToggle.checked));
        elements.footnoteToggle.addEventListener('change', ()=>updateSetting('externalFootnotes', elements.footnoteToggle.checked, {
                rerender: true
            }));
        elements.scrollSyncToggle.addEventListener('change', ()=>updateSetting('scrollSync', elements.scrollSyncToggle.checked));
        elements.markdownSource.addEventListener('scroll', ()=>synchronizeScroll(elements.markdownSource, elements.previewScroller));
        elements.previewScroller.addEventListener('scroll', ()=>synchronizeScroll(elements.previewScroller, elements.markdownSource));
        elements.richCopyButton.addEventListener('click', copyRichText);
        document.querySelectorAll('[data-copy]').forEach((button)=>button.addEventListener('click', async ()=>{
                const kind = button.dataset.copy;
                if (kind === 'markdown') {
                    await copyPlainText(elements.markdownSource.value);
                    showToast("Markdown \u5DF2\u590D\u5236");
                } else {
                    await ensurePreviewReady();
                    const html = getSanitizedPreviewHtml();
                    await copyPlainText(html);
                    showToast("\u5B89\u5168 HTML \u5DF2\u590D\u5236");
                }
                button.closest('details').open = false;
            }));
        document.querySelectorAll('[data-export]').forEach((button)=>button.addEventListener('click', async ()=>{
                const format = button.dataset.export;
                button.closest('details').open = false;
                await exportDocument(format);
            }));
        document.querySelectorAll('[data-dialog-cancel]').forEach((button)=>button.addEventListener('click', ()=>{
                button.closest('dialog')?.close('cancel');
            }));
        document.querySelectorAll('.studio-menu').forEach((details)=>{
            const summary = details.querySelector('summary');
            const panel = details.querySelector('.studio-menu-panel');
            const menuItems = ()=>Array.from(panel?.querySelectorAll('button:not([disabled])') || []);
            summary?.addEventListener('keydown', (event)=>{
                if (event.key !== 'ArrowDown') return;
                event.preventDefault();
                details.open = true;
                menuItems()[0]?.focus();
            });
            panel?.addEventListener('keydown', (event)=>{
                const items = menuItems();
                if (!items.length) return;
                const currentIndex = Math.max(0, items.indexOf(document.activeElement));
                let nextIndex = currentIndex;
                if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + items.length) % items.length;
                else if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % items.length;
                else if (event.key === 'Home') nextIndex = 0;
                else if (event.key === 'End') nextIndex = items.length - 1;
                else if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    details.open = false;
                    summary?.focus();
                    return;
                } else return;
                event.preventDefault();
                items[nextIndex].focus();
            });
        });
        window.addEventListener('beforeunload', ()=>{
            if (saveTimer) persistDocuments();
        });
        document.addEventListener('pointerdown', (event)=>{
            document.querySelectorAll('.studio-menu[open], .studio-settings[open]').forEach((details)=>{
                if (!details.contains(event.target)) details.removeAttribute('open');
            });
        });
        document.addEventListener('keydown', (event)=>{
            if (event.key !== 'Escape') return;
            document.querySelectorAll('.studio-menu[open], .studio-settings[open]').forEach((details)=>details.removeAttribute('open'));
            if ($4e9d41a2c9416514$var$app.classList.contains('sidebar-open')) toggleSidebar(false);
        });
    }
    function handleEditorKeydown(event) {
        if (!(event.metaKey || event.ctrlKey) || event.altKey) return;
        const key = event.key.toLowerCase();
        if (![
            'b',
            'i',
            'k',
            's'
        ].includes(key)) return;
        event.preventDefault();
        if (key === 'b') applyAction('bold');
        if (key === 'i') applyAction('italic');
        if (key === 'k') insertLinkFromDialog();
        if (key === 's' && event.shiftKey) applyAction('strike');
        if (key === 's' && !event.shiftKey) persistDocuments({
            announce: true
        });
    }
    async function insertLinkFromDialog() {
        const start = elements.markdownSource.selectionStart;
        const end = elements.markdownSource.selectionEnd;
        const selected = elements.markdownSource.value.slice(start, end);
        const result = await requestLink(selected || "\u94FE\u63A5\u6587\u5B57");
        if (!result) return;
        elements.markdownSource.setSelectionRange(start, end);
        applyAction('link', result);
    }
    async function insertImageUrlFromDialog() {
        const start = elements.markdownSource.selectionStart;
        const end = elements.markdownSource.selectionEnd;
        const selected = elements.markdownSource.value.slice(start, end);
        const result = await requestImageUrl(selected || "\u56FE\u7247\u8BF4\u660E");
        if (!result) return;
        elements.markdownSource.setSelectionRange(start, end);
        applyAction('image', result);
    }
    function requestDocumentName({ title: title, description: description, initialValue: initialValue }) {
        elements.documentDialogTitle.textContent = title;
        elements.documentDialogDescription.textContent = description;
        elements.documentNameInput.value = initialValue;
        elements.documentDialog.returnValue = '';
        elements.documentDialog.showModal();
        requestAnimationFrame(()=>elements.documentNameInput.select());
        return new Promise((resolve)=>{
            const onSubmit = (event)=>{
                event.preventDefault();
                const name = (0, $54a362fffda0374a$export$364496161d416a8)(elements.documentNameInput.value);
                cleanup();
                elements.documentDialog.close('confirm');
                resolve(name);
            };
            const onClose = ()=>{
                cleanup();
                resolve(null);
            };
            const cleanup = ()=>{
                elements.documentDialogForm.removeEventListener('submit', onSubmit);
                elements.documentDialog.removeEventListener('close', onClose);
            };
            elements.documentDialogForm.addEventListener('submit', onSubmit);
            elements.documentDialog.addEventListener('close', onClose, {
                once: true
            });
        });
    }
    function requestConfirmation(message) {
        elements.confirmDialogMessage.textContent = message;
        elements.confirmDialog.returnValue = '';
        elements.confirmDialog.showModal();
        return new Promise((resolve)=>{
            const onSubmit = (event)=>{
                event.preventDefault();
                cleanup();
                elements.confirmDialog.close('confirm');
                resolve(true);
            };
            const onClose = ()=>{
                cleanup();
                resolve(false);
            };
            const cleanup = ()=>{
                elements.confirmDialogForm.removeEventListener('submit', onSubmit);
                elements.confirmDialog.removeEventListener('close', onClose);
            };
            elements.confirmDialogForm.addEventListener('submit', onSubmit);
            elements.confirmDialog.addEventListener('close', onClose, {
                once: true
            });
        });
    }
    function requestLink(label) {
        elements.linkTextInput.value = label;
        elements.linkUrlInput.value = 'https://';
        elements.linkUrlInput.setCustomValidity('');
        elements.linkDialog.showModal();
        requestAnimationFrame(()=>elements.linkUrlInput.select());
        return new Promise((resolve)=>{
            const onSubmit = (event)=>{
                event.preventDefault();
                const url = elements.linkUrlInput.value.trim();
                if (!(0, $54a362fffda0374a$export$f0a7a72d6a038c2e)(url)) {
                    elements.linkUrlInput.setCustomValidity("\u8BF7\u8F93\u5165 http\u3001https\u3001mailto\u3001tel \u6216\u9875\u9762\u5185\u951A\u70B9\u5730\u5740\u3002");
                    elements.linkUrlInput.reportValidity();
                    return;
                }
                const value = {
                    label: elements.linkTextInput.value.trim() || "\u94FE\u63A5\u6587\u5B57",
                    url: url
                };
                cleanup();
                elements.linkDialog.close('confirm');
                resolve(value);
            };
            const onClose = ()=>{
                cleanup();
                resolve(null);
            };
            const cleanup = ()=>{
                elements.linkDialogForm.removeEventListener('submit', onSubmit);
                elements.linkDialog.removeEventListener('close', onClose);
            };
            elements.linkDialogForm.addEventListener('submit', onSubmit);
            elements.linkDialog.addEventListener('close', onClose, {
                once: true
            });
        });
    }
    function requestImageUrl(alt) {
        elements.imageAltInput.value = alt;
        elements.imageUrlInput.value = 'https://';
        elements.imageUrlInput.setCustomValidity('');
        elements.imageDialog.showModal();
        requestAnimationFrame(()=>elements.imageUrlInput.select());
        return new Promise((resolve)=>{
            const onSubmit = (event)=>{
                event.preventDefault();
                const url = elements.imageUrlInput.value.trim();
                if (!(0, $54a362fffda0374a$export$1c9353028587d7fa)(url) || !/^https?:/i.test(url)) {
                    elements.imageUrlInput.setCustomValidity("\u8BF7\u8F93\u5165\u4EE5 http:// \u6216 https:// \u5F00\u5934\u7684\u56FE\u7247\u5730\u5740\u3002");
                    elements.imageUrlInput.reportValidity();
                    return;
                }
                const value = {
                    alt: cleanImageAlt(elements.imageAltInput.value),
                    url: url
                };
                cleanup();
                elements.imageDialog.close('confirm');
                resolve(value);
            };
            const onClose = ()=>{
                cleanup();
                resolve(null);
            };
            const cleanup = ()=>{
                elements.imageDialogForm.removeEventListener('submit', onSubmit);
                elements.imageDialog.removeEventListener('close', onClose);
            };
            elements.imageDialogForm.addEventListener('submit', onSubmit);
            elements.imageDialog.addEventListener('close', onClose, {
                once: true
            });
        });
    }
    async function importDocument(file) {
        const extension = file.name.split('.').pop()?.toLowerCase() || '';
        if (![
            'md',
            'markdown',
            'txt',
            'html',
            'htm',
            'docx'
        ].includes(extension)) {
            showToast("\u4E0D\u652F\u6301\u8FD9\u4E2A\u6587\u4EF6\u7C7B\u578B\uFF0C\u8BF7\u9009\u62E9 Markdown\u3001TXT\u3001HTML \u6216 DOCX", 'warning');
            return;
        }
        if (file.size > $4e9d41a2c9416514$var$MAX_DOCUMENT_BYTES) {
            showToast("\u6587\u6863\u8D85\u8FC7 20 MB\u3002\u8BF7\u5148\u7CBE\u7B80\u56FE\u7247\u6216\u62C6\u5206\u6587\u4EF6\u540E\u518D\u5BFC\u5165\u3002", 'warning');
            return;
        }
        showToast(`\u{6B63}\u{5728}\u{5BFC}\u{5165} ${file.name}`);
        try {
            let content = '';
            let importWarnings = 0;
            if (extension === 'docx') {
                const mammothModule = await (parcelRequire("d5uQM"));
                const mammoth = mammothModule.default || mammothModule;
                const result = await mammoth.convertToHtml({
                    arrayBuffer: await file.arrayBuffer()
                });
                const cleanHtml = sanitizeImportedHtml(result.value);
                content = $4e9d41a2c9416514$var$turndown.turndown(cleanHtml);
                importWarnings = result.messages?.length || 0;
            } else {
                const text = await file.text();
                content = [
                    'html',
                    'htm'
                ].includes(extension) ? $4e9d41a2c9416514$var$turndown.turndown(sanitizeImportedHtml(text)) : text;
            }
            const fileName = (0, $54a362fffda0374a$export$364496161d416a8)(file.name.replace(/\.(?:md|markdown|txt|html?|docx)$/i, ''));
            const title = (0, $54a362fffda0374a$export$a2a04c192c7d3572)(content, fileName);
            const imported = makeDocument(title, content);
            documentsState.documents.push(imported);
            documentsState.activeId = imported.id;
            loadActiveDocument();
            persistDocuments();
            showToast(importWarnings ? `\u{5BFC}\u{5165}\u{5B8C}\u{6210}\u{FF0C}DOCX \u{6709} ${importWarnings} \u{9879}\u{7248}\u{5F0F}\u{63D0}\u{793A}` : `\u{5DF2}\u{5BFC}\u{5165} ${file.name}`);
        } catch (error) {
            console.error('Document import failed.', error);
            showToast("\u6587\u4EF6\u5BFC\u5165\u5931\u8D25\uFF0C\u539F\u8349\u7A3F\u6CA1\u6709\u88AB\u8986\u76D6", 'error');
        }
    }
    function sanitizeImportedHtml(html) {
        return (0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(String(html), {
            USE_PROFILES: {
                html: true
            },
            FORBID_TAGS: [
                'script',
                'style',
                'iframe',
                'object',
                'embed',
                'form',
                'button',
                'input',
                'textarea',
                'select',
                'meta',
                'link',
                'base'
            ],
            FORBID_ATTR: [
                'srcdoc'
            ]
        });
    }
    async function handleImagePaste(event) {
        const imageItems = Array.from(event.clipboardData?.items || []).filter((item)=>item.type.startsWith('image/'));
        if (!imageItems.length) return;
        event.preventDefault();
        for (const item of imageItems){
            const file = item.getAsFile();
            if (file) await insertLocalImage(file);
        }
    }
    async function handleDrop(event) {
        if (!hasFiles(event)) return;
        event.preventDefault();
        dragDepth = 0;
        elements.editorDropZone.classList.remove('is-dragging');
        const files = Array.from(event.dataTransfer.files || []);
        const images = files.filter((file)=>file.type.startsWith('image/'));
        const documents = files.filter((file)=>!file.type.startsWith('image/'));
        for (const image of images)await insertLocalImage(image);
        if (documents[0]) await importDocument(documents[0]);
        if (documents.length > 1) showToast("\u4E00\u6B21\u53EA\u5BFC\u5165\u4E00\u4E2A\u6587\u6863\uFF0C\u5176\u4F59\u6587\u4EF6\u672A\u5904\u7406", 'warning');
    }
    function hasFiles(event) {
        return Array.from(event.dataTransfer?.types || []).includes('Files');
    }
    async function insertLocalImage(file) {
        if (!/^image\/(?:png|jpeg|webp|gif)$/i.test(file.type)) {
            showToast("\u56FE\u7247\u4EC5\u652F\u6301 PNG\u3001JPEG\u3001WebP \u6216 GIF", 'warning');
            return;
        }
        if (file.size > $4e9d41a2c9416514$var$MAX_IMAGE_BYTES) {
            showToast("\u56FE\u7247\u8D85\u8FC7 12 MB\u3002\u8BF7\u5148\u538B\u7F29\u56FE\u7247\u540E\u518D\u63D2\u5165\u3002", 'warning');
            return;
        }
        const selectionStart = elements.markdownSource.selectionStart;
        const selectionEnd = elements.markdownSource.selectionEnd;
        showToast("\u6B63\u5728\u672C\u5730\u5904\u7406\u56FE\u7247");
        try {
            const result = await compressImage(file);
            elements.markdownSource.setSelectionRange(selectionStart, selectionEnd);
            applyAction('image', {
                alt: cleanImageAlt(file.name.replace(/\.[^.]+$/, '')),
                url: result.dataUrl
            });
            if (result.dataUrl.length > $4e9d41a2c9416514$var$LARGE_IMAGE_DATA_LENGTH || elements.markdownSource.value.length > 3500000) {
                imageSizeWarning = true;
                updateStorageWarning();
                showToast(`\u{56FE}\u{7247}\u{5185}\u{5D4C}\u{540E}\u{7EA6} ${formatBytes(result.dataUrl.length)}\u{FF0C}\u{8BF7}\u{5BFC}\u{51FA} Markdown \u{5907}\u{4EFD}`, 'warning');
            } else {
                const change = result.originalSize ? Math.round((1 - result.size / result.originalSize) * 100) : 0;
                showToast(change > 0 ? `\u{56FE}\u{7247}\u{5DF2}\u{5728}\u{672C}\u{5730}\u{538B}\u{7F29} ${change}% \u{5E76}\u{63D2}\u{5165}` : "\u56FE\u7247\u5DF2\u5728\u672C\u5730\u5904\u7406\u5E76\u63D2\u5165");
            }
        } catch (error) {
            console.error('Image processing failed.', error);
            showToast("\u56FE\u7247\u5904\u7406\u5931\u8D25\uFF0C\u6B63\u6587\u6CA1\u6709\u88AB\u6539\u52A8", 'error');
        }
    }
    async function compressImage(file) {
        if (file.type === 'image/gif') return {
            dataUrl: await readAsDataUrl(file),
            size: file.size,
            originalSize: file.size
        };
        const drawable = await loadDrawable(file);
        const scale = Math.min(1, $4e9d41a2c9416514$var$MAX_IMAGE_EDGE / Math.max(drawable.width, drawable.height));
        const width = Math.max(1, Math.round(drawable.width * scale));
        const height = Math.max(1, Math.round(drawable.height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', {
            alpha: file.type !== 'image/jpeg'
        });
        if (!context) throw new Error('Canvas is not available.');
        if (file.type === 'image/jpeg') {
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, width, height);
        }
        context.drawImage(drawable.source, 0, 0, width, height);
        drawable.close?.();
        const outputType = file.type === 'image/jpeg' ? 'image/jpeg' : 'image/webp';
        const compressed = await canvasToBlob(canvas, outputType, 0.82);
        if (!compressed || compressed.size >= file.size && scale === 1) return {
            dataUrl: await readAsDataUrl(file),
            size: file.size,
            originalSize: file.size
        };
        return {
            dataUrl: await readAsDataUrl(compressed),
            size: compressed.size,
            originalSize: file.size
        };
    }
    async function loadDrawable(file) {
        if ('createImageBitmap' in window) {
            const bitmap = await createImageBitmap(file);
            return {
                source: bitmap,
                width: bitmap.width,
                height: bitmap.height,
                close: ()=>bitmap.close()
            };
        }
        const objectUrl = URL.createObjectURL(file);
        try {
            const image = new Image();
            image.decoding = 'async';
            await new Promise((resolve, reject)=>{
                image.onload = resolve;
                image.onerror = reject;
                image.src = objectUrl;
            });
            return {
                source: image,
                width: image.naturalWidth,
                height: image.naturalHeight
            };
        } finally{
            URL.revokeObjectURL(objectUrl);
        }
    }
    function canvasToBlob(canvas, type, quality) {
        return new Promise((resolve)=>canvas.toBlob(resolve, type, quality));
    }
    function readAsDataUrl(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = ()=>resolve(String(reader.result));
            reader.onerror = ()=>reject(reader.error || new Error('File read failed.'));
            reader.readAsDataURL(blob);
        });
    }
    function cleanImageAlt(value) {
        return String(value || "\u56FE\u7247\u8BF4\u660E").replace(/[\[\]\\\n\r]/g, ' ').replace(/\s+/g, ' ').trim() || "\u56FE\u7247\u8BF4\u660E";
    }
    function synchronizeScroll(source, target) {
        if (!settings.scrollSync || scrollLock) return;
        const sourceRange = source.scrollHeight - source.clientHeight;
        const targetRange = target.scrollHeight - target.clientHeight;
        if (sourceRange <= 0 || targetRange <= 0) return;
        scrollLock = true;
        const ratio = source.scrollTop / sourceRange;
        target.scrollTop = ratio * targetRange;
        requestAnimationFrame(()=>{
            scrollLock = false;
        });
    }
    async function copyRichText() {
        if (!elements.markdownSource.value.trim()) {
            showToast("\u5148\u5199\u5165\u6216\u5BFC\u5165\u5185\u5BB9\u518D\u590D\u5236", 'warning');
            return;
        }
        try {
            await ensurePreviewReady();
            const clone = createInlinedPreviewClone();
            const html = (0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(clone.outerHTML, $4e9d41a2c9416514$var$SANITIZE_CONFIG);
            const plain = elements.previewDocument.innerText;
            if (window.ClipboardItem && navigator.clipboard?.write) await navigator.clipboard.write([
                new ClipboardItem({
                    'text/html': new Blob([
                        html
                    ], {
                        type: 'text/html'
                    }),
                    'text/plain': new Blob([
                        plain
                    ], {
                        type: 'text/plain'
                    })
                })
            ]);
            else copyRichTextFallback(html);
            showToast("\u5BCC\u6587\u672C\u5DF2\u590D\u5236\uFF0C\u53EF\u7C98\u8D34\u5230\u53D1\u5E03\u7F16\u8F91\u5668");
        } catch (error) {
            console.warn('Rich clipboard copy failed; trying fallback.', error);
            try {
                const clone = createInlinedPreviewClone();
                copyRichTextFallback((0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(clone.outerHTML, $4e9d41a2c9416514$var$SANITIZE_CONFIG));
                showToast("\u5BCC\u6587\u672C\u5DF2\u901A\u8FC7\u517C\u5BB9\u6A21\u5F0F\u590D\u5236");
            } catch (fallbackError) {
                console.error('Rich clipboard fallback failed.', fallbackError);
                showToast("\u6D4F\u89C8\u5668\u963B\u6B62\u4E86\u5BCC\u6587\u672C\u590D\u5236\uFF0C\u8BF7\u6539\u7528\u590D\u5236 HTML", 'error');
            }
        }
    }
    function createInlinedPreviewClone() {
        const staging = elements.previewDocument.cloneNode(true);
        staging.removeAttribute('id');
        staging.setAttribute('aria-hidden', 'true');
        Object.assign(staging.style, {
            position: 'fixed',
            left: '-100000px',
            top: '0',
            width: $4e9d41a2c9416514$var$WIDTHS[settings.width],
            maxWidth: $4e9d41a2c9416514$var$WIDTHS[settings.width],
            opacity: '0',
            pointerEvents: 'none',
            display: 'block'
        });
        document.body.append(staging);
        const clone = staging.cloneNode(true);
        const sourceElements = [
            staging,
            ...staging.querySelectorAll('*')
        ];
        const cloneElements = [
            clone,
            ...clone.querySelectorAll('*')
        ];
        sourceElements.forEach((source, index)=>{
            const target = cloneElements[index];
            const computed = getComputedStyle(source);
            $4e9d41a2c9416514$var$INLINE_STYLE_PROPERTIES.forEach((property)=>target.style.setProperty(property, computed.getPropertyValue(property)));
            target.removeAttribute('class');
            target.removeAttribute('data-theme');
            target.removeAttribute('data-display-mode');
            target.removeAttribute('tabindex');
            target.removeAttribute('aria-hidden');
        });
        clone.style.removeProperty('position');
        clone.style.removeProperty('left');
        clone.style.removeProperty('top');
        clone.style.removeProperty('opacity');
        clone.style.removeProperty('pointer-events');
        clone.removeAttribute('aria-hidden');
        clone.querySelectorAll('input[type="checkbox"]').forEach((input)=>{
            const marker = document.createElement('span');
            marker.textContent = input.checked ? "\u2611" : "\u2610";
            marker.style.marginRight = '0.45em';
            input.replaceWith(marker);
        });
        staging.remove();
        return clone;
    }
    function copyRichTextFallback(html) {
        const holder = document.createElement('div');
        holder.contentEditable = 'true';
        holder.setAttribute('aria-hidden', 'true');
        holder.style.cssText = 'position:fixed;left:-100000px;top:0;opacity:0;';
        holder.innerHTML = html;
        document.body.append(holder);
        const range = document.createRange();
        range.selectNodeContents(holder);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        const copied = document.execCommand('copy');
        selection.removeAllRanges();
        holder.remove();
        if (!copied) throw new Error('Legacy clipboard copy was rejected.');
    }
    async function copyPlainText(value) {
        try {
            await navigator.clipboard.writeText(String(value));
        } catch  {
            const textarea = document.createElement('textarea');
            textarea.value = String(value);
            textarea.setAttribute('readonly', '');
            textarea.style.cssText = 'position:fixed;left:-100000px;top:0;';
            document.body.append(textarea);
            textarea.select();
            const copied = document.execCommand('copy');
            textarea.remove();
            if (!copied) throw new Error('Clipboard write was rejected.');
        }
    }
    function getSanitizedPreviewHtml() {
        return (0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(elements.previewDocument.innerHTML, $4e9d41a2c9416514$var$SANITIZE_CONFIG);
    }
    async function exportDocument(format) {
        const content = elements.markdownSource.value;
        if (!content.trim()) {
            showToast("\u5148\u5199\u5165\u6216\u5BFC\u5165\u5185\u5BB9\u518D\u5BFC\u51FA", 'warning');
            return;
        }
        persistDocuments();
        const title = (0, $54a362fffda0374a$export$364496161d416a8)(elements.documentTitle.value || (0, $54a362fffda0374a$export$a2a04c192c7d3572)(content));
        let printWindow = null;
        if (format === 'print') {
            printWindow = window.open('', '_blank');
            if (!printWindow) {
                showToast("\u6D4F\u89C8\u5668\u62E6\u622A\u4E86\u6253\u5370\u7A97\u53E3\uFF0C\u8BF7\u5141\u8BB8\u6B64\u9875\u6253\u5F00\u65B0\u7A97\u53E3", 'warning');
                return;
            }
            printWindow.opener = null;
        }
        try {
            if (format !== 'markdown') await ensurePreviewReady();
            if (format === 'markdown') downloadBlob(content, `${title}.md`, 'text/markdown;charset=utf-8');
            else if (format === 'text') downloadBlob(elements.previewDocument.innerText, `${title}.txt`, 'text/plain;charset=utf-8');
            else if (format === 'html') {
                const inlined = createInlinedPreviewClone();
                const fullHtml = buildStandaloneHtml(inlined.innerHTML, title, content);
                downloadBlob(fullHtml, `${title}.html`, 'text/html;charset=utf-8');
            } else if (format === 'docx') {
                showToast("\u6B63\u5728\u751F\u6210 DOCX");
                const docx = await (parcelRequire("jXyqT"));
                const documentFile = buildDocx(title, docx);
                downloadBlob(await docx.Packer.toBlob(documentFile), `${title}.docx`, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
            } else if (format === 'print') {
                printPreview(title, content, printWindow);
                return;
            }
            showToast(`${formatLabel(format)} \u{5DF2}\u{5BFC}\u{51FA}`);
        } catch (error) {
            if (printWindow && !printWindow.closed) printWindow.close();
            console.error(`${format} export failed.`, error);
            showToast(`${formatLabel(format)} \u{5BFC}\u{51FA}\u{5931}\u{8D25}\u{FF0C}\u{539F}\u{7A3F}\u{4ECD}\u{5DF2}\u{4FDD}\u{7559}`, 'error');
        }
    }
    function buildStandaloneHtml(body, title, markdownSource) {
        const includeTitle = !/^\s*#\s+/m.test(markdownSource);
        return (0, $f0987e643bba202a$export$a0a6d751ded41a34)((0, $d0d31c26942b471d$export$2e2bcd8739ae039).sanitize(body, $4e9d41a2c9416514$var$SANITIZE_CONFIG), settings.theme, title, {
            ...settings,
            includeTitle: includeTitle,
            exportedAt: new Date().toLocaleDateString('zh-CN')
        });
    }
    function printPreview(title, markdownSource, printWindow) {
        if (!printWindow || printWindow.closed) {
            showToast("\u6253\u5370\u7A97\u53E3\u5DF2\u5173\u95ED\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u6253\u5370 / \u4FDD\u5B58 PDF", 'warning');
            return;
        }
        const inlined = createInlinedPreviewClone();
        const fullHtml = buildStandaloneHtml(inlined.innerHTML, title, markdownSource);
        let printStarted = false;
        const startPrint = async ()=>{
            if (printStarted || printWindow.closed) return;
            printStarted = true;
            try {
                await printWindow.document.fonts?.ready;
                await Promise.all(Array.from(printWindow.document.images).map((image)=>{
                    if (image.complete) return Promise.resolve();
                    return new Promise((resolve)=>{
                        const timeout = window.setTimeout(resolve, 1800);
                        image.addEventListener('load', ()=>{
                            window.clearTimeout(timeout);
                            resolve();
                        }, {
                            once: true
                        });
                        image.addEventListener('error', ()=>{
                            window.clearTimeout(timeout);
                            resolve();
                        }, {
                            once: true
                        });
                    });
                }));
            } catch  {
            // Printing remains available even when a browser cannot report font or image readiness.
            }
            printWindow.focus();
            printWindow.print();
        };
        printWindow.addEventListener('load', startPrint, {
            once: true
        });
        printWindow.document.open();
        printWindow.document.write(fullHtml);
        printWindow.document.close();
        window.setTimeout(startPrint, 900);
        showToast("\u5DF2\u6253\u5F00\u6253\u5370\u9762\u677F\uFF0C\u53EF\u9009\u62E9\u4FDD\u5B58\u4E3A PDF");
    }
    function buildDocx(title, docx) {
        const { Document: Document, HeadingLevel: HeadingLevel, Paragraph: Paragraph } = docx;
        const parsed = new DOMParser().parseFromString(getSanitizedPreviewHtml(), 'text/html');
        const children = [
            new Paragraph({
                text: title,
                heading: HeadingLevel.TITLE,
                spacing: {
                    after: 320
                }
            })
        ];
        parsed.body.childNodes.forEach((node)=>children.push(...blockNodeToDocx(node, docx)));
        return new Document({
            creator: "Practical Tools Markdown \u53D1\u5E03\u5DE5\u4F5C\u5BA4",
            title: title,
            description: "\u4ECE Markdown \u5BFC\u51FA\u7684\u6587\u6863",
            sections: [
                {
                    properties: {},
                    children: children
                }
            ]
        });
    }
    function blockNodeToDocx(node, docx, context = {}) {
        const { BorderStyle: BorderStyle, HeadingLevel: HeadingLevel, Paragraph: Paragraph, Table: Table, TableCell: TableCell, TableRow: TableRow, TextRun: TextRun, WidthType: WidthType } = docx;
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            return text ? [
                new Paragraph({
                    children: [
                        new TextRun(text)
                    ]
                })
            ] : [];
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return [];
        const tag = node.tagName.toLowerCase();
        const headingMap = {
            h1: HeadingLevel.HEADING_1,
            h2: HeadingLevel.HEADING_2,
            h3: HeadingLevel.HEADING_3,
            h4: HeadingLevel.HEADING_4,
            h5: HeadingLevel.HEADING_5,
            h6: HeadingLevel.HEADING_6
        };
        if (headingMap[tag]) return [
            new Paragraph({
                children: inlineNodesToDocx(node, docx),
                heading: headingMap[tag],
                spacing: {
                    before: 240,
                    after: 120
                }
            })
        ];
        if (tag === 'p') return [
            paragraphFromNode(node, docx, context)
        ];
        if (tag === 'blockquote') return [
            paragraphFromNode(node, docx, {
                quote: true
            })
        ];
        if (tag === 'pre') return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: node.textContent || '',
                        font: 'Courier New',
                        size: 18
                    })
                ],
                spacing: {
                    before: 120,
                    after: 160
                },
                shading: {
                    fill: 'EEF2F5'
                }
            })
        ];
        if (tag === 'ul' || tag === 'ol') {
            const blocks = [];
            Array.from(node.children).forEach((item, index)=>{
                if (item.tagName.toLowerCase() !== 'li') return;
                const nestedLists = Array.from(item.children).filter((child)=>[
                        'UL',
                        'OL'
                    ].includes(child.tagName));
                const shallow = item.cloneNode(true);
                shallow.querySelectorAll(':scope > ul, :scope > ol').forEach((list)=>list.remove());
                const prefix = tag === 'ol' ? `${index + 1}. ` : '';
                blocks.push(new Paragraph({
                    children: [
                        new TextRun(prefix),
                        ...inlineNodesToDocx(shallow, docx)
                    ],
                    ...tag === 'ul' ? {
                        bullet: {
                            level: Math.min(context.listLevel || 0, 8)
                        }
                    } : {},
                    indent: tag === 'ol' ? {
                        left: 360 * ((context.listLevel || 0) + 1)
                    } : undefined,
                    spacing: {
                        before: 40,
                        after: 40
                    }
                }));
                nestedLists.forEach((list)=>blocks.push(...blockNodeToDocx(list, docx, {
                        listLevel: (context.listLevel || 0) + 1
                    })));
            });
            return blocks;
        }
        if (tag === 'table') {
            const rows = Array.from(node.querySelectorAll(':scope > thead > tr, :scope > tbody > tr, :scope > tr'));
            if (!rows.length) return [];
            return [
                new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE
                    },
                    rows: rows.map((row)=>new TableRow({
                            children: Array.from(row.children).map((cell)=>new TableCell({
                                    children: [
                                        new Paragraph({
                                            children: inlineNodesToDocx(cell, docx, {
                                                bold: cell.tagName.toLowerCase() === 'th'
                                            }),
                                            spacing: {
                                                before: 60,
                                                after: 60
                                            }
                                        })
                                    ]
                                }))
                        }))
                })
            ];
        }
        if (tag === 'hr') return [
            new Paragraph({
                border: {
                    bottom: {
                        style: BorderStyle.SINGLE,
                        size: 6,
                        color: 'CBD5E1'
                    }
                },
                spacing: {
                    before: 180,
                    after: 180
                }
            })
        ];
        if (tag === 'img') return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: `[\u{56FE}\u{7247}\u{FF1A}${node.getAttribute('alt') || "\u672A\u547D\u540D\u56FE\u7247"}]`,
                        italics: true,
                        color: '64748B'
                    })
                ]
            })
        ];
        if (tag === 'div' && node.classList.contains('studio-diagram')) return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: "[Mermaid \u56FE\u8868\uFF0C\u8BF7\u5728 HTML \u6216 PDF \u5BFC\u51FA\u4E2D\u67E5\u770B]",
                        italics: true,
                        color: '64748B'
                    })
                ]
            })
        ];
        return Array.from(node.childNodes).flatMap((child)=>blockNodeToDocx(child, docx, context));
    }
    function paragraphFromNode(node, docx, context = {}) {
        const { BorderStyle: BorderStyle, Paragraph: Paragraph } = docx;
        const options = {
            children: inlineNodesToDocx(node, docx),
            spacing: {
                before: 80,
                after: 100,
                line: 360
            }
        };
        if (context.quote) {
            options.border = {
                left: {
                    style: BorderStyle.SINGLE,
                    size: 16,
                    color: settings.accent.replace('#', '').toUpperCase()
                }
            };
            options.indent = {
                left: 360
            };
        }
        return new Paragraph(options);
    }
    function inlineNodesToDocx(root, docx, inherited = {}) {
        const { ExternalHyperlink: ExternalHyperlink, TextRun: TextRun } = docx;
        const runs = [];
        root.childNodes.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) {
                if (node.textContent) runs.push(new TextRun({
                    text: node.textContent,
                    ...inherited
                }));
                return;
            }
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            const tag = node.tagName.toLowerCase();
            if (tag === 'br') {
                runs.push(new TextRun({
                    break: 1
                }));
                return;
            }
            if (tag === 'a' && (0, $54a362fffda0374a$export$f0a7a72d6a038c2e)(node.getAttribute('href') || '') && /^https?:/i.test(node.getAttribute('href'))) {
                runs.push(new ExternalHyperlink({
                    link: node.getAttribute('href'),
                    children: [
                        new TextRun({
                            text: node.textContent || node.getAttribute('href'),
                            color: '0E7490',
                            underline: {}
                        })
                    ]
                }));
                return;
            }
            if (tag === 'img') {
                runs.push(new TextRun({
                    text: `[\u{56FE}\u{7247}\u{FF1A}${node.getAttribute('alt') || "\u672A\u547D\u540D\u56FE\u7247"}]`,
                    italics: true
                }));
                return;
            }
            const next = {
                ...inherited,
                ...tag === 'strong' || tag === 'b' ? {
                    bold: true
                } : {},
                ...tag === 'em' || tag === 'i' ? {
                    italics: true
                } : {},
                ...tag === 'del' || tag === 's' ? {
                    strike: true
                } : {},
                ...tag === 'code' ? {
                    font: 'Courier New',
                    size: 18,
                    color: '0E7490'
                } : {}
            };
            runs.push(...inlineNodesToDocx(node, docx, next));
        });
        return runs.length ? runs : [
            new TextRun('')
        ];
    }
    function downloadBlob(content, filename, mime) {
        const blob = content instanceof Blob ? content : new Blob([
            content
        ], {
            type: mime
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.hidden = true;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(()=>URL.revokeObjectURL(url), 1000);
    }
    function showToast(message, tone = 'info') {
        window.clearTimeout(toastTimer);
        const toast = document.createElement('div');
        toast.className = 'studio-toast';
        toast.dataset.tone = tone;
        toast.setAttribute('role', tone === 'error' ? 'alert' : 'status');
        toast.textContent = message;
        elements.toastRegion.replaceChildren(toast);
        toastTimer = window.setTimeout(()=>toast.remove(), 3600);
    }
    function formatTime(timestamp) {
        return new Intl.DateTimeFormat('zh-CN', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(timestamp);
    }
    function formatRelativeDate(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        if (date.toDateString() === now.toDateString()) return formatTime(timestamp);
        return new Intl.DateTimeFormat('zh-CN', {
            month: 'numeric',
            day: 'numeric'
        }).format(date);
    }
    function formatBytes(bytes) {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1048576) return `${Math.round(bytes / 1024)} KB`;
        return `${(bytes / 1048576).toFixed(1)} MB`;
    }
    function formatLabel(format) {
        return ({
            markdown: 'Markdown',
            html: 'HTML',
            text: 'TXT',
            docx: 'DOCX'
        })[format] || format.toUpperCase();
    }
    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
}


//# sourceMappingURL=md-html.46779f79.js.map
